/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type AdminResetUserPasswordAPIInput = {
  username: string,
};

export type AdminDisableUserAPIInput = {
  username: string,
  type?: DisableUserType | null,
};

export enum DisableUserType {
  ENABLE = "ENABLE",
  DISABLE = "DISABLE",
}


export type CreatePollCommentInput = {
  id?: string | null,
  pollID: string,
  userID: string,
  content: string,
  avatar?: string | null,
  name?: string | null,
};

export type ModelPollCommentConditionInput = {
  pollID?: ModelIDInput | null,
  userID?: ModelIDInput | null,
  content?: ModelStringInput | null,
  avatar?: ModelStringInput | null,
  name?: ModelStringInput | null,
  and?: Array< ModelPollCommentConditionInput | null > | null,
  or?: Array< ModelPollCommentConditionInput | null > | null,
  not?: ModelPollCommentConditionInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type PollComment = {
  __typename: "PollComment",
  id: string,
  pollID: string,
  userID: string,
  content: string,
  avatar?: string | null,
  name?: string | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdatePollCommentInput = {
  id: string,
  pollID?: string | null,
  userID?: string | null,
  content?: string | null,
  avatar?: string | null,
  name?: string | null,
};

export type DeletePollCommentInput = {
  id: string,
};

export type CreatePollInput = {
  id?: string | null,
  title: string,
  question: string,
  description?: string | null,
  image?: S3ObjectInput | null,
  theme?: S3ObjectInput | null,
  background?: S3ObjectInput | null,
  logo?: S3ObjectInput | null,
  video?: string | null,
  status?: PollStatus | null,
  options?: Array< PollOptionInput > | null,
  drawOptions?: Array< PollOptionInput > | null,
  hasPledge?: boolean | null,
  isGroup?: boolean | null,
  featured?: boolean | null,
  winOption?: PollOptionInput | null,
  startTime: string,
  endTime: string,
  pledgePeriod1StartTime?: string | null,
  pledgePeriod1EndTime?: string | null,
  pledgePeriod2StartTime?: string | null,
  pledgePeriod2EndTime?: string | null,
  owner?: string | null,
  password?: string | null,
  grc?: string | null,
  division?: string | null,
  createdAt?: string | null,
  private?: number | null,
  companyID?: string | null,
  themeID?: string | null,
  representativeID?: string | null,
  isPremium?: boolean | null,
  maxVote?: number | null,
  isNotExact?: boolean | null,
  category?: string | null,
  hashtag?: Array< string | null > | null,
};

export type S3ObjectInput = {
  bucket: string,
  region: string,
  key: string,
};

export enum PollStatus {
  CREATED = "CREATED",
  SWING = "SWING",
  PLEDGING1 = "PLEDGING1",
  PLEDGING2 = "PLEDGING2",
  END = "END",
  CLOSED = "CLOSED",
}


export type PollOptionInput = {
  id: string,
  title?: string | null,
  description?: string | null,
  detail?: DetailInput | null,
};

export type DetailInput = {
  image?: S3ObjectInput | null,
  video?: string | null,
  price?: string | null,
  currency?: Currency | null,
};

export enum Currency {
  SGD = "SGD",
  USD = "USD",
}


export type ModelPollConditionInput = {
  title?: ModelStringInput | null,
  question?: ModelStringInput | null,
  description?: ModelStringInput | null,
  video?: ModelStringInput | null,
  status?: ModelPollStatusInput | null,
  hasPledge?: ModelBooleanInput | null,
  isGroup?: ModelBooleanInput | null,
  featured?: ModelBooleanInput | null,
  startTime?: ModelStringInput | null,
  endTime?: ModelStringInput | null,
  pledgePeriod1StartTime?: ModelStringInput | null,
  pledgePeriod1EndTime?: ModelStringInput | null,
  pledgePeriod2StartTime?: ModelStringInput | null,
  pledgePeriod2EndTime?: ModelStringInput | null,
  password?: ModelStringInput | null,
  grc?: ModelStringInput | null,
  division?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  private?: ModelIntInput | null,
  companyID?: ModelIDInput | null,
  themeID?: ModelIDInput | null,
  representativeID?: ModelIDInput | null,
  isPremium?: ModelBooleanInput | null,
  maxVote?: ModelIntInput | null,
  isNotExact?: ModelBooleanInput | null,
  category?: ModelStringInput | null,
  hashtag?: ModelStringInput | null,
  and?: Array< ModelPollConditionInput | null > | null,
  or?: Array< ModelPollConditionInput | null > | null,
  not?: ModelPollConditionInput | null,
};

export type ModelPollStatusInput = {
  eq?: PollStatus | null,
  ne?: PollStatus | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type Poll = {
  __typename: "Poll",
  id: string,
  title: string,
  question: string,
  description?: string | null,
  image?: S3Object | null,
  theme?: S3Object | null,
  background?: S3Object | null,
  logo?: S3Object | null,
  video?: string | null,
  status?: PollStatus | null,
  options?:  Array<PollOption > | null,
  drawOptions?:  Array<PollOption > | null,
  hasPledge?: boolean | null,
  isGroup?: boolean | null,
  featured?: boolean | null,
  winOption?: PollOption | null,
  startTime: string,
  endTime: string,
  pledgePeriod1StartTime?: string | null,
  pledgePeriod1EndTime?: string | null,
  pledgePeriod2StartTime?: string | null,
  pledgePeriod2EndTime?: string | null,
  owner?: string | null,
  password?: string | null,
  grc?: string | null,
  division?: string | null,
  createdAt: string,
  private?: number | null,
  companyID?: string | null,
  themeID?: string | null,
  representativeID?: string | null,
  isPremium?: boolean | null,
  maxVote?: number | null,
  isNotExact?: boolean | null,
  category?: string | null,
  hashtag?: Array< string | null > | null,
  updatedAt: string,
  comments?: ModelPollCommentConnection | null,
  votes?: ModelVoteConnection | null,
  voteResults?: ModelVoteResultConnection | null,
  companyTheme?: CompanyTheme | null,
  company?: Company | null,
  postalsGRC?: ModelPostalInfoConnection | null,
  postalsDivision?: ModelPostalInfoConnection | null,
};

export type S3Object = {
  __typename: "S3Object",
  bucket: string,
  region: string,
  key: string,
};

export type PollOption = {
  __typename: "PollOption",
  id: string,
  title?: string | null,
  description?: string | null,
  detail?: Detail | null,
};

export type Detail = {
  __typename: "Detail",
  image?: S3Object | null,
  video?: string | null,
  price?: string | null,
  currency?: Currency | null,
};

export type ModelPollCommentConnection = {
  __typename: "ModelPollCommentConnection",
  items:  Array<PollComment | null >,
  nextToken?: string | null,
};

export type ModelVoteConnection = {
  __typename: "ModelVoteConnection",
  items:  Array<Vote | null >,
  nextToken?: string | null,
};

export type Vote = {
  __typename: "Vote",
  id: string,
  userID: string,
  option: PollOption,
  type: VoteType,
  subPollID?: string | null,
  reason?: string | null,
  pollID: string,
  proxyUserID?: string | null,
  createdAt: string,
  updatedAt: string,
  poll?: Poll | null,
  user?: User | null,
};

export enum VoteType {
  VOTE = "VOTE",
  WITHDRAW = "WITHDRAW",
}


export type User = {
  __typename: "User",
  id: string,
  email?: string | null,
  username?: string | null,
  owner?: string | null,
  phone?: string | null,
  type?: UserType | null,
  disable?: boolean | null,
  firstName?: string | null,
  lastName?: string | null,
  yearOfBirth?: number | null,
  gender?: string | null,
  education?: string | null,
  postalCode?: string | null,
  salaryRange?: UserSalaryRange | null,
  image?: S3Object | null,
  company?: string | null,
  createdAt: string,
  organisation?: OrganisationInfo | null,
  isSetup?: boolean | null,
  tier?: Tier | null,
  proxyUserID?: string | null,
  premiumPolls?: number | null,
  usedPremiumPolls?: number | null,
  cryptowallet?: string | null,
  updatedAt: string,
  postalInfo?: PostalInfo | null,
};

export enum UserType {
  INDIVIDUAL = "INDIVIDUAL",
  PAID = "PAID",
  COMPANY = "COMPANY",
  ADMINISTRATOR = "ADMINISTRATOR",
  REPRESENTATIVE = "REPRESENTATIVE",
  PROXY = "PROXY",
  STAFF = "STAFF",
  SUPER_STAFF = "SUPER_STAFF",
}


export enum UserSalaryRange {
  _1 = "_1",
  _2 = "_2",
  _3 = "_3",
  _4 = "_4",
  _5 = "_5",
  _6 = "_6",
}


export type OrganisationInfo = {
  __typename: "OrganisationInfo",
  name?: string | null,
  department?: string | null,
  jobTitle?: string | null,
};

export enum Tier {
  FREE = "FREE",
  PREMIUM = "PREMIUM",
  ENTERPRISE = "ENTERPRISE",
  CONSULTATIVE = "CONSULTATIVE",
}


export type PostalInfo = {
  __typename: "PostalInfo",
  postal: string,
  grc?: string | null,
  division?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelVoteResultConnection = {
  __typename: "ModelVoteResultConnection",
  items:  Array<VoteResult | null >,
  nextToken?: string | null,
};

export type VoteResult = {
  __typename: "VoteResult",
  id: string,
  option: PollOption,
  count: number,
  subPollID?: string | null,
  pollID: string,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type CompanyTheme = {
  __typename: "CompanyTheme",
  id: string,
  companyID: string,
  attributes?: CustomThemeAttribute | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type CustomThemeAttribute = {
  __typename: "CustomThemeAttribute",
  pollActivePeriodBgColor?: string | null,
  pollActivePeriodShadowColor?: string | null,
  pollQuestionCardBgColor?: string | null,
  pollQuestionCardQuestionColor?: string | null,
  pollQuestionCardAnswerColor?: string | null,
  pollPledgeCastBtnBgColor?: string | null,
  pollPledgeCastBtnBracketColor?: string | null,
  pollPledgeCastBtnTextColor?: string | null,
  pollPageBgColor?: string | null,
};

export type Company = {
  __typename: "Company",
  id: string,
  name: string,
  domain: string,
  owner?: string | null,
  status?: CompanyStatus | null,
  createdAt: string,
  updatedAt: string,
};

export enum CompanyStatus {
  ACTIVATED = "ACTIVATED",
  DEACTIVATED = "DEACTIVATED",
}


export type ModelPostalInfoConnection = {
  __typename: "ModelPostalInfoConnection",
  items:  Array<PostalInfo | null >,
  nextToken?: string | null,
};

export type UpdatePollInput = {
  id: string,
  title?: string | null,
  question?: string | null,
  description?: string | null,
  image?: S3ObjectInput | null,
  theme?: S3ObjectInput | null,
  background?: S3ObjectInput | null,
  logo?: S3ObjectInput | null,
  video?: string | null,
  status?: PollStatus | null,
  options?: Array< PollOptionInput > | null,
  drawOptions?: Array< PollOptionInput > | null,
  hasPledge?: boolean | null,
  isGroup?: boolean | null,
  featured?: boolean | null,
  winOption?: PollOptionInput | null,
  startTime?: string | null,
  endTime?: string | null,
  pledgePeriod1StartTime?: string | null,
  pledgePeriod1EndTime?: string | null,
  pledgePeriod2StartTime?: string | null,
  pledgePeriod2EndTime?: string | null,
  owner?: string | null,
  password?: string | null,
  grc?: string | null,
  division?: string | null,
  createdAt?: string | null,
  private?: number | null,
  companyID?: string | null,
  themeID?: string | null,
  representativeID?: string | null,
  isPremium?: boolean | null,
  maxVote?: number | null,
  isNotExact?: boolean | null,
  category?: string | null,
  hashtag?: Array< string | null > | null,
};

export type DeletePollInput = {
  id: string,
};

export type CreateSubPollInput = {
  id?: string | null,
  pollID?: string | null,
  title?: string | null,
  question: string,
  description?: string | null,
  image?: S3ObjectInput | null,
  video?: string | null,
  status?: PollStatus | null,
  options?: Array< PollOptionInput > | null,
  winOption?: PollOptionInput | null,
  owner?: string | null,
  createdAt?: string | null,
  orderID: number,
  private: number,
  maxVote?: number | null,
  isNotExact?: boolean | null,
};

export type ModelSubPollConditionInput = {
  pollID?: ModelStringInput | null,
  title?: ModelStringInput | null,
  question?: ModelStringInput | null,
  description?: ModelStringInput | null,
  video?: ModelStringInput | null,
  status?: ModelPollStatusInput | null,
  createdAt?: ModelStringInput | null,
  orderID?: ModelIntInput | null,
  private?: ModelIntInput | null,
  maxVote?: ModelIntInput | null,
  isNotExact?: ModelBooleanInput | null,
  and?: Array< ModelSubPollConditionInput | null > | null,
  or?: Array< ModelSubPollConditionInput | null > | null,
  not?: ModelSubPollConditionInput | null,
};

export type SubPoll = {
  __typename: "SubPoll",
  id: string,
  pollID?: string | null,
  title?: string | null,
  question: string,
  description?: string | null,
  image?: S3Object | null,
  video?: string | null,
  status?: PollStatus | null,
  options?:  Array<PollOption > | null,
  winOption?: PollOption | null,
  owner?: string | null,
  createdAt: string,
  orderID: number,
  private: number,
  maxVote?: number | null,
  isNotExact?: boolean | null,
  updatedAt: string,
  votes?: ModelVoteConnection | null,
  voteResults?: ModelVoteResultConnection | null,
};

export type UpdateSubPollInput = {
  id: string,
  pollID?: string | null,
  title?: string | null,
  question?: string | null,
  description?: string | null,
  image?: S3ObjectInput | null,
  video?: string | null,
  status?: PollStatus | null,
  options?: Array< PollOptionInput > | null,
  winOption?: PollOptionInput | null,
  owner?: string | null,
  createdAt?: string | null,
  orderID?: number | null,
  private?: number | null,
  maxVote?: number | null,
  isNotExact?: boolean | null,
};

export type DeleteSubPollInput = {
  id: string,
};

export type CreateVoteInput = {
  id?: string | null,
  userID: string,
  option: PollOptionInput,
  type: VoteType,
  subPollID?: string | null,
  reason?: string | null,
  pollID: string,
  proxyUserID?: string | null,
};

export type ModelVoteConditionInput = {
  userID?: ModelIDInput | null,
  type?: ModelVoteTypeInput | null,
  subPollID?: ModelIDInput | null,
  reason?: ModelStringInput | null,
  pollID?: ModelIDInput | null,
  proxyUserID?: ModelIDInput | null,
  and?: Array< ModelVoteConditionInput | null > | null,
  or?: Array< ModelVoteConditionInput | null > | null,
  not?: ModelVoteConditionInput | null,
};

export type ModelVoteTypeInput = {
  eq?: VoteType | null,
  ne?: VoteType | null,
};

export type UpdateVoteInput = {
  id: string,
  userID?: string | null,
  option?: PollOptionInput | null,
  type?: VoteType | null,
  subPollID?: string | null,
  reason?: string | null,
  pollID?: string | null,
  proxyUserID?: string | null,
};

export type DeleteVoteInput = {
  id: string,
};

export type CreateHotPollInput = {
  id?: string | null,
  pollID: string,
  count: number,
  status: HotPollStatus,
  hotPollPollId?: string | null,
};

export enum HotPollStatus {
  VISIBLE = "VISIBLE",
  HIDDEN = "HIDDEN",
}


export type ModelHotPollConditionInput = {
  pollID?: ModelIDInput | null,
  count?: ModelIntInput | null,
  status?: ModelHotPollStatusInput | null,
  and?: Array< ModelHotPollConditionInput | null > | null,
  or?: Array< ModelHotPollConditionInput | null > | null,
  not?: ModelHotPollConditionInput | null,
};

export type ModelHotPollStatusInput = {
  eq?: HotPollStatus | null,
  ne?: HotPollStatus | null,
};

export type HotPoll = {
  __typename: "HotPoll",
  id: string,
  pollID: string,
  count: number,
  status: HotPollStatus,
  createdAt: string,
  updatedAt: string,
  poll?: Poll | null,
};

export type UpdateHotPollInput = {
  id: string,
  pollID?: string | null,
  count?: number | null,
  status?: HotPollStatus | null,
  hotPollPollId?: string | null,
};

export type DeleteHotPollInput = {
  id: string,
};

export type CreateHotPledgeInput = {
  id?: string | null,
  pollID: string,
  count: number,
  status: HotPollStatus,
};

export type ModelHotPledgeConditionInput = {
  pollID?: ModelIDInput | null,
  count?: ModelIntInput | null,
  status?: ModelHotPollStatusInput | null,
  and?: Array< ModelHotPledgeConditionInput | null > | null,
  or?: Array< ModelHotPledgeConditionInput | null > | null,
  not?: ModelHotPledgeConditionInput | null,
};

export type HotPledge = {
  __typename: "HotPledge",
  id: string,
  pollID: string,
  count: number,
  status: HotPollStatus,
  createdAt: string,
  updatedAt: string,
  poll?: Poll | null,
};

export type UpdateHotPledgeInput = {
  id: string,
  pollID?: string | null,
  count?: number | null,
  status?: HotPollStatus | null,
};

export type DeleteHotPledgeInput = {
  id: string,
};

export type CreateVoteResultInput = {
  id?: string | null,
  option: PollOptionInput,
  count: number,
  subPollID?: string | null,
  pollID: string,
};

export type ModelVoteResultConditionInput = {
  count?: ModelIntInput | null,
  subPollID?: ModelIDInput | null,
  pollID?: ModelIDInput | null,
  and?: Array< ModelVoteResultConditionInput | null > | null,
  or?: Array< ModelVoteResultConditionInput | null > | null,
  not?: ModelVoteResultConditionInput | null,
};

export type UpdateVoteResultInput = {
  id: string,
  option?: PollOptionInput | null,
  count?: number | null,
  subPollID?: string | null,
  pollID?: string | null,
};

export type DeleteVoteResultInput = {
  id: string,
};

export type CreatePledgeInput = {
  id?: string | null,
  userID: string,
  type: PledgeType,
  pollID: string,
  reason?: string | null,
  createdAt?: string | null,
};

export enum PledgeType {
  PLEDGE = "PLEDGE",
  WITHDRAW = "WITHDRAW",
}


export type ModelPledgeConditionInput = {
  userID?: ModelIDInput | null,
  type?: ModelPledgeTypeInput | null,
  pollID?: ModelIDInput | null,
  reason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelPledgeConditionInput | null > | null,
  or?: Array< ModelPledgeConditionInput | null > | null,
  not?: ModelPledgeConditionInput | null,
};

export type ModelPledgeTypeInput = {
  eq?: PledgeType | null,
  ne?: PledgeType | null,
};

export type Pledge = {
  __typename: "Pledge",
  id: string,
  userID: string,
  type: PledgeType,
  pollID: string,
  reason?: string | null,
  createdAt: string,
  updatedAt: string,
  poll?: Poll | null,
  user?: User | null,
};

export type UpdatePledgeInput = {
  id: string,
  userID?: string | null,
  type?: PledgeType | null,
  pollID?: string | null,
  reason?: string | null,
  createdAt?: string | null,
};

export type DeletePledgeInput = {
  id: string,
};

export type CreatePledgeResultInput = {
  id?: string | null,
  option: PollOptionInput,
  count: number,
  pollID: string,
};

export type ModelPledgeResultConditionInput = {
  count?: ModelIntInput | null,
  pollID?: ModelStringInput | null,
  and?: Array< ModelPledgeResultConditionInput | null > | null,
  or?: Array< ModelPledgeResultConditionInput | null > | null,
  not?: ModelPledgeResultConditionInput | null,
};

export type PledgeResult = {
  __typename: "PledgeResult",
  id: string,
  option: PollOption,
  count: number,
  pollID: string,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdatePledgeResultInput = {
  id: string,
  option?: PollOptionInput | null,
  count?: number | null,
  pollID?: string | null,
};

export type DeletePledgeResultInput = {
  id: string,
};

export type CreatePollReportInput = {
  id?: string | null,
  title: string,
  description: string,
  pollID: string,
  owner?: string | null,
  createdAt?: string | null,
};

export type ModelPollReportConditionInput = {
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  pollID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelPollReportConditionInput | null > | null,
  or?: Array< ModelPollReportConditionInput | null > | null,
  not?: ModelPollReportConditionInput | null,
};

export type PollReport = {
  __typename: "PollReport",
  id: string,
  title: string,
  description: string,
  pollID: string,
  owner?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdatePollReportInput = {
  id: string,
  title?: string | null,
  description?: string | null,
  pollID?: string | null,
  owner?: string | null,
  createdAt?: string | null,
};

export type DeletePollReportInput = {
  id: string,
};

export type CreatePackageSubscriptionInput = {
  id?: string | null,
  tier: Tier,
  price?: string | null,
  stripePriceID?: string | null,
  pollOptionLimit?: number | null,
  groupPollAllowed?: boolean | null,
  groupPollLimit?: number | null,
  pledgeAllowed?: boolean | null,
  pledgeChargePercentage?: string | null,
  pollDurationLimit?: string | null,
  pollResultLiveAllowed?: boolean | null,
  statisticReportAllowed?: boolean | null,
  withdrawalAllowed?: boolean | null,
  extensionPledgeAllowed?: boolean | null,
  noOfPolls?: number | null,
};

export type ModelPackageSubscriptionConditionInput = {
  tier?: ModelTierInput | null,
  price?: ModelStringInput | null,
  stripePriceID?: ModelStringInput | null,
  pollOptionLimit?: ModelIntInput | null,
  groupPollAllowed?: ModelBooleanInput | null,
  groupPollLimit?: ModelIntInput | null,
  pledgeAllowed?: ModelBooleanInput | null,
  pledgeChargePercentage?: ModelStringInput | null,
  pollDurationLimit?: ModelStringInput | null,
  pollResultLiveAllowed?: ModelBooleanInput | null,
  statisticReportAllowed?: ModelBooleanInput | null,
  withdrawalAllowed?: ModelBooleanInput | null,
  extensionPledgeAllowed?: ModelBooleanInput | null,
  noOfPolls?: ModelIntInput | null,
  and?: Array< ModelPackageSubscriptionConditionInput | null > | null,
  or?: Array< ModelPackageSubscriptionConditionInput | null > | null,
  not?: ModelPackageSubscriptionConditionInput | null,
};

export type ModelTierInput = {
  eq?: Tier | null,
  ne?: Tier | null,
};

export type PackageSubscription = {
  __typename: "PackageSubscription",
  id: string,
  tier: Tier,
  price?: string | null,
  stripePriceID?: string | null,
  pollOptionLimit?: number | null,
  groupPollAllowed?: boolean | null,
  groupPollLimit?: number | null,
  pledgeAllowed?: boolean | null,
  pledgeChargePercentage?: string | null,
  pollDurationLimit?: string | null,
  pollResultLiveAllowed?: boolean | null,
  statisticReportAllowed?: boolean | null,
  withdrawalAllowed?: boolean | null,
  extensionPledgeAllowed?: boolean | null,
  noOfPolls?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdatePackageSubscriptionInput = {
  id: string,
  tier?: Tier | null,
  price?: string | null,
  stripePriceID?: string | null,
  pollOptionLimit?: number | null,
  groupPollAllowed?: boolean | null,
  groupPollLimit?: number | null,
  pledgeAllowed?: boolean | null,
  pledgeChargePercentage?: string | null,
  pollDurationLimit?: string | null,
  pollResultLiveAllowed?: boolean | null,
  statisticReportAllowed?: boolean | null,
  withdrawalAllowed?: boolean | null,
  extensionPledgeAllowed?: boolean | null,
  noOfPolls?: number | null,
};

export type DeletePackageSubscriptionInput = {
  id: string,
};

export type CreateUserInput = {
  id?: string | null,
  email?: string | null,
  username?: string | null,
  owner?: string | null,
  phone?: string | null,
  type?: UserType | null,
  disable?: boolean | null,
  firstName?: string | null,
  lastName?: string | null,
  yearOfBirth?: number | null,
  gender?: string | null,
  education?: string | null,
  postalCode?: string | null,
  salaryRange?: UserSalaryRange | null,
  image?: S3ObjectInput | null,
  company?: string | null,
  createdAt?: string | null,
  organisation?: OrganisationInfoInput | null,
  isSetup?: boolean | null,
  tier?: Tier | null,
  proxyUserID?: string | null,
  premiumPolls?: number | null,
  usedPremiumPolls?: number | null,
  cryptowallet?: string | null,
};

export type OrganisationInfoInput = {
  name?: string | null,
  department?: string | null,
  jobTitle?: string | null,
};

export type ModelUserConditionInput = {
  email?: ModelStringInput | null,
  username?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  type?: ModelUserTypeInput | null,
  disable?: ModelBooleanInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  yearOfBirth?: ModelIntInput | null,
  gender?: ModelStringInput | null,
  education?: ModelStringInput | null,
  postalCode?: ModelIDInput | null,
  salaryRange?: ModelUserSalaryRangeInput | null,
  company?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  isSetup?: ModelBooleanInput | null,
  tier?: ModelTierInput | null,
  proxyUserID?: ModelIDInput | null,
  premiumPolls?: ModelIntInput | null,
  usedPremiumPolls?: ModelIntInput | null,
  cryptowallet?: ModelStringInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
};

export type ModelUserTypeInput = {
  eq?: UserType | null,
  ne?: UserType | null,
};

export type ModelUserSalaryRangeInput = {
  eq?: UserSalaryRange | null,
  ne?: UserSalaryRange | null,
};

export type UpdateUserInput = {
  id: string,
  email?: string | null,
  username?: string | null,
  owner?: string | null,
  phone?: string | null,
  type?: UserType | null,
  disable?: boolean | null,
  firstName?: string | null,
  lastName?: string | null,
  yearOfBirth?: number | null,
  gender?: string | null,
  education?: string | null,
  postalCode?: string | null,
  salaryRange?: UserSalaryRange | null,
  image?: S3ObjectInput | null,
  company?: string | null,
  createdAt?: string | null,
  organisation?: OrganisationInfoInput | null,
  isSetup?: boolean | null,
  tier?: Tier | null,
  proxyUserID?: string | null,
  premiumPolls?: number | null,
  usedPremiumPolls?: number | null,
  cryptowallet?: string | null,
};

export type DeleteUserInput = {
  id: string,
};

export type CreateCompanyUserInput = {
  id?: string | null,
  userID: string,
  username: string,
  companyID: string,
  adminID: string,
  role: CompanyRole,
  owner?: string | null,
};

export enum CompanyRole {
  ADMIN = "ADMIN",
  REPRESENTATIVE = "REPRESENTATIVE",
  PROXY = "PROXY",
  EMPLOYEE = "EMPLOYEE",
}


export type ModelCompanyUserConditionInput = {
  userID?: ModelIDInput | null,
  username?: ModelStringInput | null,
  companyID?: ModelIDInput | null,
  adminID?: ModelIDInput | null,
  role?: ModelCompanyRoleInput | null,
  and?: Array< ModelCompanyUserConditionInput | null > | null,
  or?: Array< ModelCompanyUserConditionInput | null > | null,
  not?: ModelCompanyUserConditionInput | null,
};

export type ModelCompanyRoleInput = {
  eq?: CompanyRole | null,
  ne?: CompanyRole | null,
};

export type CompanyUser = {
  __typename: "CompanyUser",
  id: string,
  userID: string,
  username: string,
  companyID: string,
  adminID: string,
  role: CompanyRole,
  owner?: string | null,
  createdAt: string,
  updatedAt: string,
  user?: User | null,
};

export type UpdateCompanyUserInput = {
  id: string,
  userID?: string | null,
  username?: string | null,
  companyID?: string | null,
  adminID?: string | null,
  role?: CompanyRole | null,
  owner?: string | null,
};

export type DeleteCompanyUserInput = {
  id: string,
};

export type CreateCompanyThemeInput = {
  id?: string | null,
  companyID: string,
  attributes?: CustomThemeAttributeInput | null,
};

export type CustomThemeAttributeInput = {
  pollActivePeriodBgColor?: string | null,
  pollActivePeriodShadowColor?: string | null,
  pollQuestionCardBgColor?: string | null,
  pollQuestionCardQuestionColor?: string | null,
  pollQuestionCardAnswerColor?: string | null,
  pollPledgeCastBtnBgColor?: string | null,
  pollPledgeCastBtnBracketColor?: string | null,
  pollPledgeCastBtnTextColor?: string | null,
  pollPageBgColor?: string | null,
};

export type ModelCompanyThemeConditionInput = {
  companyID?: ModelIDInput | null,
  and?: Array< ModelCompanyThemeConditionInput | null > | null,
  or?: Array< ModelCompanyThemeConditionInput | null > | null,
  not?: ModelCompanyThemeConditionInput | null,
};

export type UpdateCompanyThemeInput = {
  id: string,
  companyID?: string | null,
  attributes?: CustomThemeAttributeInput | null,
};

export type DeleteCompanyThemeInput = {
  id: string,
};

export type CreateCompanyInput = {
  id?: string | null,
  name: string,
  domain: string,
  owner?: string | null,
  status?: CompanyStatus | null,
  createdAt?: string | null,
};

export type ModelCompanyConditionInput = {
  name?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  status?: ModelCompanyStatusInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelCompanyConditionInput | null > | null,
  or?: Array< ModelCompanyConditionInput | null > | null,
  not?: ModelCompanyConditionInput | null,
};

export type ModelCompanyStatusInput = {
  eq?: CompanyStatus | null,
  ne?: CompanyStatus | null,
};

export type UpdateCompanyInput = {
  id: string,
  name?: string | null,
  domain?: string | null,
  owner?: string | null,
  status?: CompanyStatus | null,
  createdAt?: string | null,
};

export type DeleteCompanyInput = {
  id: string,
};

export type CreateCompanyDomainInput = {
  id?: string | null,
  companyID: string,
  domain: string,
  createdAt?: string | null,
};

export type ModelCompanyDomainConditionInput = {
  companyID?: ModelIDInput | null,
  domain?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelCompanyDomainConditionInput | null > | null,
  or?: Array< ModelCompanyDomainConditionInput | null > | null,
  not?: ModelCompanyDomainConditionInput | null,
};

export type CompanyDomain = {
  __typename: "CompanyDomain",
  id: string,
  companyID: string,
  domain: string,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateCompanyDomainInput = {
  id: string,
  companyID?: string | null,
  domain?: string | null,
  createdAt?: string | null,
};

export type DeleteCompanyDomainInput = {
  id: string,
};

export type CreateRequestJoinCompanyInput = {
  id?: string | null,
  userID: string,
  companyID: string,
  status: RequestJoinCompanyStatus,
  createdAt?: string | null,
};

export enum RequestJoinCompanyStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}


export type ModelRequestJoinCompanyConditionInput = {
  userID?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  status?: ModelRequestJoinCompanyStatusInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelRequestJoinCompanyConditionInput | null > | null,
  or?: Array< ModelRequestJoinCompanyConditionInput | null > | null,
  not?: ModelRequestJoinCompanyConditionInput | null,
};

export type ModelRequestJoinCompanyStatusInput = {
  eq?: RequestJoinCompanyStatus | null,
  ne?: RequestJoinCompanyStatus | null,
};

export type RequestJoinCompany = {
  __typename: "RequestJoinCompany",
  id: string,
  userID: string,
  companyID: string,
  status: RequestJoinCompanyStatus,
  createdAt: string,
  updatedAt: string,
  user?: User | null,
};

export type UpdateRequestJoinCompanyInput = {
  id: string,
  userID?: string | null,
  companyID?: string | null,
  status?: RequestJoinCompanyStatus | null,
  createdAt?: string | null,
};

export type DeleteRequestJoinCompanyInput = {
  id: string,
};

export type CreateAlertInput = {
  id?: string | null,
  title?: string | null,
  detail?: string | null,
  pollID?: string | null,
  message?: string | null,
  type: AlertType,
  createdAt?: string | null,
  userID: string,
};

export enum AlertType {
  POLL_RESET = "POLL_RESET",
  POLL_END = "POLL_END",
  POLL_VOTE_CLOSED = "POLL_VOTE_CLOSED",
  POLL_PLEDGING_CLOSED = "POLL_PLEDGING_CLOSED",
  POLL_PLEDGING1 = "POLL_PLEDGING1",
  POLL_PLEDGING2 = "POLL_PLEDGING2",
  POPUP = "POPUP",
  PROMOTION = "PROMOTION",
  EVENT = "EVENT",
}


export type ModelAlertConditionInput = {
  title?: ModelStringInput | null,
  detail?: ModelStringInput | null,
  pollID?: ModelIDInput | null,
  message?: ModelStringInput | null,
  type?: ModelAlertTypeInput | null,
  createdAt?: ModelStringInput | null,
  userID?: ModelIDInput | null,
  and?: Array< ModelAlertConditionInput | null > | null,
  or?: Array< ModelAlertConditionInput | null > | null,
  not?: ModelAlertConditionInput | null,
};

export type ModelAlertTypeInput = {
  eq?: AlertType | null,
  ne?: AlertType | null,
};

export type Alert = {
  __typename: "Alert",
  id: string,
  title?: string | null,
  detail?: string | null,
  pollID?: string | null,
  message?: string | null,
  type: AlertType,
  createdAt: string,
  userID: string,
  updatedAt: string,
  poll?: Poll | null,
  user?: User | null,
  owner?: string | null,
};

export type UpdateAlertInput = {
  id: string,
  title?: string | null,
  detail?: string | null,
  pollID?: string | null,
  message?: string | null,
  type?: AlertType | null,
  createdAt?: string | null,
  userID?: string | null,
};

export type DeleteAlertInput = {
  id: string,
};

export type CreateStripeAccountInput = {
  id?: string | null,
  userID: string,
  isOnboard: boolean,
  createdAt?: string | null,
  amount?: string | null,
  owner?: string | null,
};

export type ModelStripeAccountConditionInput = {
  userID?: ModelStringInput | null,
  isOnboard?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  amount?: ModelStringInput | null,
  and?: Array< ModelStripeAccountConditionInput | null > | null,
  or?: Array< ModelStripeAccountConditionInput | null > | null,
  not?: ModelStripeAccountConditionInput | null,
};

export type StripeAccount = {
  __typename: "StripeAccount",
  id: string,
  userID: string,
  isOnboard: boolean,
  createdAt: string,
  amount?: string | null,
  owner?: string | null,
  updatedAt: string,
};

export type UpdateStripeAccountInput = {
  id: string,
  userID?: string | null,
  isOnboard?: boolean | null,
  createdAt?: string | null,
  amount?: string | null,
  owner?: string | null,
};

export type DeleteStripeAccountInput = {
  id: string,
};

export type CreateStripeCustomerInput = {
  id?: string | null,
  userID: string,
  createdAt?: string | null,
  owner?: string | null,
};

export type ModelStripeCustomerConditionInput = {
  userID?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelStripeCustomerConditionInput | null > | null,
  or?: Array< ModelStripeCustomerConditionInput | null > | null,
  not?: ModelStripeCustomerConditionInput | null,
};

export type StripeCustomer = {
  __typename: "StripeCustomer",
  id: string,
  userID: string,
  createdAt: string,
  owner?: string | null,
  updatedAt: string,
};

export type UpdateStripeCustomerInput = {
  id: string,
  userID?: string | null,
  createdAt?: string | null,
  owner?: string | null,
};

export type DeleteStripeCustomerInput = {
  id: string,
};

export type CreateStripeChargeInput = {
  id?: string | null,
  userID: string,
  pollID: string,
  chargeID: string,
  status: StripeChargeStatus,
  amount: string,
  owner?: string | null,
  createdAt?: string | null,
};

export enum StripeChargeStatus {
  UNPAID = "UNPAID",
  PAID = "PAID",
  REFUNDED = "REFUNDED",
}


export type ModelStripeChargeConditionInput = {
  userID?: ModelStringInput | null,
  pollID?: ModelStringInput | null,
  chargeID?: ModelStringInput | null,
  status?: ModelStripeChargeStatusInput | null,
  amount?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelStripeChargeConditionInput | null > | null,
  or?: Array< ModelStripeChargeConditionInput | null > | null,
  not?: ModelStripeChargeConditionInput | null,
};

export type ModelStripeChargeStatusInput = {
  eq?: StripeChargeStatus | null,
  ne?: StripeChargeStatus | null,
};

export type StripeCharge = {
  __typename: "StripeCharge",
  id: string,
  userID: string,
  pollID: string,
  chargeID: string,
  status: StripeChargeStatus,
  amount: string,
  owner?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateStripeChargeInput = {
  id: string,
  userID?: string | null,
  pollID?: string | null,
  chargeID?: string | null,
  status?: StripeChargeStatus | null,
  amount?: string | null,
  owner?: string | null,
  createdAt?: string | null,
};

export type DeleteStripeChargeInput = {
  id: string,
};

export type CreateStripeSubscriptionInput = {
  id?: string | null,
  subscriptionID: string,
  customerID: string,
  userID: string,
  tier: string,
  createdAt?: string | null,
};

export type ModelStripeSubscriptionConditionInput = {
  subscriptionID?: ModelStringInput | null,
  customerID?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  tier?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelStripeSubscriptionConditionInput | null > | null,
  or?: Array< ModelStripeSubscriptionConditionInput | null > | null,
  not?: ModelStripeSubscriptionConditionInput | null,
};

export type StripeSubscription = {
  __typename: "StripeSubscription",
  id: string,
  subscriptionID: string,
  customerID: string,
  userID: string,
  tier: string,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateStripeSubscriptionInput = {
  id: string,
  subscriptionID?: string | null,
  customerID?: string | null,
  userID?: string | null,
  tier?: string | null,
  createdAt?: string | null,
};

export type DeleteStripeSubscriptionInput = {
  id: string,
};

export type CreateProxyPollInput = {
  id?: string | null,
  proxyUserID: string,
  pollID: string,
  enabled?: boolean | null,
  createdAt?: string | null,
};

export type ModelProxyPollConditionInput = {
  proxyUserID?: ModelIDInput | null,
  pollID?: ModelIDInput | null,
  enabled?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelProxyPollConditionInput | null > | null,
  or?: Array< ModelProxyPollConditionInput | null > | null,
  not?: ModelProxyPollConditionInput | null,
};

export type ProxyPoll = {
  __typename: "ProxyPoll",
  id: string,
  proxyUserID: string,
  pollID: string,
  enabled?: boolean | null,
  createdAt: string,
  updatedAt: string,
  poll?: Poll | null,
  user?: User | null,
};

export type UpdateProxyPollInput = {
  id: string,
  proxyUserID?: string | null,
  pollID?: string | null,
  enabled?: boolean | null,
  createdAt?: string | null,
};

export type DeleteProxyPollInput = {
  id: string,
};

export type CreateDefaultConfigurationInput = {
  id?: string | null,
  theme?: S3ObjectInput | null,
  background?: S3ObjectInput | null,
  logo?: S3ObjectInput | null,
  pollImage?: S3ObjectInput | null,
};

export type ModelDefaultConfigurationConditionInput = {
  and?: Array< ModelDefaultConfigurationConditionInput | null > | null,
  or?: Array< ModelDefaultConfigurationConditionInput | null > | null,
  not?: ModelDefaultConfigurationConditionInput | null,
};

export type DefaultConfiguration = {
  __typename: "DefaultConfiguration",
  id: string,
  theme?: S3Object | null,
  background?: S3Object | null,
  logo?: S3Object | null,
  pollImage?: S3Object | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateDefaultConfigurationInput = {
  id: string,
  theme?: S3ObjectInput | null,
  background?: S3ObjectInput | null,
  logo?: S3ObjectInput | null,
  pollImage?: S3ObjectInput | null,
};

export type DeleteDefaultConfigurationInput = {
  id: string,
};

export type CreateCustomConfigurationInput = {
  id?: string | null,
  companyID: string,
  field?: string | null,
  value?: string | null,
};

export type ModelCustomConfigurationConditionInput = {
  companyID?: ModelIDInput | null,
  field?: ModelStringInput | null,
  value?: ModelStringInput | null,
  and?: Array< ModelCustomConfigurationConditionInput | null > | null,
  or?: Array< ModelCustomConfigurationConditionInput | null > | null,
  not?: ModelCustomConfigurationConditionInput | null,
};

export type CustomConfiguration = {
  __typename: "CustomConfiguration",
  id: string,
  companyID: string,
  field?: string | null,
  value?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateCustomConfigurationInput = {
  id: string,
  companyID?: string | null,
  field?: string | null,
  value?: string | null,
};

export type DeleteCustomConfigurationInput = {
  id: string,
};

export type CreatePollCountInput = {
  id?: string | null,
  count?: number | null,
};

export type ModelPollCountConditionInput = {
  count?: ModelIntInput | null,
  and?: Array< ModelPollCountConditionInput | null > | null,
  or?: Array< ModelPollCountConditionInput | null > | null,
  not?: ModelPollCountConditionInput | null,
};

export type PollCount = {
  __typename: "PollCount",
  id: string,
  count?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdatePollCountInput = {
  id: string,
  count?: number | null,
};

export type DeletePollCountInput = {
  id: string,
};

export type CreatePopUpInput = {
  id?: string | null,
  status: PopUpStatus,
  type: PopUpType,
  pollID: string,
  updatedAt?: string | null,
};

export enum PopUpStatus {
  CREATED = "CREATED",
  DELETED = "DELETED",
}


export enum PopUpType {
  POLL_INSERT = "POLL_INSERT",
  POLL_REMOVE = "POLL_REMOVE",
  POLL_MODIFY = "POLL_MODIFY",
  VOTE_INSERT = "VOTE_INSERT",
  VOTE_REMOVE = "VOTE_REMOVE",
  VOTE_MODIFY = "VOTE_MODIFY",
  PLEDGE_INSERT = "PLEDGE_INSERT",
  PLEDGE_REMOVE = "PLEDGE_REMOVE",
  PLEDGE_MODIFY = "PLEDGE_MODIFY",
}


export type ModelPopUpConditionInput = {
  status?: ModelPopUpStatusInput | null,
  type?: ModelPopUpTypeInput | null,
  pollID?: ModelIDInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPopUpConditionInput | null > | null,
  or?: Array< ModelPopUpConditionInput | null > | null,
  not?: ModelPopUpConditionInput | null,
};

export type ModelPopUpStatusInput = {
  eq?: PopUpStatus | null,
  ne?: PopUpStatus | null,
};

export type ModelPopUpTypeInput = {
  eq?: PopUpType | null,
  ne?: PopUpType | null,
};

export type PopUp = {
  __typename: "PopUp",
  id: string,
  status: PopUpStatus,
  type: PopUpType,
  pollID: string,
  updatedAt: string,
  createdAt: string,
  poll?: Poll | null,
};

export type UpdatePopUpInput = {
  id: string,
  status?: PopUpStatus | null,
  type?: PopUpType | null,
  pollID?: string | null,
  updatedAt?: string | null,
};

export type DeletePopUpInput = {
  id: string,
};

export type CreatePostalInfoInput = {
  postal: string,
  grc?: string | null,
  division?: string | null,
};

export type ModelPostalInfoConditionInput = {
  grc?: ModelStringInput | null,
  division?: ModelStringInput | null,
  and?: Array< ModelPostalInfoConditionInput | null > | null,
  or?: Array< ModelPostalInfoConditionInput | null > | null,
  not?: ModelPostalInfoConditionInput | null,
};

export type UpdatePostalInfoInput = {
  postal: string,
  grc?: string | null,
  division?: string | null,
};

export type DeletePostalInfoInput = {
  postal: string,
};

export type CreatePremiumPollPurchaseInput = {
  id?: string | null,
  userID: string,
  createdAt?: string | null,
  amount?: string | null,
  chargeID?: string | null,
};

export type ModelPremiumPollPurchaseConditionInput = {
  userID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  amount?: ModelStringInput | null,
  chargeID?: ModelStringInput | null,
  and?: Array< ModelPremiumPollPurchaseConditionInput | null > | null,
  or?: Array< ModelPremiumPollPurchaseConditionInput | null > | null,
  not?: ModelPremiumPollPurchaseConditionInput | null,
};

export type PremiumPollPurchase = {
  __typename: "PremiumPollPurchase",
  id: string,
  userID: string,
  createdAt: string,
  amount?: string | null,
  chargeID?: string | null,
  updatedAt: string,
  user?: User | null,
  owner?: string | null,
};

export type UpdatePremiumPollPurchaseInput = {
  id: string,
  userID?: string | null,
  createdAt?: string | null,
  amount?: string | null,
  chargeID?: string | null,
};

export type DeletePremiumPollPurchaseInput = {
  id: string,
};

export type GetIdeaSummaryInput = {
  userID?: string | null,
  companyID?: string | null,
};

export type ChatGPTInput = {
  type?: string | null,
  search?: string | null,
};

export type CreateIdeaPledgeStripeChargeAPIInput = {
  ideaID: string,
  ideaPledgeID: string,
  price: number,
  token: string,
  currency: string,
  userID: string,
  coupon?: string | null,
};

export type GetGuest = {
  timestamp?: string | null,
};

export type AddPremiumPollCountInput = {
  token: string,
  coupon?: string | null,
};

export type CanCreatePremiumPollInput = {
  userID?: string | null,
};

export type SyncVoteInput = {
  guestID?: string | null,
};

export type CreateStripeSubscriptionAPIInput = {
  userID: string,
  tier: string,
  token: string,
  coupon?: string | null,
};

export type CreateChargeStripeAPIInput = {
  price: string,
  token: string,
  currency: Currency,
  userID: string,
  coupon?: string | null,
};

export type CreateRefundStripeAPIInput = {
  chargeID: string,
  includeFee: boolean,
};

export type GetStripeSubscriptionAPIInput = {
  subscriptionID: string,
};

export type CreateIdeaCategoryInput = {
  id?: string | null,
  title?: string | null,
  edu?: boolean | null,
};

export type ModelIdeaCategoryConditionInput = {
  title?: ModelStringInput | null,
  edu?: ModelBooleanInput | null,
  and?: Array< ModelIdeaCategoryConditionInput | null > | null,
  or?: Array< ModelIdeaCategoryConditionInput | null > | null,
  not?: ModelIdeaCategoryConditionInput | null,
};

export type IdeaCategory = {
  __typename: "IdeaCategory",
  id: string,
  title?: string | null,
  edu?: boolean | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateIdeaCategoryInput = {
  id: string,
  title?: string | null,
  edu?: boolean | null,
};

export type DeleteIdeaCategoryInput = {
  id: string,
};

export type CreateIdeaHashtagInput = {
  id?: string | null,
  title?: string | null,
};

export type ModelIdeaHashtagConditionInput = {
  title?: ModelStringInput | null,
  and?: Array< ModelIdeaHashtagConditionInput | null > | null,
  or?: Array< ModelIdeaHashtagConditionInput | null > | null,
  not?: ModelIdeaHashtagConditionInput | null,
};

export type IdeaHashtag = {
  __typename: "IdeaHashtag",
  id: string,
  title?: string | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateIdeaHashtagInput = {
  id: string,
  title?: string | null,
};

export type DeleteIdeaHashtagInput = {
  id: string,
};

export type CreateIdeaInput = {
  id?: string | null,
  title: string,
  description?: string | null,
  image?: S3ObjectInput | null,
  theme?: S3ObjectInput | null,
  background?: S3ObjectInput | null,
  logo?: S3ObjectInput | null,
  video?: string | null,
  featured?: boolean | null,
  startTime: string,
  endTime: string,
  owner?: string | null,
  createdAt?: string | null,
  companyID?: string | null,
  themeID?: string | null,
  category?: string | null,
  hashtag?: Array< string | null > | null,
};

export type ModelIdeaConditionInput = {
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  video?: ModelStringInput | null,
  featured?: ModelBooleanInput | null,
  startTime?: ModelStringInput | null,
  endTime?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  companyID?: ModelIDInput | null,
  themeID?: ModelIDInput | null,
  category?: ModelStringInput | null,
  hashtag?: ModelStringInput | null,
  and?: Array< ModelIdeaConditionInput | null > | null,
  or?: Array< ModelIdeaConditionInput | null > | null,
  not?: ModelIdeaConditionInput | null,
};

export type Idea = {
  __typename: "Idea",
  id: string,
  title: string,
  description?: string | null,
  image?: S3Object | null,
  theme?: S3Object | null,
  background?: S3Object | null,
  logo?: S3Object | null,
  video?: string | null,
  featured?: boolean | null,
  startTime: string,
  endTime: string,
  owner?: string | null,
  createdAt: string,
  companyID?: string | null,
  themeID?: string | null,
  category?: string | null,
  hashtag?: Array< string | null > | null,
  updatedAt: string,
  companyTheme?: CompanyTheme | null,
  company?: Company | null,
  pledges?: ModelIdeaPledgeConnection | null,
  comments?: ModelIdeaCommentConnection | null,
  scores?: ModelIdeaScoreConnection | null,
};

export type ModelIdeaPledgeConnection = {
  __typename: "ModelIdeaPledgeConnection",
  items:  Array<IdeaPledge | null >,
  nextToken?: string | null,
};

export type IdeaPledge = {
  __typename: "IdeaPledge",
  id: string,
  ideaID: string,
  title?: string | null,
  description?: string | null,
  video?: string | null,
  price: string,
  currency: string,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type ModelIdeaCommentConnection = {
  __typename: "ModelIdeaCommentConnection",
  items:  Array<IdeaComment | null >,
  nextToken?: string | null,
};

export type IdeaComment = {
  __typename: "IdeaComment",
  id: string,
  ideaID: string,
  userID: string,
  content: string,
  avatar?: string | null,
  name?: string | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type ModelIdeaScoreConnection = {
  __typename: "ModelIdeaScoreConnection",
  items:  Array<IdeaScore | null >,
  nextToken?: string | null,
};

export type IdeaScore = {
  __typename: "IdeaScore",
  id: string,
  ideaID: string,
  userID: string,
  level_of_success: number,
  investment_required: number,
  talent_required: number,
  consultation_required: number,
  connection_required: number,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateIdeaInput = {
  id: string,
  title?: string | null,
  description?: string | null,
  image?: S3ObjectInput | null,
  theme?: S3ObjectInput | null,
  background?: S3ObjectInput | null,
  logo?: S3ObjectInput | null,
  video?: string | null,
  featured?: boolean | null,
  startTime?: string | null,
  endTime?: string | null,
  owner?: string | null,
  createdAt?: string | null,
  companyID?: string | null,
  themeID?: string | null,
  category?: string | null,
  hashtag?: Array< string | null > | null,
};

export type DeleteIdeaInput = {
  id: string,
};

export type CreateIdeaPledgeInput = {
  id?: string | null,
  ideaID: string,
  title?: string | null,
  description?: string | null,
  video?: string | null,
  price: string,
  currency: string,
};

export type ModelIdeaPledgeConditionInput = {
  ideaID?: ModelIDInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  video?: ModelStringInput | null,
  price?: ModelStringInput | null,
  currency?: ModelStringInput | null,
  and?: Array< ModelIdeaPledgeConditionInput | null > | null,
  or?: Array< ModelIdeaPledgeConditionInput | null > | null,
  not?: ModelIdeaPledgeConditionInput | null,
};

export type UpdateIdeaPledgeInput = {
  id: string,
  ideaID?: string | null,
  title?: string | null,
  description?: string | null,
  video?: string | null,
  price?: string | null,
  currency?: string | null,
};

export type DeleteIdeaPledgeInput = {
  id: string,
};

export type CreateIdeaCommentInput = {
  id?: string | null,
  ideaID: string,
  userID: string,
  content: string,
  avatar?: string | null,
  name?: string | null,
};

export type ModelIdeaCommentConditionInput = {
  ideaID?: ModelIDInput | null,
  userID?: ModelIDInput | null,
  content?: ModelStringInput | null,
  avatar?: ModelStringInput | null,
  name?: ModelStringInput | null,
  and?: Array< ModelIdeaCommentConditionInput | null > | null,
  or?: Array< ModelIdeaCommentConditionInput | null > | null,
  not?: ModelIdeaCommentConditionInput | null,
};

export type UpdateIdeaCommentInput = {
  id: string,
  ideaID?: string | null,
  userID?: string | null,
  content?: string | null,
  avatar?: string | null,
  name?: string | null,
};

export type DeleteIdeaCommentInput = {
  id: string,
};

export type CreateIdeaPledgeStripeChargeInput = {
  id?: string | null,
  userID: string,
  ideaID: string,
  ideaPledgeID: string,
  chargeID: string,
  status: StripeChargeStatus,
  amount: string,
  owner?: string | null,
  createdAt?: string | null,
};

export type ModelIdeaPledgeStripeChargeConditionInput = {
  userID?: ModelIDInput | null,
  ideaID?: ModelStringInput | null,
  ideaPledgeID?: ModelStringInput | null,
  chargeID?: ModelStringInput | null,
  status?: ModelStripeChargeStatusInput | null,
  amount?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelIdeaPledgeStripeChargeConditionInput | null > | null,
  or?: Array< ModelIdeaPledgeStripeChargeConditionInput | null > | null,
  not?: ModelIdeaPledgeStripeChargeConditionInput | null,
};

export type IdeaPledgeStripeCharge = {
  __typename: "IdeaPledgeStripeCharge",
  id: string,
  userID: string,
  ideaID: string,
  ideaPledgeID: string,
  chargeID: string,
  status: StripeChargeStatus,
  amount: string,
  owner?: string | null,
  createdAt: string,
  updatedAt: string,
  user?: User | null,
};

export type UpdateIdeaPledgeStripeChargeInput = {
  id: string,
  userID?: string | null,
  ideaID?: string | null,
  ideaPledgeID?: string | null,
  chargeID?: string | null,
  status?: StripeChargeStatus | null,
  amount?: string | null,
  owner?: string | null,
  createdAt?: string | null,
};

export type DeleteIdeaPledgeStripeChargeInput = {
  id: string,
};

export type CreateIdeaScoreInput = {
  id?: string | null,
  ideaID: string,
  userID: string,
  level_of_success: number,
  investment_required: number,
  talent_required: number,
  consultation_required: number,
  connection_required: number,
};

export type ModelIdeaScoreConditionInput = {
  ideaID?: ModelIDInput | null,
  userID?: ModelIDInput | null,
  level_of_success?: ModelIntInput | null,
  investment_required?: ModelIntInput | null,
  talent_required?: ModelIntInput | null,
  consultation_required?: ModelIntInput | null,
  connection_required?: ModelIntInput | null,
  and?: Array< ModelIdeaScoreConditionInput | null > | null,
  or?: Array< ModelIdeaScoreConditionInput | null > | null,
  not?: ModelIdeaScoreConditionInput | null,
};

export type UpdateIdeaScoreInput = {
  id: string,
  ideaID?: string | null,
  userID?: string | null,
  level_of_success?: number | null,
  investment_required?: number | null,
  talent_required?: number | null,
  consultation_required?: number | null,
  connection_required?: number | null,
};

export type DeleteIdeaScoreInput = {
  id: string,
};

export type CreateIdeaSupporterInput = {
  id?: string | null,
  url?: string | null,
  logo?: S3ObjectInput | null,
};

export type ModelIdeaSupporterConditionInput = {
  url?: ModelStringInput | null,
  and?: Array< ModelIdeaSupporterConditionInput | null > | null,
  or?: Array< ModelIdeaSupporterConditionInput | null > | null,
  not?: ModelIdeaSupporterConditionInput | null,
};

export type IdeaSupporter = {
  __typename: "IdeaSupporter",
  id: string,
  url?: string | null,
  logo?: S3Object | null,
  createdAt: string,
  updatedAt: string,
  owner?: string | null,
};

export type UpdateIdeaSupporterInput = {
  id: string,
  url?: string | null,
  logo?: S3ObjectInput | null,
};

export type DeleteIdeaSupporterInput = {
  id: string,
};

export type ModelPollCommentFilterInput = {
  id?: ModelIDInput | null,
  pollID?: ModelIDInput | null,
  userID?: ModelIDInput | null,
  content?: ModelStringInput | null,
  avatar?: ModelStringInput | null,
  name?: ModelStringInput | null,
  and?: Array< ModelPollCommentFilterInput | null > | null,
  or?: Array< ModelPollCommentFilterInput | null > | null,
  not?: ModelPollCommentFilterInput | null,
};

export type ModelPollFilterInput = {
  id?: ModelIDInput | null,
  title?: ModelStringInput | null,
  question?: ModelStringInput | null,
  description?: ModelStringInput | null,
  video?: ModelStringInput | null,
  status?: ModelPollStatusInput | null,
  hasPledge?: ModelBooleanInput | null,
  isGroup?: ModelBooleanInput | null,
  featured?: ModelBooleanInput | null,
  startTime?: ModelStringInput | null,
  endTime?: ModelStringInput | null,
  pledgePeriod1StartTime?: ModelStringInput | null,
  pledgePeriod1EndTime?: ModelStringInput | null,
  pledgePeriod2StartTime?: ModelStringInput | null,
  pledgePeriod2EndTime?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  password?: ModelStringInput | null,
  grc?: ModelStringInput | null,
  division?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  private?: ModelIntInput | null,
  companyID?: ModelIDInput | null,
  themeID?: ModelIDInput | null,
  representativeID?: ModelIDInput | null,
  isPremium?: ModelBooleanInput | null,
  maxVote?: ModelIntInput | null,
  isNotExact?: ModelBooleanInput | null,
  category?: ModelStringInput | null,
  hashtag?: ModelStringInput | null,
  and?: Array< ModelPollFilterInput | null > | null,
  or?: Array< ModelPollFilterInput | null > | null,
  not?: ModelPollFilterInput | null,
};

export type ModelPollConnection = {
  __typename: "ModelPollConnection",
  items:  Array<Poll | null >,
  nextToken?: string | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelSubPollFilterInput = {
  id?: ModelIDInput | null,
  pollID?: ModelStringInput | null,
  title?: ModelStringInput | null,
  question?: ModelStringInput | null,
  description?: ModelStringInput | null,
  video?: ModelStringInput | null,
  status?: ModelPollStatusInput | null,
  owner?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  orderID?: ModelIntInput | null,
  private?: ModelIntInput | null,
  maxVote?: ModelIntInput | null,
  isNotExact?: ModelBooleanInput | null,
  and?: Array< ModelSubPollFilterInput | null > | null,
  or?: Array< ModelSubPollFilterInput | null > | null,
  not?: ModelSubPollFilterInput | null,
};

export type ModelSubPollConnection = {
  __typename: "ModelSubPollConnection",
  items:  Array<SubPoll | null >,
  nextToken?: string | null,
};

export type ModelIntKeyConditionInput = {
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelVoteFilterInput = {
  id?: ModelIDInput | null,
  userID?: ModelIDInput | null,
  type?: ModelVoteTypeInput | null,
  subPollID?: ModelIDInput | null,
  reason?: ModelStringInput | null,
  pollID?: ModelIDInput | null,
  proxyUserID?: ModelIDInput | null,
  and?: Array< ModelVoteFilterInput | null > | null,
  or?: Array< ModelVoteFilterInput | null > | null,
  not?: ModelVoteFilterInput | null,
};

export type ModelIDKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelHotPollFilterInput = {
  id?: ModelIDInput | null,
  pollID?: ModelIDInput | null,
  count?: ModelIntInput | null,
  status?: ModelHotPollStatusInput | null,
  and?: Array< ModelHotPollFilterInput | null > | null,
  or?: Array< ModelHotPollFilterInput | null > | null,
  not?: ModelHotPollFilterInput | null,
};

export type ModelHotPollConnection = {
  __typename: "ModelHotPollConnection",
  items:  Array<HotPoll | null >,
  nextToken?: string | null,
};

export type ModelHotPledgeFilterInput = {
  id?: ModelIDInput | null,
  pollID?: ModelIDInput | null,
  count?: ModelIntInput | null,
  status?: ModelHotPollStatusInput | null,
  and?: Array< ModelHotPledgeFilterInput | null > | null,
  or?: Array< ModelHotPledgeFilterInput | null > | null,
  not?: ModelHotPledgeFilterInput | null,
};

export type ModelHotPledgeConnection = {
  __typename: "ModelHotPledgeConnection",
  items:  Array<HotPledge | null >,
  nextToken?: string | null,
};

export type ModelVoteResultFilterInput = {
  id?: ModelIDInput | null,
  count?: ModelIntInput | null,
  subPollID?: ModelIDInput | null,
  pollID?: ModelIDInput | null,
  and?: Array< ModelVoteResultFilterInput | null > | null,
  or?: Array< ModelVoteResultFilterInput | null > | null,
  not?: ModelVoteResultFilterInput | null,
};

export type ModelPledgeFilterInput = {
  id?: ModelIDInput | null,
  userID?: ModelIDInput | null,
  type?: ModelPledgeTypeInput | null,
  pollID?: ModelIDInput | null,
  reason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelPledgeFilterInput | null > | null,
  or?: Array< ModelPledgeFilterInput | null > | null,
  not?: ModelPledgeFilterInput | null,
};

export type ModelPledgeConnection = {
  __typename: "ModelPledgeConnection",
  items:  Array<Pledge | null >,
  nextToken?: string | null,
};

export type ModelPledgeResultFilterInput = {
  id?: ModelIDInput | null,
  count?: ModelIntInput | null,
  pollID?: ModelStringInput | null,
  and?: Array< ModelPledgeResultFilterInput | null > | null,
  or?: Array< ModelPledgeResultFilterInput | null > | null,
  not?: ModelPledgeResultFilterInput | null,
};

export type ModelPledgeResultConnection = {
  __typename: "ModelPledgeResultConnection",
  items:  Array<PledgeResult | null >,
  nextToken?: string | null,
};

export type ModelPollReportFilterInput = {
  id?: ModelIDInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  pollID?: ModelIDInput | null,
  owner?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelPollReportFilterInput | null > | null,
  or?: Array< ModelPollReportFilterInput | null > | null,
  not?: ModelPollReportFilterInput | null,
};

export type ModelPollReportConnection = {
  __typename: "ModelPollReportConnection",
  items:  Array<PollReport | null >,
  nextToken?: string | null,
};

export type ModelPackageSubscriptionFilterInput = {
  tier?: ModelTierInput | null,
  price?: ModelStringInput | null,
  stripePriceID?: ModelStringInput | null,
  pollOptionLimit?: ModelIntInput | null,
  groupPollAllowed?: ModelBooleanInput | null,
  groupPollLimit?: ModelIntInput | null,
  pledgeAllowed?: ModelBooleanInput | null,
  pledgeChargePercentage?: ModelStringInput | null,
  pollDurationLimit?: ModelStringInput | null,
  pollResultLiveAllowed?: ModelBooleanInput | null,
  statisticReportAllowed?: ModelBooleanInput | null,
  withdrawalAllowed?: ModelBooleanInput | null,
  extensionPledgeAllowed?: ModelBooleanInput | null,
  noOfPolls?: ModelIntInput | null,
  and?: Array< ModelPackageSubscriptionFilterInput | null > | null,
  or?: Array< ModelPackageSubscriptionFilterInput | null > | null,
  not?: ModelPackageSubscriptionFilterInput | null,
};

export type ModelPackageSubscriptionConnection = {
  __typename: "ModelPackageSubscriptionConnection",
  items:  Array<PackageSubscription | null >,
  nextToken?: string | null,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  email?: ModelStringInput | null,
  username?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  phone?: ModelStringInput | null,
  type?: ModelUserTypeInput | null,
  disable?: ModelBooleanInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  yearOfBirth?: ModelIntInput | null,
  gender?: ModelStringInput | null,
  education?: ModelStringInput | null,
  postalCode?: ModelIDInput | null,
  salaryRange?: ModelUserSalaryRangeInput | null,
  company?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  isSetup?: ModelBooleanInput | null,
  tier?: ModelTierInput | null,
  proxyUserID?: ModelIDInput | null,
  premiumPolls?: ModelIntInput | null,
  usedPremiumPolls?: ModelIntInput | null,
  cryptowallet?: ModelStringInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
};

export type ModelCompanyUserFilterInput = {
  id?: ModelIDInput | null,
  userID?: ModelIDInput | null,
  username?: ModelStringInput | null,
  companyID?: ModelIDInput | null,
  adminID?: ModelIDInput | null,
  role?: ModelCompanyRoleInput | null,
  owner?: ModelStringInput | null,
  and?: Array< ModelCompanyUserFilterInput | null > | null,
  or?: Array< ModelCompanyUserFilterInput | null > | null,
  not?: ModelCompanyUserFilterInput | null,
};

export type ModelCompanyUserConnection = {
  __typename: "ModelCompanyUserConnection",
  items:  Array<CompanyUser | null >,
  nextToken?: string | null,
};

export type ModelCompanyThemeFilterInput = {
  id?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  and?: Array< ModelCompanyThemeFilterInput | null > | null,
  or?: Array< ModelCompanyThemeFilterInput | null > | null,
  not?: ModelCompanyThemeFilterInput | null,
};

export type ModelCompanyThemeConnection = {
  __typename: "ModelCompanyThemeConnection",
  items:  Array<CompanyTheme | null >,
  nextToken?: string | null,
};

export type ModelCompanyFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  domain?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  status?: ModelCompanyStatusInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelCompanyFilterInput | null > | null,
  or?: Array< ModelCompanyFilterInput | null > | null,
  not?: ModelCompanyFilterInput | null,
};

export type ModelCompanyConnection = {
  __typename: "ModelCompanyConnection",
  items:  Array<Company | null >,
  nextToken?: string | null,
};

export type ModelCompanyDomainFilterInput = {
  id?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  domain?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelCompanyDomainFilterInput | null > | null,
  or?: Array< ModelCompanyDomainFilterInput | null > | null,
  not?: ModelCompanyDomainFilterInput | null,
};

export type ModelCompanyDomainConnection = {
  __typename: "ModelCompanyDomainConnection",
  items:  Array<CompanyDomain | null >,
  nextToken?: string | null,
};

export type ModelRequestJoinCompanyFilterInput = {
  id?: ModelIDInput | null,
  userID?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  status?: ModelRequestJoinCompanyStatusInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelRequestJoinCompanyFilterInput | null > | null,
  or?: Array< ModelRequestJoinCompanyFilterInput | null > | null,
  not?: ModelRequestJoinCompanyFilterInput | null,
};

export type ModelRequestJoinCompanyConnection = {
  __typename: "ModelRequestJoinCompanyConnection",
  items:  Array<RequestJoinCompany | null >,
  nextToken?: string | null,
};

export type ModelAlertFilterInput = {
  title?: ModelStringInput | null,
  detail?: ModelStringInput | null,
  pollID?: ModelIDInput | null,
  message?: ModelStringInput | null,
  type?: ModelAlertTypeInput | null,
  createdAt?: ModelStringInput | null,
  userID?: ModelIDInput | null,
  and?: Array< ModelAlertFilterInput | null > | null,
  or?: Array< ModelAlertFilterInput | null > | null,
  not?: ModelAlertFilterInput | null,
};

export type ModelAlertConnection = {
  __typename: "ModelAlertConnection",
  items:  Array<Alert | null >,
  nextToken?: string | null,
};

export type ModelStripeAccountFilterInput = {
  id?: ModelIDInput | null,
  userID?: ModelStringInput | null,
  isOnboard?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  amount?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  and?: Array< ModelStripeAccountFilterInput | null > | null,
  or?: Array< ModelStripeAccountFilterInput | null > | null,
  not?: ModelStripeAccountFilterInput | null,
};

export type ModelStripeAccountConnection = {
  __typename: "ModelStripeAccountConnection",
  items:  Array<StripeAccount | null >,
  nextToken?: string | null,
};

export type ModelStripeCustomerFilterInput = {
  id?: ModelIDInput | null,
  userID?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  and?: Array< ModelStripeCustomerFilterInput | null > | null,
  or?: Array< ModelStripeCustomerFilterInput | null > | null,
  not?: ModelStripeCustomerFilterInput | null,
};

export type ModelStripeCustomerConnection = {
  __typename: "ModelStripeCustomerConnection",
  items:  Array<StripeCustomer | null >,
  nextToken?: string | null,
};

export type ModelStripeChargeFilterInput = {
  id?: ModelIDInput | null,
  userID?: ModelStringInput | null,
  pollID?: ModelStringInput | null,
  chargeID?: ModelStringInput | null,
  status?: ModelStripeChargeStatusInput | null,
  amount?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelStripeChargeFilterInput | null > | null,
  or?: Array< ModelStripeChargeFilterInput | null > | null,
  not?: ModelStripeChargeFilterInput | null,
};

export type ModelStripeChargeConnection = {
  __typename: "ModelStripeChargeConnection",
  items:  Array<StripeCharge | null >,
  nextToken?: string | null,
};

export type ModelStripeSubscriptionFilterInput = {
  subscriptionID?: ModelStringInput | null,
  customerID?: ModelStringInput | null,
  userID?: ModelStringInput | null,
  tier?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelStripeSubscriptionFilterInput | null > | null,
  or?: Array< ModelStripeSubscriptionFilterInput | null > | null,
  not?: ModelStripeSubscriptionFilterInput | null,
};

export type ModelStripeSubscriptionConnection = {
  __typename: "ModelStripeSubscriptionConnection",
  items:  Array<StripeSubscription | null >,
  nextToken?: string | null,
};

export type ModelProxyPollFilterInput = {
  id?: ModelIDInput | null,
  proxyUserID?: ModelIDInput | null,
  pollID?: ModelIDInput | null,
  enabled?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelProxyPollFilterInput | null > | null,
  or?: Array< ModelProxyPollFilterInput | null > | null,
  not?: ModelProxyPollFilterInput | null,
};

export type ModelProxyPollConnection = {
  __typename: "ModelProxyPollConnection",
  items:  Array<ProxyPoll | null >,
  nextToken?: string | null,
};

export type ModelDefaultConfigurationFilterInput = {
  id?: ModelIDInput | null,
  and?: Array< ModelDefaultConfigurationFilterInput | null > | null,
  or?: Array< ModelDefaultConfigurationFilterInput | null > | null,
  not?: ModelDefaultConfigurationFilterInput | null,
};

export type ModelDefaultConfigurationConnection = {
  __typename: "ModelDefaultConfigurationConnection",
  items:  Array<DefaultConfiguration | null >,
  nextToken?: string | null,
};

export type ModelCustomConfigurationFilterInput = {
  id?: ModelIDInput | null,
  companyID?: ModelIDInput | null,
  field?: ModelStringInput | null,
  value?: ModelStringInput | null,
  and?: Array< ModelCustomConfigurationFilterInput | null > | null,
  or?: Array< ModelCustomConfigurationFilterInput | null > | null,
  not?: ModelCustomConfigurationFilterInput | null,
};

export type ModelCustomConfigurationConnection = {
  __typename: "ModelCustomConfigurationConnection",
  items:  Array<CustomConfiguration | null >,
  nextToken?: string | null,
};

export type ModelPollCountFilterInput = {
  id?: ModelIDInput | null,
  count?: ModelIntInput | null,
  and?: Array< ModelPollCountFilterInput | null > | null,
  or?: Array< ModelPollCountFilterInput | null > | null,
  not?: ModelPollCountFilterInput | null,
};

export type ModelPollCountConnection = {
  __typename: "ModelPollCountConnection",
  items:  Array<PollCount | null >,
  nextToken?: string | null,
};

export type ModelPopUpFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelPopUpStatusInput | null,
  type?: ModelPopUpTypeInput | null,
  pollID?: ModelIDInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelPopUpFilterInput | null > | null,
  or?: Array< ModelPopUpFilterInput | null > | null,
  not?: ModelPopUpFilterInput | null,
};

export type ModelPopUpConnection = {
  __typename: "ModelPopUpConnection",
  items:  Array<PopUp | null >,
  nextToken?: string | null,
};

export type ModelPostalInfoFilterInput = {
  postal?: ModelIDInput | null,
  grc?: ModelStringInput | null,
  division?: ModelStringInput | null,
  and?: Array< ModelPostalInfoFilterInput | null > | null,
  or?: Array< ModelPostalInfoFilterInput | null > | null,
  not?: ModelPostalInfoFilterInput | null,
};

export type ModelPremiumPollPurchaseFilterInput = {
  id?: ModelIDInput | null,
  userID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  amount?: ModelStringInput | null,
  chargeID?: ModelStringInput | null,
  and?: Array< ModelPremiumPollPurchaseFilterInput | null > | null,
  or?: Array< ModelPremiumPollPurchaseFilterInput | null > | null,
  not?: ModelPremiumPollPurchaseFilterInput | null,
};

export type ModelPremiumPollPurchaseConnection = {
  __typename: "ModelPremiumPollPurchaseConnection",
  items:  Array<PremiumPollPurchase | null >,
  nextToken?: string | null,
};

export type ModelIdeaCategoryFilterInput = {
  id?: ModelIDInput | null,
  title?: ModelStringInput | null,
  edu?: ModelBooleanInput | null,
  and?: Array< ModelIdeaCategoryFilterInput | null > | null,
  or?: Array< ModelIdeaCategoryFilterInput | null > | null,
  not?: ModelIdeaCategoryFilterInput | null,
};

export type ModelIdeaCategoryConnection = {
  __typename: "ModelIdeaCategoryConnection",
  items:  Array<IdeaCategory | null >,
  nextToken?: string | null,
};

export type ModelIdeaHashtagFilterInput = {
  id?: ModelIDInput | null,
  title?: ModelStringInput | null,
  and?: Array< ModelIdeaHashtagFilterInput | null > | null,
  or?: Array< ModelIdeaHashtagFilterInput | null > | null,
  not?: ModelIdeaHashtagFilterInput | null,
};

export type ModelIdeaHashtagConnection = {
  __typename: "ModelIdeaHashtagConnection",
  items:  Array<IdeaHashtag | null >,
  nextToken?: string | null,
};

export type ModelIdeaFilterInput = {
  id?: ModelIDInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  video?: ModelStringInput | null,
  featured?: ModelBooleanInput | null,
  startTime?: ModelStringInput | null,
  endTime?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  companyID?: ModelIDInput | null,
  themeID?: ModelIDInput | null,
  category?: ModelStringInput | null,
  hashtag?: ModelStringInput | null,
  and?: Array< ModelIdeaFilterInput | null > | null,
  or?: Array< ModelIdeaFilterInput | null > | null,
  not?: ModelIdeaFilterInput | null,
};

export type ModelIdeaConnection = {
  __typename: "ModelIdeaConnection",
  items:  Array<Idea | null >,
  nextToken?: string | null,
};

export type ModelIdeaPledgeFilterInput = {
  id?: ModelIDInput | null,
  ideaID?: ModelIDInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  video?: ModelStringInput | null,
  price?: ModelStringInput | null,
  currency?: ModelStringInput | null,
  and?: Array< ModelIdeaPledgeFilterInput | null > | null,
  or?: Array< ModelIdeaPledgeFilterInput | null > | null,
  not?: ModelIdeaPledgeFilterInput | null,
};

export type ModelIdeaCommentFilterInput = {
  id?: ModelIDInput | null,
  ideaID?: ModelIDInput | null,
  userID?: ModelIDInput | null,
  content?: ModelStringInput | null,
  avatar?: ModelStringInput | null,
  name?: ModelStringInput | null,
  and?: Array< ModelIdeaCommentFilterInput | null > | null,
  or?: Array< ModelIdeaCommentFilterInput | null > | null,
  not?: ModelIdeaCommentFilterInput | null,
};

export type ModelIdeaPledgeStripeChargeFilterInput = {
  id?: ModelIDInput | null,
  userID?: ModelIDInput | null,
  ideaID?: ModelStringInput | null,
  ideaPledgeID?: ModelStringInput | null,
  chargeID?: ModelStringInput | null,
  status?: ModelStripeChargeStatusInput | null,
  amount?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelIdeaPledgeStripeChargeFilterInput | null > | null,
  or?: Array< ModelIdeaPledgeStripeChargeFilterInput | null > | null,
  not?: ModelIdeaPledgeStripeChargeFilterInput | null,
};

export type ModelIdeaPledgeStripeChargeConnection = {
  __typename: "ModelIdeaPledgeStripeChargeConnection",
  items:  Array<IdeaPledgeStripeCharge | null >,
  nextToken?: string | null,
};

export type ModelIdeaScoreFilterInput = {
  id?: ModelIDInput | null,
  ideaID?: ModelIDInput | null,
  userID?: ModelIDInput | null,
  level_of_success?: ModelIntInput | null,
  investment_required?: ModelIntInput | null,
  talent_required?: ModelIntInput | null,
  consultation_required?: ModelIntInput | null,
  connection_required?: ModelIntInput | null,
  and?: Array< ModelIdeaScoreFilterInput | null > | null,
  or?: Array< ModelIdeaScoreFilterInput | null > | null,
  not?: ModelIdeaScoreFilterInput | null,
};

export type ModelIdeaSupporterFilterInput = {
  id?: ModelIDInput | null,
  url?: ModelStringInput | null,
  and?: Array< ModelIdeaSupporterFilterInput | null > | null,
  or?: Array< ModelIdeaSupporterFilterInput | null > | null,
  not?: ModelIdeaSupporterFilterInput | null,
};

export type ModelIdeaSupporterConnection = {
  __typename: "ModelIdeaSupporterConnection",
  items:  Array<IdeaSupporter | null >,
  nextToken?: string | null,
};

export type AdminResetUserPasswordAPIMutationVariables = {
  input: AdminResetUserPasswordAPIInput,
};

export type AdminResetUserPasswordAPIMutation = {
  adminResetUserPasswordAPI?: string | null,
};

export type AdminDisableUserAPIMutationVariables = {
  input: AdminDisableUserAPIInput,
};

export type AdminDisableUserAPIMutation = {
  adminDisableUserAPI?: string | null,
};

export type CreatePollCommentMutationVariables = {
  input: CreatePollCommentInput,
  condition?: ModelPollCommentConditionInput | null,
};

export type CreatePollCommentMutation = {
  createPollComment?:  {
    __typename: "PollComment",
    id: string,
    pollID: string,
    userID: string,
    content: string,
    avatar?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdatePollCommentMutationVariables = {
  input: UpdatePollCommentInput,
  condition?: ModelPollCommentConditionInput | null,
};

export type UpdatePollCommentMutation = {
  updatePollComment?:  {
    __typename: "PollComment",
    id: string,
    pollID: string,
    userID: string,
    content: string,
    avatar?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeletePollCommentMutationVariables = {
  input: DeletePollCommentInput,
  condition?: ModelPollCommentConditionInput | null,
};

export type DeletePollCommentMutation = {
  deletePollComment?:  {
    __typename: "PollComment",
    id: string,
    pollID: string,
    userID: string,
    content: string,
    avatar?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreatePollMutationVariables = {
  input: CreatePollInput,
  condition?: ModelPollConditionInput | null,
};

export type CreatePollMutation = {
  createPoll?:  {
    __typename: "Poll",
    id: string,
    title: string,
    question: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    status?: PollStatus | null,
    options?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    drawOptions?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    hasPledge?: boolean | null,
    isGroup?: boolean | null,
    featured?: boolean | null,
    winOption?:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } | null,
    startTime: string,
    endTime: string,
    pledgePeriod1StartTime?: string | null,
    pledgePeriod1EndTime?: string | null,
    pledgePeriod2StartTime?: string | null,
    pledgePeriod2EndTime?: string | null,
    owner?: string | null,
    password?: string | null,
    grc?: string | null,
    division?: string | null,
    createdAt: string,
    private?: number | null,
    companyID?: string | null,
    themeID?: string | null,
    representativeID?: string | null,
    isPremium?: boolean | null,
    maxVote?: number | null,
    isNotExact?: boolean | null,
    category?: string | null,
    hashtag?: Array< string | null > | null,
    updatedAt: string,
    comments?:  {
      __typename: "ModelPollCommentConnection",
      items:  Array< {
        __typename: "PollComment",
        id: string,
        pollID: string,
        userID: string,
        content: string,
        avatar?: string | null,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    votes?:  {
      __typename: "ModelVoteConnection",
      items:  Array< {
        __typename: "Vote",
        id: string,
        userID: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        type: VoteType,
        subPollID?: string | null,
        reason?: string | null,
        pollID: string,
        proxyUserID?: string | null,
        createdAt: string,
        updatedAt: string,
        poll?:  {
          __typename: "Poll",
          id: string,
          title: string,
          question: string,
          description?: string | null,
          video?: string | null,
          status?: PollStatus | null,
          hasPledge?: boolean | null,
          isGroup?: boolean | null,
          featured?: boolean | null,
          startTime: string,
          endTime: string,
          pledgePeriod1StartTime?: string | null,
          pledgePeriod1EndTime?: string | null,
          pledgePeriod2StartTime?: string | null,
          pledgePeriod2EndTime?: string | null,
          owner?: string | null,
          password?: string | null,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          private?: number | null,
          companyID?: string | null,
          themeID?: string | null,
          representativeID?: string | null,
          isPremium?: boolean | null,
          maxVote?: number | null,
          isNotExact?: boolean | null,
          category?: string | null,
          hashtag?: Array< string | null > | null,
          updatedAt: string,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          email?: string | null,
          username?: string | null,
          owner?: string | null,
          phone?: string | null,
          type?: UserType | null,
          disable?: boolean | null,
          firstName?: string | null,
          lastName?: string | null,
          yearOfBirth?: number | null,
          gender?: string | null,
          education?: string | null,
          postalCode?: string | null,
          salaryRange?: UserSalaryRange | null,
          company?: string | null,
          createdAt: string,
          isSetup?: boolean | null,
          tier?: Tier | null,
          proxyUserID?: string | null,
          premiumPolls?: number | null,
          usedPremiumPolls?: number | null,
          cryptowallet?: string | null,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    voteResults?:  {
      __typename: "ModelVoteResultConnection",
      items:  Array< {
        __typename: "VoteResult",
        id: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        count: number,
        subPollID?: string | null,
        pollID: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    companyTheme?:  {
      __typename: "CompanyTheme",
      id: string,
      companyID: string,
      attributes?:  {
        __typename: "CustomThemeAttribute",
        pollActivePeriodBgColor?: string | null,
        pollActivePeriodShadowColor?: string | null,
        pollQuestionCardBgColor?: string | null,
        pollQuestionCardQuestionColor?: string | null,
        pollQuestionCardAnswerColor?: string | null,
        pollPledgeCastBtnBgColor?: string | null,
        pollPledgeCastBtnBracketColor?: string | null,
        pollPledgeCastBtnTextColor?: string | null,
        pollPageBgColor?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      domain: string,
      owner?: string | null,
      status?: CompanyStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    postalsGRC?:  {
      __typename: "ModelPostalInfoConnection",
      items:  Array< {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    postalsDivision?:  {
      __typename: "ModelPostalInfoConnection",
      items:  Array< {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdatePollMutationVariables = {
  input: UpdatePollInput,
  condition?: ModelPollConditionInput | null,
};

export type UpdatePollMutation = {
  updatePoll?:  {
    __typename: "Poll",
    id: string,
    title: string,
    question: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    status?: PollStatus | null,
    options?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    drawOptions?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    hasPledge?: boolean | null,
    isGroup?: boolean | null,
    featured?: boolean | null,
    winOption?:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } | null,
    startTime: string,
    endTime: string,
    pledgePeriod1StartTime?: string | null,
    pledgePeriod1EndTime?: string | null,
    pledgePeriod2StartTime?: string | null,
    pledgePeriod2EndTime?: string | null,
    owner?: string | null,
    password?: string | null,
    grc?: string | null,
    division?: string | null,
    createdAt: string,
    private?: number | null,
    companyID?: string | null,
    themeID?: string | null,
    representativeID?: string | null,
    isPremium?: boolean | null,
    maxVote?: number | null,
    isNotExact?: boolean | null,
    category?: string | null,
    hashtag?: Array< string | null > | null,
    updatedAt: string,
    comments?:  {
      __typename: "ModelPollCommentConnection",
      items:  Array< {
        __typename: "PollComment",
        id: string,
        pollID: string,
        userID: string,
        content: string,
        avatar?: string | null,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    votes?:  {
      __typename: "ModelVoteConnection",
      items:  Array< {
        __typename: "Vote",
        id: string,
        userID: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        type: VoteType,
        subPollID?: string | null,
        reason?: string | null,
        pollID: string,
        proxyUserID?: string | null,
        createdAt: string,
        updatedAt: string,
        poll?:  {
          __typename: "Poll",
          id: string,
          title: string,
          question: string,
          description?: string | null,
          video?: string | null,
          status?: PollStatus | null,
          hasPledge?: boolean | null,
          isGroup?: boolean | null,
          featured?: boolean | null,
          startTime: string,
          endTime: string,
          pledgePeriod1StartTime?: string | null,
          pledgePeriod1EndTime?: string | null,
          pledgePeriod2StartTime?: string | null,
          pledgePeriod2EndTime?: string | null,
          owner?: string | null,
          password?: string | null,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          private?: number | null,
          companyID?: string | null,
          themeID?: string | null,
          representativeID?: string | null,
          isPremium?: boolean | null,
          maxVote?: number | null,
          isNotExact?: boolean | null,
          category?: string | null,
          hashtag?: Array< string | null > | null,
          updatedAt: string,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          email?: string | null,
          username?: string | null,
          owner?: string | null,
          phone?: string | null,
          type?: UserType | null,
          disable?: boolean | null,
          firstName?: string | null,
          lastName?: string | null,
          yearOfBirth?: number | null,
          gender?: string | null,
          education?: string | null,
          postalCode?: string | null,
          salaryRange?: UserSalaryRange | null,
          company?: string | null,
          createdAt: string,
          isSetup?: boolean | null,
          tier?: Tier | null,
          proxyUserID?: string | null,
          premiumPolls?: number | null,
          usedPremiumPolls?: number | null,
          cryptowallet?: string | null,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    voteResults?:  {
      __typename: "ModelVoteResultConnection",
      items:  Array< {
        __typename: "VoteResult",
        id: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        count: number,
        subPollID?: string | null,
        pollID: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    companyTheme?:  {
      __typename: "CompanyTheme",
      id: string,
      companyID: string,
      attributes?:  {
        __typename: "CustomThemeAttribute",
        pollActivePeriodBgColor?: string | null,
        pollActivePeriodShadowColor?: string | null,
        pollQuestionCardBgColor?: string | null,
        pollQuestionCardQuestionColor?: string | null,
        pollQuestionCardAnswerColor?: string | null,
        pollPledgeCastBtnBgColor?: string | null,
        pollPledgeCastBtnBracketColor?: string | null,
        pollPledgeCastBtnTextColor?: string | null,
        pollPageBgColor?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      domain: string,
      owner?: string | null,
      status?: CompanyStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    postalsGRC?:  {
      __typename: "ModelPostalInfoConnection",
      items:  Array< {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    postalsDivision?:  {
      __typename: "ModelPostalInfoConnection",
      items:  Array< {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeletePollMutationVariables = {
  input: DeletePollInput,
  condition?: ModelPollConditionInput | null,
};

export type DeletePollMutation = {
  deletePoll?:  {
    __typename: "Poll",
    id: string,
    title: string,
    question: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    status?: PollStatus | null,
    options?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    drawOptions?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    hasPledge?: boolean | null,
    isGroup?: boolean | null,
    featured?: boolean | null,
    winOption?:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } | null,
    startTime: string,
    endTime: string,
    pledgePeriod1StartTime?: string | null,
    pledgePeriod1EndTime?: string | null,
    pledgePeriod2StartTime?: string | null,
    pledgePeriod2EndTime?: string | null,
    owner?: string | null,
    password?: string | null,
    grc?: string | null,
    division?: string | null,
    createdAt: string,
    private?: number | null,
    companyID?: string | null,
    themeID?: string | null,
    representativeID?: string | null,
    isPremium?: boolean | null,
    maxVote?: number | null,
    isNotExact?: boolean | null,
    category?: string | null,
    hashtag?: Array< string | null > | null,
    updatedAt: string,
    comments?:  {
      __typename: "ModelPollCommentConnection",
      items:  Array< {
        __typename: "PollComment",
        id: string,
        pollID: string,
        userID: string,
        content: string,
        avatar?: string | null,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    votes?:  {
      __typename: "ModelVoteConnection",
      items:  Array< {
        __typename: "Vote",
        id: string,
        userID: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        type: VoteType,
        subPollID?: string | null,
        reason?: string | null,
        pollID: string,
        proxyUserID?: string | null,
        createdAt: string,
        updatedAt: string,
        poll?:  {
          __typename: "Poll",
          id: string,
          title: string,
          question: string,
          description?: string | null,
          video?: string | null,
          status?: PollStatus | null,
          hasPledge?: boolean | null,
          isGroup?: boolean | null,
          featured?: boolean | null,
          startTime: string,
          endTime: string,
          pledgePeriod1StartTime?: string | null,
          pledgePeriod1EndTime?: string | null,
          pledgePeriod2StartTime?: string | null,
          pledgePeriod2EndTime?: string | null,
          owner?: string | null,
          password?: string | null,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          private?: number | null,
          companyID?: string | null,
          themeID?: string | null,
          representativeID?: string | null,
          isPremium?: boolean | null,
          maxVote?: number | null,
          isNotExact?: boolean | null,
          category?: string | null,
          hashtag?: Array< string | null > | null,
          updatedAt: string,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          email?: string | null,
          username?: string | null,
          owner?: string | null,
          phone?: string | null,
          type?: UserType | null,
          disable?: boolean | null,
          firstName?: string | null,
          lastName?: string | null,
          yearOfBirth?: number | null,
          gender?: string | null,
          education?: string | null,
          postalCode?: string | null,
          salaryRange?: UserSalaryRange | null,
          company?: string | null,
          createdAt: string,
          isSetup?: boolean | null,
          tier?: Tier | null,
          proxyUserID?: string | null,
          premiumPolls?: number | null,
          usedPremiumPolls?: number | null,
          cryptowallet?: string | null,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    voteResults?:  {
      __typename: "ModelVoteResultConnection",
      items:  Array< {
        __typename: "VoteResult",
        id: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        count: number,
        subPollID?: string | null,
        pollID: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    companyTheme?:  {
      __typename: "CompanyTheme",
      id: string,
      companyID: string,
      attributes?:  {
        __typename: "CustomThemeAttribute",
        pollActivePeriodBgColor?: string | null,
        pollActivePeriodShadowColor?: string | null,
        pollQuestionCardBgColor?: string | null,
        pollQuestionCardQuestionColor?: string | null,
        pollQuestionCardAnswerColor?: string | null,
        pollPledgeCastBtnBgColor?: string | null,
        pollPledgeCastBtnBracketColor?: string | null,
        pollPledgeCastBtnTextColor?: string | null,
        pollPageBgColor?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      domain: string,
      owner?: string | null,
      status?: CompanyStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    postalsGRC?:  {
      __typename: "ModelPostalInfoConnection",
      items:  Array< {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    postalsDivision?:  {
      __typename: "ModelPostalInfoConnection",
      items:  Array< {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateSubPollMutationVariables = {
  input: CreateSubPollInput,
  condition?: ModelSubPollConditionInput | null,
};

export type CreateSubPollMutation = {
  createSubPoll?:  {
    __typename: "SubPoll",
    id: string,
    pollID?: string | null,
    title?: string | null,
    question: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    status?: PollStatus | null,
    options?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    winOption?:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } | null,
    owner?: string | null,
    createdAt: string,
    orderID: number,
    private: number,
    maxVote?: number | null,
    isNotExact?: boolean | null,
    updatedAt: string,
    votes?:  {
      __typename: "ModelVoteConnection",
      items:  Array< {
        __typename: "Vote",
        id: string,
        userID: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        type: VoteType,
        subPollID?: string | null,
        reason?: string | null,
        pollID: string,
        proxyUserID?: string | null,
        createdAt: string,
        updatedAt: string,
        poll?:  {
          __typename: "Poll",
          id: string,
          title: string,
          question: string,
          description?: string | null,
          video?: string | null,
          status?: PollStatus | null,
          hasPledge?: boolean | null,
          isGroup?: boolean | null,
          featured?: boolean | null,
          startTime: string,
          endTime: string,
          pledgePeriod1StartTime?: string | null,
          pledgePeriod1EndTime?: string | null,
          pledgePeriod2StartTime?: string | null,
          pledgePeriod2EndTime?: string | null,
          owner?: string | null,
          password?: string | null,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          private?: number | null,
          companyID?: string | null,
          themeID?: string | null,
          representativeID?: string | null,
          isPremium?: boolean | null,
          maxVote?: number | null,
          isNotExact?: boolean | null,
          category?: string | null,
          hashtag?: Array< string | null > | null,
          updatedAt: string,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          email?: string | null,
          username?: string | null,
          owner?: string | null,
          phone?: string | null,
          type?: UserType | null,
          disable?: boolean | null,
          firstName?: string | null,
          lastName?: string | null,
          yearOfBirth?: number | null,
          gender?: string | null,
          education?: string | null,
          postalCode?: string | null,
          salaryRange?: UserSalaryRange | null,
          company?: string | null,
          createdAt: string,
          isSetup?: boolean | null,
          tier?: Tier | null,
          proxyUserID?: string | null,
          premiumPolls?: number | null,
          usedPremiumPolls?: number | null,
          cryptowallet?: string | null,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    voteResults?:  {
      __typename: "ModelVoteResultConnection",
      items:  Array< {
        __typename: "VoteResult",
        id: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        count: number,
        subPollID?: string | null,
        pollID: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateSubPollMutationVariables = {
  input: UpdateSubPollInput,
  condition?: ModelSubPollConditionInput | null,
};

export type UpdateSubPollMutation = {
  updateSubPoll?:  {
    __typename: "SubPoll",
    id: string,
    pollID?: string | null,
    title?: string | null,
    question: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    status?: PollStatus | null,
    options?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    winOption?:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } | null,
    owner?: string | null,
    createdAt: string,
    orderID: number,
    private: number,
    maxVote?: number | null,
    isNotExact?: boolean | null,
    updatedAt: string,
    votes?:  {
      __typename: "ModelVoteConnection",
      items:  Array< {
        __typename: "Vote",
        id: string,
        userID: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        type: VoteType,
        subPollID?: string | null,
        reason?: string | null,
        pollID: string,
        proxyUserID?: string | null,
        createdAt: string,
        updatedAt: string,
        poll?:  {
          __typename: "Poll",
          id: string,
          title: string,
          question: string,
          description?: string | null,
          video?: string | null,
          status?: PollStatus | null,
          hasPledge?: boolean | null,
          isGroup?: boolean | null,
          featured?: boolean | null,
          startTime: string,
          endTime: string,
          pledgePeriod1StartTime?: string | null,
          pledgePeriod1EndTime?: string | null,
          pledgePeriod2StartTime?: string | null,
          pledgePeriod2EndTime?: string | null,
          owner?: string | null,
          password?: string | null,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          private?: number | null,
          companyID?: string | null,
          themeID?: string | null,
          representativeID?: string | null,
          isPremium?: boolean | null,
          maxVote?: number | null,
          isNotExact?: boolean | null,
          category?: string | null,
          hashtag?: Array< string | null > | null,
          updatedAt: string,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          email?: string | null,
          username?: string | null,
          owner?: string | null,
          phone?: string | null,
          type?: UserType | null,
          disable?: boolean | null,
          firstName?: string | null,
          lastName?: string | null,
          yearOfBirth?: number | null,
          gender?: string | null,
          education?: string | null,
          postalCode?: string | null,
          salaryRange?: UserSalaryRange | null,
          company?: string | null,
          createdAt: string,
          isSetup?: boolean | null,
          tier?: Tier | null,
          proxyUserID?: string | null,
          premiumPolls?: number | null,
          usedPremiumPolls?: number | null,
          cryptowallet?: string | null,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    voteResults?:  {
      __typename: "ModelVoteResultConnection",
      items:  Array< {
        __typename: "VoteResult",
        id: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        count: number,
        subPollID?: string | null,
        pollID: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteSubPollMutationVariables = {
  input: DeleteSubPollInput,
  condition?: ModelSubPollConditionInput | null,
};

export type DeleteSubPollMutation = {
  deleteSubPoll?:  {
    __typename: "SubPoll",
    id: string,
    pollID?: string | null,
    title?: string | null,
    question: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    status?: PollStatus | null,
    options?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    winOption?:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } | null,
    owner?: string | null,
    createdAt: string,
    orderID: number,
    private: number,
    maxVote?: number | null,
    isNotExact?: boolean | null,
    updatedAt: string,
    votes?:  {
      __typename: "ModelVoteConnection",
      items:  Array< {
        __typename: "Vote",
        id: string,
        userID: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        type: VoteType,
        subPollID?: string | null,
        reason?: string | null,
        pollID: string,
        proxyUserID?: string | null,
        createdAt: string,
        updatedAt: string,
        poll?:  {
          __typename: "Poll",
          id: string,
          title: string,
          question: string,
          description?: string | null,
          video?: string | null,
          status?: PollStatus | null,
          hasPledge?: boolean | null,
          isGroup?: boolean | null,
          featured?: boolean | null,
          startTime: string,
          endTime: string,
          pledgePeriod1StartTime?: string | null,
          pledgePeriod1EndTime?: string | null,
          pledgePeriod2StartTime?: string | null,
          pledgePeriod2EndTime?: string | null,
          owner?: string | null,
          password?: string | null,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          private?: number | null,
          companyID?: string | null,
          themeID?: string | null,
          representativeID?: string | null,
          isPremium?: boolean | null,
          maxVote?: number | null,
          isNotExact?: boolean | null,
          category?: string | null,
          hashtag?: Array< string | null > | null,
          updatedAt: string,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          email?: string | null,
          username?: string | null,
          owner?: string | null,
          phone?: string | null,
          type?: UserType | null,
          disable?: boolean | null,
          firstName?: string | null,
          lastName?: string | null,
          yearOfBirth?: number | null,
          gender?: string | null,
          education?: string | null,
          postalCode?: string | null,
          salaryRange?: UserSalaryRange | null,
          company?: string | null,
          createdAt: string,
          isSetup?: boolean | null,
          tier?: Tier | null,
          proxyUserID?: string | null,
          premiumPolls?: number | null,
          usedPremiumPolls?: number | null,
          cryptowallet?: string | null,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    voteResults?:  {
      __typename: "ModelVoteResultConnection",
      items:  Array< {
        __typename: "VoteResult",
        id: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        count: number,
        subPollID?: string | null,
        pollID: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateVoteMutationVariables = {
  input: CreateVoteInput,
  condition?: ModelVoteConditionInput | null,
};

export type CreateVoteMutation = {
  createVote?:  {
    __typename: "Vote",
    id: string,
    userID: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    type: VoteType,
    subPollID?: string | null,
    reason?: string | null,
    pollID: string,
    proxyUserID?: string | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type UpdateVoteMutationVariables = {
  input: UpdateVoteInput,
  condition?: ModelVoteConditionInput | null,
};

export type UpdateVoteMutation = {
  updateVote?:  {
    __typename: "Vote",
    id: string,
    userID: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    type: VoteType,
    subPollID?: string | null,
    reason?: string | null,
    pollID: string,
    proxyUserID?: string | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type DeleteVoteMutationVariables = {
  input: DeleteVoteInput,
  condition?: ModelVoteConditionInput | null,
};

export type DeleteVoteMutation = {
  deleteVote?:  {
    __typename: "Vote",
    id: string,
    userID: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    type: VoteType,
    subPollID?: string | null,
    reason?: string | null,
    pollID: string,
    proxyUserID?: string | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type CreateHotPollMutationVariables = {
  input: CreateHotPollInput,
  condition?: ModelHotPollConditionInput | null,
};

export type CreateHotPollMutation = {
  createHotPoll?:  {
    __typename: "HotPoll",
    id: string,
    pollID: string,
    count: number,
    status: HotPollStatus,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateHotPollMutationVariables = {
  input: UpdateHotPollInput,
  condition?: ModelHotPollConditionInput | null,
};

export type UpdateHotPollMutation = {
  updateHotPoll?:  {
    __typename: "HotPoll",
    id: string,
    pollID: string,
    count: number,
    status: HotPollStatus,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteHotPollMutationVariables = {
  input: DeleteHotPollInput,
  condition?: ModelHotPollConditionInput | null,
};

export type DeleteHotPollMutation = {
  deleteHotPoll?:  {
    __typename: "HotPoll",
    id: string,
    pollID: string,
    count: number,
    status: HotPollStatus,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateHotPledgeMutationVariables = {
  input: CreateHotPledgeInput,
  condition?: ModelHotPledgeConditionInput | null,
};

export type CreateHotPledgeMutation = {
  createHotPledge?:  {
    __typename: "HotPledge",
    id: string,
    pollID: string,
    count: number,
    status: HotPollStatus,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdateHotPledgeMutationVariables = {
  input: UpdateHotPledgeInput,
  condition?: ModelHotPledgeConditionInput | null,
};

export type UpdateHotPledgeMutation = {
  updateHotPledge?:  {
    __typename: "HotPledge",
    id: string,
    pollID: string,
    count: number,
    status: HotPollStatus,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeleteHotPledgeMutationVariables = {
  input: DeleteHotPledgeInput,
  condition?: ModelHotPledgeConditionInput | null,
};

export type DeleteHotPledgeMutation = {
  deleteHotPledge?:  {
    __typename: "HotPledge",
    id: string,
    pollID: string,
    count: number,
    status: HotPollStatus,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreateVoteResultMutationVariables = {
  input: CreateVoteResultInput,
  condition?: ModelVoteResultConditionInput | null,
};

export type CreateVoteResultMutation = {
  createVoteResult?:  {
    __typename: "VoteResult",
    id: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    count: number,
    subPollID?: string | null,
    pollID: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateVoteResultMutationVariables = {
  input: UpdateVoteResultInput,
  condition?: ModelVoteResultConditionInput | null,
};

export type UpdateVoteResultMutation = {
  updateVoteResult?:  {
    __typename: "VoteResult",
    id: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    count: number,
    subPollID?: string | null,
    pollID: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteVoteResultMutationVariables = {
  input: DeleteVoteResultInput,
  condition?: ModelVoteResultConditionInput | null,
};

export type DeleteVoteResultMutation = {
  deleteVoteResult?:  {
    __typename: "VoteResult",
    id: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    count: number,
    subPollID?: string | null,
    pollID: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreatePledgeMutationVariables = {
  input: CreatePledgeInput,
  condition?: ModelPledgeConditionInput | null,
};

export type CreatePledgeMutation = {
  createPledge?:  {
    __typename: "Pledge",
    id: string,
    userID: string,
    type: PledgeType,
    pollID: string,
    reason?: string | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type UpdatePledgeMutationVariables = {
  input: UpdatePledgeInput,
  condition?: ModelPledgeConditionInput | null,
};

export type UpdatePledgeMutation = {
  updatePledge?:  {
    __typename: "Pledge",
    id: string,
    userID: string,
    type: PledgeType,
    pollID: string,
    reason?: string | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type DeletePledgeMutationVariables = {
  input: DeletePledgeInput,
  condition?: ModelPledgeConditionInput | null,
};

export type DeletePledgeMutation = {
  deletePledge?:  {
    __typename: "Pledge",
    id: string,
    userID: string,
    type: PledgeType,
    pollID: string,
    reason?: string | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type CreatePledgeResultMutationVariables = {
  input: CreatePledgeResultInput,
  condition?: ModelPledgeResultConditionInput | null,
};

export type CreatePledgeResultMutation = {
  createPledgeResult?:  {
    __typename: "PledgeResult",
    id: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    count: number,
    pollID: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdatePledgeResultMutationVariables = {
  input: UpdatePledgeResultInput,
  condition?: ModelPledgeResultConditionInput | null,
};

export type UpdatePledgeResultMutation = {
  updatePledgeResult?:  {
    __typename: "PledgeResult",
    id: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    count: number,
    pollID: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeletePledgeResultMutationVariables = {
  input: DeletePledgeResultInput,
  condition?: ModelPledgeResultConditionInput | null,
};

export type DeletePledgeResultMutation = {
  deletePledgeResult?:  {
    __typename: "PledgeResult",
    id: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    count: number,
    pollID: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreatePollReportMutationVariables = {
  input: CreatePollReportInput,
  condition?: ModelPollReportConditionInput | null,
};

export type CreatePollReportMutation = {
  createPollReport?:  {
    __typename: "PollReport",
    id: string,
    title: string,
    description: string,
    pollID: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePollReportMutationVariables = {
  input: UpdatePollReportInput,
  condition?: ModelPollReportConditionInput | null,
};

export type UpdatePollReportMutation = {
  updatePollReport?:  {
    __typename: "PollReport",
    id: string,
    title: string,
    description: string,
    pollID: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePollReportMutationVariables = {
  input: DeletePollReportInput,
  condition?: ModelPollReportConditionInput | null,
};

export type DeletePollReportMutation = {
  deletePollReport?:  {
    __typename: "PollReport",
    id: string,
    title: string,
    description: string,
    pollID: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePackageSubscriptionMutationVariables = {
  input: CreatePackageSubscriptionInput,
  condition?: ModelPackageSubscriptionConditionInput | null,
};

export type CreatePackageSubscriptionMutation = {
  createPackageSubscription?:  {
    __typename: "PackageSubscription",
    id: string,
    tier: Tier,
    price?: string | null,
    stripePriceID?: string | null,
    pollOptionLimit?: number | null,
    groupPollAllowed?: boolean | null,
    groupPollLimit?: number | null,
    pledgeAllowed?: boolean | null,
    pledgeChargePercentage?: string | null,
    pollDurationLimit?: string | null,
    pollResultLiveAllowed?: boolean | null,
    statisticReportAllowed?: boolean | null,
    withdrawalAllowed?: boolean | null,
    extensionPledgeAllowed?: boolean | null,
    noOfPolls?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePackageSubscriptionMutationVariables = {
  input: UpdatePackageSubscriptionInput,
  condition?: ModelPackageSubscriptionConditionInput | null,
};

export type UpdatePackageSubscriptionMutation = {
  updatePackageSubscription?:  {
    __typename: "PackageSubscription",
    id: string,
    tier: Tier,
    price?: string | null,
    stripePriceID?: string | null,
    pollOptionLimit?: number | null,
    groupPollAllowed?: boolean | null,
    groupPollLimit?: number | null,
    pledgeAllowed?: boolean | null,
    pledgeChargePercentage?: string | null,
    pollDurationLimit?: string | null,
    pollResultLiveAllowed?: boolean | null,
    statisticReportAllowed?: boolean | null,
    withdrawalAllowed?: boolean | null,
    extensionPledgeAllowed?: boolean | null,
    noOfPolls?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePackageSubscriptionMutationVariables = {
  input: DeletePackageSubscriptionInput,
  condition?: ModelPackageSubscriptionConditionInput | null,
};

export type DeletePackageSubscriptionMutation = {
  deletePackageSubscription?:  {
    __typename: "PackageSubscription",
    id: string,
    tier: Tier,
    price?: string | null,
    stripePriceID?: string | null,
    pollOptionLimit?: number | null,
    groupPollAllowed?: boolean | null,
    groupPollLimit?: number | null,
    pledgeAllowed?: boolean | null,
    pledgeChargePercentage?: string | null,
    pollDurationLimit?: string | null,
    pollResultLiveAllowed?: boolean | null,
    statisticReportAllowed?: boolean | null,
    withdrawalAllowed?: boolean | null,
    extensionPledgeAllowed?: boolean | null,
    noOfPolls?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    id: string,
    email?: string | null,
    username?: string | null,
    owner?: string | null,
    phone?: string | null,
    type?: UserType | null,
    disable?: boolean | null,
    firstName?: string | null,
    lastName?: string | null,
    yearOfBirth?: number | null,
    gender?: string | null,
    education?: string | null,
    postalCode?: string | null,
    salaryRange?: UserSalaryRange | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    company?: string | null,
    createdAt: string,
    organisation?:  {
      __typename: "OrganisationInfo",
      name?: string | null,
      department?: string | null,
      jobTitle?: string | null,
    } | null,
    isSetup?: boolean | null,
    tier?: Tier | null,
    proxyUserID?: string | null,
    premiumPolls?: number | null,
    usedPremiumPolls?: number | null,
    cryptowallet?: string | null,
    updatedAt: string,
    postalInfo?:  {
      __typename: "PostalInfo",
      postal: string,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    id: string,
    email?: string | null,
    username?: string | null,
    owner?: string | null,
    phone?: string | null,
    type?: UserType | null,
    disable?: boolean | null,
    firstName?: string | null,
    lastName?: string | null,
    yearOfBirth?: number | null,
    gender?: string | null,
    education?: string | null,
    postalCode?: string | null,
    salaryRange?: UserSalaryRange | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    company?: string | null,
    createdAt: string,
    organisation?:  {
      __typename: "OrganisationInfo",
      name?: string | null,
      department?: string | null,
      jobTitle?: string | null,
    } | null,
    isSetup?: boolean | null,
    tier?: Tier | null,
    proxyUserID?: string | null,
    premiumPolls?: number | null,
    usedPremiumPolls?: number | null,
    cryptowallet?: string | null,
    updatedAt: string,
    postalInfo?:  {
      __typename: "PostalInfo",
      postal: string,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    id: string,
    email?: string | null,
    username?: string | null,
    owner?: string | null,
    phone?: string | null,
    type?: UserType | null,
    disable?: boolean | null,
    firstName?: string | null,
    lastName?: string | null,
    yearOfBirth?: number | null,
    gender?: string | null,
    education?: string | null,
    postalCode?: string | null,
    salaryRange?: UserSalaryRange | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    company?: string | null,
    createdAt: string,
    organisation?:  {
      __typename: "OrganisationInfo",
      name?: string | null,
      department?: string | null,
      jobTitle?: string | null,
    } | null,
    isSetup?: boolean | null,
    tier?: Tier | null,
    proxyUserID?: string | null,
    premiumPolls?: number | null,
    usedPremiumPolls?: number | null,
    cryptowallet?: string | null,
    updatedAt: string,
    postalInfo?:  {
      __typename: "PostalInfo",
      postal: string,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type CreateCompanyUserMutationVariables = {
  input: CreateCompanyUserInput,
  condition?: ModelCompanyUserConditionInput | null,
};

export type CreateCompanyUserMutation = {
  createCompanyUser?:  {
    __typename: "CompanyUser",
    id: string,
    userID: string,
    username: string,
    companyID: string,
    adminID: string,
    role: CompanyRole,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type UpdateCompanyUserMutationVariables = {
  input: UpdateCompanyUserInput,
  condition?: ModelCompanyUserConditionInput | null,
};

export type UpdateCompanyUserMutation = {
  updateCompanyUser?:  {
    __typename: "CompanyUser",
    id: string,
    userID: string,
    username: string,
    companyID: string,
    adminID: string,
    role: CompanyRole,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type DeleteCompanyUserMutationVariables = {
  input: DeleteCompanyUserInput,
  condition?: ModelCompanyUserConditionInput | null,
};

export type DeleteCompanyUserMutation = {
  deleteCompanyUser?:  {
    __typename: "CompanyUser",
    id: string,
    userID: string,
    username: string,
    companyID: string,
    adminID: string,
    role: CompanyRole,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type CreateCompanyThemeMutationVariables = {
  input: CreateCompanyThemeInput,
  condition?: ModelCompanyThemeConditionInput | null,
};

export type CreateCompanyThemeMutation = {
  createCompanyTheme?:  {
    __typename: "CompanyTheme",
    id: string,
    companyID: string,
    attributes?:  {
      __typename: "CustomThemeAttribute",
      pollActivePeriodBgColor?: string | null,
      pollActivePeriodShadowColor?: string | null,
      pollQuestionCardBgColor?: string | null,
      pollQuestionCardQuestionColor?: string | null,
      pollQuestionCardAnswerColor?: string | null,
      pollPledgeCastBtnBgColor?: string | null,
      pollPledgeCastBtnBracketColor?: string | null,
      pollPledgeCastBtnTextColor?: string | null,
      pollPageBgColor?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateCompanyThemeMutationVariables = {
  input: UpdateCompanyThemeInput,
  condition?: ModelCompanyThemeConditionInput | null,
};

export type UpdateCompanyThemeMutation = {
  updateCompanyTheme?:  {
    __typename: "CompanyTheme",
    id: string,
    companyID: string,
    attributes?:  {
      __typename: "CustomThemeAttribute",
      pollActivePeriodBgColor?: string | null,
      pollActivePeriodShadowColor?: string | null,
      pollQuestionCardBgColor?: string | null,
      pollQuestionCardQuestionColor?: string | null,
      pollQuestionCardAnswerColor?: string | null,
      pollPledgeCastBtnBgColor?: string | null,
      pollPledgeCastBtnBracketColor?: string | null,
      pollPledgeCastBtnTextColor?: string | null,
      pollPageBgColor?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteCompanyThemeMutationVariables = {
  input: DeleteCompanyThemeInput,
  condition?: ModelCompanyThemeConditionInput | null,
};

export type DeleteCompanyThemeMutation = {
  deleteCompanyTheme?:  {
    __typename: "CompanyTheme",
    id: string,
    companyID: string,
    attributes?:  {
      __typename: "CustomThemeAttribute",
      pollActivePeriodBgColor?: string | null,
      pollActivePeriodShadowColor?: string | null,
      pollQuestionCardBgColor?: string | null,
      pollQuestionCardQuestionColor?: string | null,
      pollQuestionCardAnswerColor?: string | null,
      pollPledgeCastBtnBgColor?: string | null,
      pollPledgeCastBtnBracketColor?: string | null,
      pollPledgeCastBtnTextColor?: string | null,
      pollPageBgColor?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateCompanyMutationVariables = {
  input: CreateCompanyInput,
  condition?: ModelCompanyConditionInput | null,
};

export type CreateCompanyMutation = {
  createCompany?:  {
    __typename: "Company",
    id: string,
    name: string,
    domain: string,
    owner?: string | null,
    status?: CompanyStatus | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCompanyMutationVariables = {
  input: UpdateCompanyInput,
  condition?: ModelCompanyConditionInput | null,
};

export type UpdateCompanyMutation = {
  updateCompany?:  {
    __typename: "Company",
    id: string,
    name: string,
    domain: string,
    owner?: string | null,
    status?: CompanyStatus | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCompanyMutationVariables = {
  input: DeleteCompanyInput,
  condition?: ModelCompanyConditionInput | null,
};

export type DeleteCompanyMutation = {
  deleteCompany?:  {
    __typename: "Company",
    id: string,
    name: string,
    domain: string,
    owner?: string | null,
    status?: CompanyStatus | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCompanyDomainMutationVariables = {
  input: CreateCompanyDomainInput,
  condition?: ModelCompanyDomainConditionInput | null,
};

export type CreateCompanyDomainMutation = {
  createCompanyDomain?:  {
    __typename: "CompanyDomain",
    id: string,
    companyID: string,
    domain: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateCompanyDomainMutationVariables = {
  input: UpdateCompanyDomainInput,
  condition?: ModelCompanyDomainConditionInput | null,
};

export type UpdateCompanyDomainMutation = {
  updateCompanyDomain?:  {
    __typename: "CompanyDomain",
    id: string,
    companyID: string,
    domain: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteCompanyDomainMutationVariables = {
  input: DeleteCompanyDomainInput,
  condition?: ModelCompanyDomainConditionInput | null,
};

export type DeleteCompanyDomainMutation = {
  deleteCompanyDomain?:  {
    __typename: "CompanyDomain",
    id: string,
    companyID: string,
    domain: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateRequestJoinCompanyMutationVariables = {
  input: CreateRequestJoinCompanyInput,
  condition?: ModelRequestJoinCompanyConditionInput | null,
};

export type CreateRequestJoinCompanyMutation = {
  createRequestJoinCompany?:  {
    __typename: "RequestJoinCompany",
    id: string,
    userID: string,
    companyID: string,
    status: RequestJoinCompanyStatus,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type UpdateRequestJoinCompanyMutationVariables = {
  input: UpdateRequestJoinCompanyInput,
  condition?: ModelRequestJoinCompanyConditionInput | null,
};

export type UpdateRequestJoinCompanyMutation = {
  updateRequestJoinCompany?:  {
    __typename: "RequestJoinCompany",
    id: string,
    userID: string,
    companyID: string,
    status: RequestJoinCompanyStatus,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type DeleteRequestJoinCompanyMutationVariables = {
  input: DeleteRequestJoinCompanyInput,
  condition?: ModelRequestJoinCompanyConditionInput | null,
};

export type DeleteRequestJoinCompanyMutation = {
  deleteRequestJoinCompany?:  {
    __typename: "RequestJoinCompany",
    id: string,
    userID: string,
    companyID: string,
    status: RequestJoinCompanyStatus,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type CreateAlertMutationVariables = {
  input: CreateAlertInput,
  condition?: ModelAlertConditionInput | null,
};

export type CreateAlertMutation = {
  createAlert?:  {
    __typename: "Alert",
    id: string,
    title?: string | null,
    detail?: string | null,
    pollID?: string | null,
    message?: string | null,
    type: AlertType,
    createdAt: string,
    userID: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type UpdateAlertMutationVariables = {
  input: UpdateAlertInput,
  condition?: ModelAlertConditionInput | null,
};

export type UpdateAlertMutation = {
  updateAlert?:  {
    __typename: "Alert",
    id: string,
    title?: string | null,
    detail?: string | null,
    pollID?: string | null,
    message?: string | null,
    type: AlertType,
    createdAt: string,
    userID: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type DeleteAlertMutationVariables = {
  input: DeleteAlertInput,
  condition?: ModelAlertConditionInput | null,
};

export type DeleteAlertMutation = {
  deleteAlert?:  {
    __typename: "Alert",
    id: string,
    title?: string | null,
    detail?: string | null,
    pollID?: string | null,
    message?: string | null,
    type: AlertType,
    createdAt: string,
    userID: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type CreateStripeAccountMutationVariables = {
  input: CreateStripeAccountInput,
  condition?: ModelStripeAccountConditionInput | null,
};

export type CreateStripeAccountMutation = {
  createStripeAccount?:  {
    __typename: "StripeAccount",
    id: string,
    userID: string,
    isOnboard: boolean,
    createdAt: string,
    amount?: string | null,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateStripeAccountMutationVariables = {
  input: UpdateStripeAccountInput,
  condition?: ModelStripeAccountConditionInput | null,
};

export type UpdateStripeAccountMutation = {
  updateStripeAccount?:  {
    __typename: "StripeAccount",
    id: string,
    userID: string,
    isOnboard: boolean,
    createdAt: string,
    amount?: string | null,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteStripeAccountMutationVariables = {
  input: DeleteStripeAccountInput,
  condition?: ModelStripeAccountConditionInput | null,
};

export type DeleteStripeAccountMutation = {
  deleteStripeAccount?:  {
    __typename: "StripeAccount",
    id: string,
    userID: string,
    isOnboard: boolean,
    createdAt: string,
    amount?: string | null,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateStripeCustomerMutationVariables = {
  input: CreateStripeCustomerInput,
  condition?: ModelStripeCustomerConditionInput | null,
};

export type CreateStripeCustomerMutation = {
  createStripeCustomer?:  {
    __typename: "StripeCustomer",
    id: string,
    userID: string,
    createdAt: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateStripeCustomerMutationVariables = {
  input: UpdateStripeCustomerInput,
  condition?: ModelStripeCustomerConditionInput | null,
};

export type UpdateStripeCustomerMutation = {
  updateStripeCustomer?:  {
    __typename: "StripeCustomer",
    id: string,
    userID: string,
    createdAt: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteStripeCustomerMutationVariables = {
  input: DeleteStripeCustomerInput,
  condition?: ModelStripeCustomerConditionInput | null,
};

export type DeleteStripeCustomerMutation = {
  deleteStripeCustomer?:  {
    __typename: "StripeCustomer",
    id: string,
    userID: string,
    createdAt: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateStripeChargeMutationVariables = {
  input: CreateStripeChargeInput,
  condition?: ModelStripeChargeConditionInput | null,
};

export type CreateStripeChargeMutation = {
  createStripeCharge?:  {
    __typename: "StripeCharge",
    id: string,
    userID: string,
    pollID: string,
    chargeID: string,
    status: StripeChargeStatus,
    amount: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateStripeChargeMutationVariables = {
  input: UpdateStripeChargeInput,
  condition?: ModelStripeChargeConditionInput | null,
};

export type UpdateStripeChargeMutation = {
  updateStripeCharge?:  {
    __typename: "StripeCharge",
    id: string,
    userID: string,
    pollID: string,
    chargeID: string,
    status: StripeChargeStatus,
    amount: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteStripeChargeMutationVariables = {
  input: DeleteStripeChargeInput,
  condition?: ModelStripeChargeConditionInput | null,
};

export type DeleteStripeChargeMutation = {
  deleteStripeCharge?:  {
    __typename: "StripeCharge",
    id: string,
    userID: string,
    pollID: string,
    chargeID: string,
    status: StripeChargeStatus,
    amount: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateStripeSubscriptionMutationVariables = {
  input: CreateStripeSubscriptionInput,
  condition?: ModelStripeSubscriptionConditionInput | null,
};

export type CreateStripeSubscriptionMutation = {
  createStripeSubscription?:  {
    __typename: "StripeSubscription",
    id: string,
    subscriptionID: string,
    customerID: string,
    userID: string,
    tier: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateStripeSubscriptionMutationVariables = {
  input: UpdateStripeSubscriptionInput,
  condition?: ModelStripeSubscriptionConditionInput | null,
};

export type UpdateStripeSubscriptionMutation = {
  updateStripeSubscription?:  {
    __typename: "StripeSubscription",
    id: string,
    subscriptionID: string,
    customerID: string,
    userID: string,
    tier: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteStripeSubscriptionMutationVariables = {
  input: DeleteStripeSubscriptionInput,
  condition?: ModelStripeSubscriptionConditionInput | null,
};

export type DeleteStripeSubscriptionMutation = {
  deleteStripeSubscription?:  {
    __typename: "StripeSubscription",
    id: string,
    subscriptionID: string,
    customerID: string,
    userID: string,
    tier: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateProxyPollMutationVariables = {
  input: CreateProxyPollInput,
  condition?: ModelProxyPollConditionInput | null,
};

export type CreateProxyPollMutation = {
  createProxyPoll?:  {
    __typename: "ProxyPoll",
    id: string,
    proxyUserID: string,
    pollID: string,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type UpdateProxyPollMutationVariables = {
  input: UpdateProxyPollInput,
  condition?: ModelProxyPollConditionInput | null,
};

export type UpdateProxyPollMutation = {
  updateProxyPoll?:  {
    __typename: "ProxyPoll",
    id: string,
    proxyUserID: string,
    pollID: string,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type DeleteProxyPollMutationVariables = {
  input: DeleteProxyPollInput,
  condition?: ModelProxyPollConditionInput | null,
};

export type DeleteProxyPollMutation = {
  deleteProxyPoll?:  {
    __typename: "ProxyPoll",
    id: string,
    proxyUserID: string,
    pollID: string,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type CreateDefaultConfigurationMutationVariables = {
  input: CreateDefaultConfigurationInput,
  condition?: ModelDefaultConfigurationConditionInput | null,
};

export type CreateDefaultConfigurationMutation = {
  createDefaultConfiguration?:  {
    __typename: "DefaultConfiguration",
    id: string,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    pollImage?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateDefaultConfigurationMutationVariables = {
  input: UpdateDefaultConfigurationInput,
  condition?: ModelDefaultConfigurationConditionInput | null,
};

export type UpdateDefaultConfigurationMutation = {
  updateDefaultConfiguration?:  {
    __typename: "DefaultConfiguration",
    id: string,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    pollImage?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteDefaultConfigurationMutationVariables = {
  input: DeleteDefaultConfigurationInput,
  condition?: ModelDefaultConfigurationConditionInput | null,
};

export type DeleteDefaultConfigurationMutation = {
  deleteDefaultConfiguration?:  {
    __typename: "DefaultConfiguration",
    id: string,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    pollImage?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateCustomConfigurationMutationVariables = {
  input: CreateCustomConfigurationInput,
  condition?: ModelCustomConfigurationConditionInput | null,
};

export type CreateCustomConfigurationMutation = {
  createCustomConfiguration?:  {
    __typename: "CustomConfiguration",
    id: string,
    companyID: string,
    field?: string | null,
    value?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateCustomConfigurationMutationVariables = {
  input: UpdateCustomConfigurationInput,
  condition?: ModelCustomConfigurationConditionInput | null,
};

export type UpdateCustomConfigurationMutation = {
  updateCustomConfiguration?:  {
    __typename: "CustomConfiguration",
    id: string,
    companyID: string,
    field?: string | null,
    value?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteCustomConfigurationMutationVariables = {
  input: DeleteCustomConfigurationInput,
  condition?: ModelCustomConfigurationConditionInput | null,
};

export type DeleteCustomConfigurationMutation = {
  deleteCustomConfiguration?:  {
    __typename: "CustomConfiguration",
    id: string,
    companyID: string,
    field?: string | null,
    value?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePollCountMutationVariables = {
  input: CreatePollCountInput,
  condition?: ModelPollCountConditionInput | null,
};

export type CreatePollCountMutation = {
  createPollCount?:  {
    __typename: "PollCount",
    id: string,
    count?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePollCountMutationVariables = {
  input: UpdatePollCountInput,
  condition?: ModelPollCountConditionInput | null,
};

export type UpdatePollCountMutation = {
  updatePollCount?:  {
    __typename: "PollCount",
    id: string,
    count?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePollCountMutationVariables = {
  input: DeletePollCountInput,
  condition?: ModelPollCountConditionInput | null,
};

export type DeletePollCountMutation = {
  deletePollCount?:  {
    __typename: "PollCount",
    id: string,
    count?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePopUpMutationVariables = {
  input: CreatePopUpInput,
  condition?: ModelPopUpConditionInput | null,
};

export type CreatePopUpMutation = {
  createPopUp?:  {
    __typename: "PopUp",
    id: string,
    status: PopUpStatus,
    type: PopUpType,
    pollID: string,
    updatedAt: string,
    createdAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type UpdatePopUpMutationVariables = {
  input: UpdatePopUpInput,
  condition?: ModelPopUpConditionInput | null,
};

export type UpdatePopUpMutation = {
  updatePopUp?:  {
    __typename: "PopUp",
    id: string,
    status: PopUpStatus,
    type: PopUpType,
    pollID: string,
    updatedAt: string,
    createdAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type DeletePopUpMutationVariables = {
  input: DeletePopUpInput,
  condition?: ModelPopUpConditionInput | null,
};

export type DeletePopUpMutation = {
  deletePopUp?:  {
    __typename: "PopUp",
    id: string,
    status: PopUpStatus,
    type: PopUpType,
    pollID: string,
    updatedAt: string,
    createdAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type CreatePostalInfoMutationVariables = {
  input: CreatePostalInfoInput,
  condition?: ModelPostalInfoConditionInput | null,
};

export type CreatePostalInfoMutation = {
  createPostalInfo?:  {
    __typename: "PostalInfo",
    postal: string,
    grc?: string | null,
    division?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatePostalInfoMutationVariables = {
  input: UpdatePostalInfoInput,
  condition?: ModelPostalInfoConditionInput | null,
};

export type UpdatePostalInfoMutation = {
  updatePostalInfo?:  {
    __typename: "PostalInfo",
    postal: string,
    grc?: string | null,
    division?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeletePostalInfoMutationVariables = {
  input: DeletePostalInfoInput,
  condition?: ModelPostalInfoConditionInput | null,
};

export type DeletePostalInfoMutation = {
  deletePostalInfo?:  {
    __typename: "PostalInfo",
    postal: string,
    grc?: string | null,
    division?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreatePremiumPollPurchaseMutationVariables = {
  input: CreatePremiumPollPurchaseInput,
  condition?: ModelPremiumPollPurchaseConditionInput | null,
};

export type CreatePremiumPollPurchaseMutation = {
  createPremiumPollPurchase?:  {
    __typename: "PremiumPollPurchase",
    id: string,
    userID: string,
    createdAt: string,
    amount?: string | null,
    chargeID?: string | null,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type UpdatePremiumPollPurchaseMutationVariables = {
  input: UpdatePremiumPollPurchaseInput,
  condition?: ModelPremiumPollPurchaseConditionInput | null,
};

export type UpdatePremiumPollPurchaseMutation = {
  updatePremiumPollPurchase?:  {
    __typename: "PremiumPollPurchase",
    id: string,
    userID: string,
    createdAt: string,
    amount?: string | null,
    chargeID?: string | null,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type DeletePremiumPollPurchaseMutationVariables = {
  input: DeletePremiumPollPurchaseInput,
  condition?: ModelPremiumPollPurchaseConditionInput | null,
};

export type DeletePremiumPollPurchaseMutation = {
  deletePremiumPollPurchase?:  {
    __typename: "PremiumPollPurchase",
    id: string,
    userID: string,
    createdAt: string,
    amount?: string | null,
    chargeID?: string | null,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type GetIdeaSummaryMutationVariables = {
  input?: GetIdeaSummaryInput | null,
};

export type GetIdeaSummaryMutation = {
  getIdeaSummary?: string | null,
};

export type SearchChatGPTMutationVariables = {
  input?: ChatGPTInput | null,
};

export type SearchChatGPTMutation = {
  searchChatGPT?: string | null,
};

export type CreateIdeaPledgeStripeChargeAPIMutationVariables = {
  input: CreateIdeaPledgeStripeChargeAPIInput,
};

export type CreateIdeaPledgeStripeChargeAPIMutation = {
  createIdeaPledgeStripeChargeAPI?: string | null,
};

export type GetGuestMutationVariables = {
  input?: GetGuest | null,
};

export type GetGuestMutation = {
  getGuest?: string | null,
};

export type AddPremiumPollCountMutationVariables = {
  input: AddPremiumPollCountInput,
};

export type AddPremiumPollCountMutation = {
  addPremiumPollCount?: string | null,
};

export type CanCreatePremiumPollMutationVariables = {
  input: CanCreatePremiumPollInput,
};

export type CanCreatePremiumPollMutation = {
  canCreatePremiumPoll?: string | null,
};

export type SyncVoteMutationVariables = {
  input: SyncVoteInput,
};

export type SyncVoteMutation = {
  syncVote?: string | null,
};

export type CreateStripeSubscriptionAPIMutationVariables = {
  input: CreateStripeSubscriptionAPIInput,
};

export type CreateStripeSubscriptionAPIMutation = {
  createStripeSubscriptionAPI?: string | null,
};

export type CreateChargeStripeAPIMutationVariables = {
  input: CreateChargeStripeAPIInput,
};

export type CreateChargeStripeAPIMutation = {
  createChargeStripeAPI?: string | null,
};

export type CreateRefundStripeAPIMutationVariables = {
  input: CreateRefundStripeAPIInput,
};

export type CreateRefundStripeAPIMutation = {
  createRefundStripeAPI?: string | null,
};

export type GetStripeSubscriptionAPIMutationVariables = {
  input: GetStripeSubscriptionAPIInput,
};

export type GetStripeSubscriptionAPIMutation = {
  getStripeSubscriptionAPI?: string | null,
};

export type CreateIdeaCategoryMutationVariables = {
  input: CreateIdeaCategoryInput,
  condition?: ModelIdeaCategoryConditionInput | null,
};

export type CreateIdeaCategoryMutation = {
  createIdeaCategory?:  {
    __typename: "IdeaCategory",
    id: string,
    title?: string | null,
    edu?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateIdeaCategoryMutationVariables = {
  input: UpdateIdeaCategoryInput,
  condition?: ModelIdeaCategoryConditionInput | null,
};

export type UpdateIdeaCategoryMutation = {
  updateIdeaCategory?:  {
    __typename: "IdeaCategory",
    id: string,
    title?: string | null,
    edu?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteIdeaCategoryMutationVariables = {
  input: DeleteIdeaCategoryInput,
  condition?: ModelIdeaCategoryConditionInput | null,
};

export type DeleteIdeaCategoryMutation = {
  deleteIdeaCategory?:  {
    __typename: "IdeaCategory",
    id: string,
    title?: string | null,
    edu?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateIdeaHashtagMutationVariables = {
  input: CreateIdeaHashtagInput,
  condition?: ModelIdeaHashtagConditionInput | null,
};

export type CreateIdeaHashtagMutation = {
  createIdeaHashtag?:  {
    __typename: "IdeaHashtag",
    id: string,
    title?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateIdeaHashtagMutationVariables = {
  input: UpdateIdeaHashtagInput,
  condition?: ModelIdeaHashtagConditionInput | null,
};

export type UpdateIdeaHashtagMutation = {
  updateIdeaHashtag?:  {
    __typename: "IdeaHashtag",
    id: string,
    title?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteIdeaHashtagMutationVariables = {
  input: DeleteIdeaHashtagInput,
  condition?: ModelIdeaHashtagConditionInput | null,
};

export type DeleteIdeaHashtagMutation = {
  deleteIdeaHashtag?:  {
    __typename: "IdeaHashtag",
    id: string,
    title?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateIdeaMutationVariables = {
  input: CreateIdeaInput,
  condition?: ModelIdeaConditionInput | null,
};

export type CreateIdeaMutation = {
  createIdea?:  {
    __typename: "Idea",
    id: string,
    title: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    featured?: boolean | null,
    startTime: string,
    endTime: string,
    owner?: string | null,
    createdAt: string,
    companyID?: string | null,
    themeID?: string | null,
    category?: string | null,
    hashtag?: Array< string | null > | null,
    updatedAt: string,
    companyTheme?:  {
      __typename: "CompanyTheme",
      id: string,
      companyID: string,
      attributes?:  {
        __typename: "CustomThemeAttribute",
        pollActivePeriodBgColor?: string | null,
        pollActivePeriodShadowColor?: string | null,
        pollQuestionCardBgColor?: string | null,
        pollQuestionCardQuestionColor?: string | null,
        pollQuestionCardAnswerColor?: string | null,
        pollPledgeCastBtnBgColor?: string | null,
        pollPledgeCastBtnBracketColor?: string | null,
        pollPledgeCastBtnTextColor?: string | null,
        pollPageBgColor?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      domain: string,
      owner?: string | null,
      status?: CompanyStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    pledges?:  {
      __typename: "ModelIdeaPledgeConnection",
      items:  Array< {
        __typename: "IdeaPledge",
        id: string,
        ideaID: string,
        title?: string | null,
        description?: string | null,
        video?: string | null,
        price: string,
        currency: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelIdeaCommentConnection",
      items:  Array< {
        __typename: "IdeaComment",
        id: string,
        ideaID: string,
        userID: string,
        content: string,
        avatar?: string | null,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    scores?:  {
      __typename: "ModelIdeaScoreConnection",
      items:  Array< {
        __typename: "IdeaScore",
        id: string,
        ideaID: string,
        userID: string,
        level_of_success: number,
        investment_required: number,
        talent_required: number,
        consultation_required: number,
        connection_required: number,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type UpdateIdeaMutationVariables = {
  input: UpdateIdeaInput,
  condition?: ModelIdeaConditionInput | null,
};

export type UpdateIdeaMutation = {
  updateIdea?:  {
    __typename: "Idea",
    id: string,
    title: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    featured?: boolean | null,
    startTime: string,
    endTime: string,
    owner?: string | null,
    createdAt: string,
    companyID?: string | null,
    themeID?: string | null,
    category?: string | null,
    hashtag?: Array< string | null > | null,
    updatedAt: string,
    companyTheme?:  {
      __typename: "CompanyTheme",
      id: string,
      companyID: string,
      attributes?:  {
        __typename: "CustomThemeAttribute",
        pollActivePeriodBgColor?: string | null,
        pollActivePeriodShadowColor?: string | null,
        pollQuestionCardBgColor?: string | null,
        pollQuestionCardQuestionColor?: string | null,
        pollQuestionCardAnswerColor?: string | null,
        pollPledgeCastBtnBgColor?: string | null,
        pollPledgeCastBtnBracketColor?: string | null,
        pollPledgeCastBtnTextColor?: string | null,
        pollPageBgColor?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      domain: string,
      owner?: string | null,
      status?: CompanyStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    pledges?:  {
      __typename: "ModelIdeaPledgeConnection",
      items:  Array< {
        __typename: "IdeaPledge",
        id: string,
        ideaID: string,
        title?: string | null,
        description?: string | null,
        video?: string | null,
        price: string,
        currency: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelIdeaCommentConnection",
      items:  Array< {
        __typename: "IdeaComment",
        id: string,
        ideaID: string,
        userID: string,
        content: string,
        avatar?: string | null,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    scores?:  {
      __typename: "ModelIdeaScoreConnection",
      items:  Array< {
        __typename: "IdeaScore",
        id: string,
        ideaID: string,
        userID: string,
        level_of_success: number,
        investment_required: number,
        talent_required: number,
        consultation_required: number,
        connection_required: number,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type DeleteIdeaMutationVariables = {
  input: DeleteIdeaInput,
  condition?: ModelIdeaConditionInput | null,
};

export type DeleteIdeaMutation = {
  deleteIdea?:  {
    __typename: "Idea",
    id: string,
    title: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    featured?: boolean | null,
    startTime: string,
    endTime: string,
    owner?: string | null,
    createdAt: string,
    companyID?: string | null,
    themeID?: string | null,
    category?: string | null,
    hashtag?: Array< string | null > | null,
    updatedAt: string,
    companyTheme?:  {
      __typename: "CompanyTheme",
      id: string,
      companyID: string,
      attributes?:  {
        __typename: "CustomThemeAttribute",
        pollActivePeriodBgColor?: string | null,
        pollActivePeriodShadowColor?: string | null,
        pollQuestionCardBgColor?: string | null,
        pollQuestionCardQuestionColor?: string | null,
        pollQuestionCardAnswerColor?: string | null,
        pollPledgeCastBtnBgColor?: string | null,
        pollPledgeCastBtnBracketColor?: string | null,
        pollPledgeCastBtnTextColor?: string | null,
        pollPageBgColor?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      domain: string,
      owner?: string | null,
      status?: CompanyStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    pledges?:  {
      __typename: "ModelIdeaPledgeConnection",
      items:  Array< {
        __typename: "IdeaPledge",
        id: string,
        ideaID: string,
        title?: string | null,
        description?: string | null,
        video?: string | null,
        price: string,
        currency: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelIdeaCommentConnection",
      items:  Array< {
        __typename: "IdeaComment",
        id: string,
        ideaID: string,
        userID: string,
        content: string,
        avatar?: string | null,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    scores?:  {
      __typename: "ModelIdeaScoreConnection",
      items:  Array< {
        __typename: "IdeaScore",
        id: string,
        ideaID: string,
        userID: string,
        level_of_success: number,
        investment_required: number,
        talent_required: number,
        consultation_required: number,
        connection_required: number,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type CreateIdeaPledgeMutationVariables = {
  input: CreateIdeaPledgeInput,
  condition?: ModelIdeaPledgeConditionInput | null,
};

export type CreateIdeaPledgeMutation = {
  createIdeaPledge?:  {
    __typename: "IdeaPledge",
    id: string,
    ideaID: string,
    title?: string | null,
    description?: string | null,
    video?: string | null,
    price: string,
    currency: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateIdeaPledgeMutationVariables = {
  input: UpdateIdeaPledgeInput,
  condition?: ModelIdeaPledgeConditionInput | null,
};

export type UpdateIdeaPledgeMutation = {
  updateIdeaPledge?:  {
    __typename: "IdeaPledge",
    id: string,
    ideaID: string,
    title?: string | null,
    description?: string | null,
    video?: string | null,
    price: string,
    currency: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteIdeaPledgeMutationVariables = {
  input: DeleteIdeaPledgeInput,
  condition?: ModelIdeaPledgeConditionInput | null,
};

export type DeleteIdeaPledgeMutation = {
  deleteIdeaPledge?:  {
    __typename: "IdeaPledge",
    id: string,
    ideaID: string,
    title?: string | null,
    description?: string | null,
    video?: string | null,
    price: string,
    currency: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateIdeaCommentMutationVariables = {
  input: CreateIdeaCommentInput,
  condition?: ModelIdeaCommentConditionInput | null,
};

export type CreateIdeaCommentMutation = {
  createIdeaComment?:  {
    __typename: "IdeaComment",
    id: string,
    ideaID: string,
    userID: string,
    content: string,
    avatar?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateIdeaCommentMutationVariables = {
  input: UpdateIdeaCommentInput,
  condition?: ModelIdeaCommentConditionInput | null,
};

export type UpdateIdeaCommentMutation = {
  updateIdeaComment?:  {
    __typename: "IdeaComment",
    id: string,
    ideaID: string,
    userID: string,
    content: string,
    avatar?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteIdeaCommentMutationVariables = {
  input: DeleteIdeaCommentInput,
  condition?: ModelIdeaCommentConditionInput | null,
};

export type DeleteIdeaCommentMutation = {
  deleteIdeaComment?:  {
    __typename: "IdeaComment",
    id: string,
    ideaID: string,
    userID: string,
    content: string,
    avatar?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateIdeaPledgeStripeChargeMutationVariables = {
  input: CreateIdeaPledgeStripeChargeInput,
  condition?: ModelIdeaPledgeStripeChargeConditionInput | null,
};

export type CreateIdeaPledgeStripeChargeMutation = {
  createIdeaPledgeStripeCharge?:  {
    __typename: "IdeaPledgeStripeCharge",
    id: string,
    userID: string,
    ideaID: string,
    ideaPledgeID: string,
    chargeID: string,
    status: StripeChargeStatus,
    amount: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type UpdateIdeaPledgeStripeChargeMutationVariables = {
  input: UpdateIdeaPledgeStripeChargeInput,
  condition?: ModelIdeaPledgeStripeChargeConditionInput | null,
};

export type UpdateIdeaPledgeStripeChargeMutation = {
  updateIdeaPledgeStripeCharge?:  {
    __typename: "IdeaPledgeStripeCharge",
    id: string,
    userID: string,
    ideaID: string,
    ideaPledgeID: string,
    chargeID: string,
    status: StripeChargeStatus,
    amount: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type DeleteIdeaPledgeStripeChargeMutationVariables = {
  input: DeleteIdeaPledgeStripeChargeInput,
  condition?: ModelIdeaPledgeStripeChargeConditionInput | null,
};

export type DeleteIdeaPledgeStripeChargeMutation = {
  deleteIdeaPledgeStripeCharge?:  {
    __typename: "IdeaPledgeStripeCharge",
    id: string,
    userID: string,
    ideaID: string,
    ideaPledgeID: string,
    chargeID: string,
    status: StripeChargeStatus,
    amount: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type CreateIdeaScoreMutationVariables = {
  input: CreateIdeaScoreInput,
  condition?: ModelIdeaScoreConditionInput | null,
};

export type CreateIdeaScoreMutation = {
  createIdeaScore?:  {
    __typename: "IdeaScore",
    id: string,
    ideaID: string,
    userID: string,
    level_of_success: number,
    investment_required: number,
    talent_required: number,
    consultation_required: number,
    connection_required: number,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateIdeaScoreMutationVariables = {
  input: UpdateIdeaScoreInput,
  condition?: ModelIdeaScoreConditionInput | null,
};

export type UpdateIdeaScoreMutation = {
  updateIdeaScore?:  {
    __typename: "IdeaScore",
    id: string,
    ideaID: string,
    userID: string,
    level_of_success: number,
    investment_required: number,
    talent_required: number,
    consultation_required: number,
    connection_required: number,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteIdeaScoreMutationVariables = {
  input: DeleteIdeaScoreInput,
  condition?: ModelIdeaScoreConditionInput | null,
};

export type DeleteIdeaScoreMutation = {
  deleteIdeaScore?:  {
    __typename: "IdeaScore",
    id: string,
    ideaID: string,
    userID: string,
    level_of_success: number,
    investment_required: number,
    talent_required: number,
    consultation_required: number,
    connection_required: number,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type CreateIdeaSupporterMutationVariables = {
  input: CreateIdeaSupporterInput,
  condition?: ModelIdeaSupporterConditionInput | null,
};

export type CreateIdeaSupporterMutation = {
  createIdeaSupporter?:  {
    __typename: "IdeaSupporter",
    id: string,
    url?: string | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type UpdateIdeaSupporterMutationVariables = {
  input: UpdateIdeaSupporterInput,
  condition?: ModelIdeaSupporterConditionInput | null,
};

export type UpdateIdeaSupporterMutation = {
  updateIdeaSupporter?:  {
    __typename: "IdeaSupporter",
    id: string,
    url?: string | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type DeleteIdeaSupporterMutationVariables = {
  input: DeleteIdeaSupporterInput,
  condition?: ModelIdeaSupporterConditionInput | null,
};

export type DeleteIdeaSupporterMutation = {
  deleteIdeaSupporter?:  {
    __typename: "IdeaSupporter",
    id: string,
    url?: string | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type GetPollCommentQueryVariables = {
  id: string,
};

export type GetPollCommentQuery = {
  getPollComment?:  {
    __typename: "PollComment",
    id: string,
    pollID: string,
    userID: string,
    content: string,
    avatar?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListPollCommentsQueryVariables = {
  filter?: ModelPollCommentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPollCommentsQuery = {
  listPollComments?:  {
    __typename: "ModelPollCommentConnection",
    items:  Array< {
      __typename: "PollComment",
      id: string,
      pollID: string,
      userID: string,
      content: string,
      avatar?: string | null,
      name?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPollQueryVariables = {
  id: string,
};

export type GetPollQuery = {
  getPoll?:  {
    __typename: "Poll",
    id: string,
    title: string,
    question: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    status?: PollStatus | null,
    options?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    drawOptions?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    hasPledge?: boolean | null,
    isGroup?: boolean | null,
    featured?: boolean | null,
    winOption?:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } | null,
    startTime: string,
    endTime: string,
    pledgePeriod1StartTime?: string | null,
    pledgePeriod1EndTime?: string | null,
    pledgePeriod2StartTime?: string | null,
    pledgePeriod2EndTime?: string | null,
    owner?: string | null,
    password?: string | null,
    grc?: string | null,
    division?: string | null,
    createdAt: string,
    private?: number | null,
    companyID?: string | null,
    themeID?: string | null,
    representativeID?: string | null,
    isPremium?: boolean | null,
    maxVote?: number | null,
    isNotExact?: boolean | null,
    category?: string | null,
    hashtag?: Array< string | null > | null,
    updatedAt: string,
    comments?:  {
      __typename: "ModelPollCommentConnection",
      items:  Array< {
        __typename: "PollComment",
        id: string,
        pollID: string,
        userID: string,
        content: string,
        avatar?: string | null,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    votes?:  {
      __typename: "ModelVoteConnection",
      items:  Array< {
        __typename: "Vote",
        id: string,
        userID: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        type: VoteType,
        subPollID?: string | null,
        reason?: string | null,
        pollID: string,
        proxyUserID?: string | null,
        createdAt: string,
        updatedAt: string,
        poll?:  {
          __typename: "Poll",
          id: string,
          title: string,
          question: string,
          description?: string | null,
          video?: string | null,
          status?: PollStatus | null,
          hasPledge?: boolean | null,
          isGroup?: boolean | null,
          featured?: boolean | null,
          startTime: string,
          endTime: string,
          pledgePeriod1StartTime?: string | null,
          pledgePeriod1EndTime?: string | null,
          pledgePeriod2StartTime?: string | null,
          pledgePeriod2EndTime?: string | null,
          owner?: string | null,
          password?: string | null,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          private?: number | null,
          companyID?: string | null,
          themeID?: string | null,
          representativeID?: string | null,
          isPremium?: boolean | null,
          maxVote?: number | null,
          isNotExact?: boolean | null,
          category?: string | null,
          hashtag?: Array< string | null > | null,
          updatedAt: string,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          email?: string | null,
          username?: string | null,
          owner?: string | null,
          phone?: string | null,
          type?: UserType | null,
          disable?: boolean | null,
          firstName?: string | null,
          lastName?: string | null,
          yearOfBirth?: number | null,
          gender?: string | null,
          education?: string | null,
          postalCode?: string | null,
          salaryRange?: UserSalaryRange | null,
          company?: string | null,
          createdAt: string,
          isSetup?: boolean | null,
          tier?: Tier | null,
          proxyUserID?: string | null,
          premiumPolls?: number | null,
          usedPremiumPolls?: number | null,
          cryptowallet?: string | null,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    voteResults?:  {
      __typename: "ModelVoteResultConnection",
      items:  Array< {
        __typename: "VoteResult",
        id: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        count: number,
        subPollID?: string | null,
        pollID: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    companyTheme?:  {
      __typename: "CompanyTheme",
      id: string,
      companyID: string,
      attributes?:  {
        __typename: "CustomThemeAttribute",
        pollActivePeriodBgColor?: string | null,
        pollActivePeriodShadowColor?: string | null,
        pollQuestionCardBgColor?: string | null,
        pollQuestionCardQuestionColor?: string | null,
        pollQuestionCardAnswerColor?: string | null,
        pollPledgeCastBtnBgColor?: string | null,
        pollPledgeCastBtnBracketColor?: string | null,
        pollPledgeCastBtnTextColor?: string | null,
        pollPageBgColor?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      domain: string,
      owner?: string | null,
      status?: CompanyStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    postalsGRC?:  {
      __typename: "ModelPostalInfoConnection",
      items:  Array< {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    postalsDivision?:  {
      __typename: "ModelPostalInfoConnection",
      items:  Array< {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListPollsQueryVariables = {
  filter?: ModelPollFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPollsQuery = {
  listPolls?:  {
    __typename: "ModelPollConnection",
    items:  Array< {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPublicPollsQueryVariables = {
  private?: number | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPollFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPublicPollsQuery = {
  listPublicPolls?:  {
    __typename: "ModelPollConnection",
    items:  Array< {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PollsByStatusQueryVariables = {
  status?: PollStatus | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPollFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PollsByStatusQuery = {
  pollsByStatus?:  {
    __typename: "ModelPollConnection",
    items:  Array< {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPollByVoteEndPeriodQueryVariables = {
  status?: PollStatus | null,
  endTime?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPollFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPollByVoteEndPeriodQuery = {
  listPollByVoteEndPeriod?:  {
    __typename: "ModelPollConnection",
    items:  Array< {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPollByVoteStartPeriodQueryVariables = {
  status?: PollStatus | null,
  startTime?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPollFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPollByVoteStartPeriodQuery = {
  listPollByVoteStartPeriod?:  {
    __typename: "ModelPollConnection",
    items:  Array< {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPollByPledgeStartPeriod1QueryVariables = {
  status?: PollStatus | null,
  pledgePeriod1StartTime?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPollFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPollByPledgeStartPeriod1Query = {
  listPollByPledgeStartPeriod1?:  {
    __typename: "ModelPollConnection",
    items:  Array< {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPollByPledgeStartPeriod2QueryVariables = {
  status?: PollStatus | null,
  pledgePeriod2StartTime?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPollFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPollByPledgeStartPeriod2Query = {
  listPollByPledgeStartPeriod2?:  {
    __typename: "ModelPollConnection",
    items:  Array< {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPollByPledgeEndPeriod1QueryVariables = {
  status?: PollStatus | null,
  pledgePeriod1EndTime?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPollFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPollByPledgeEndPeriod1Query = {
  listPollByPledgeEndPeriod1?:  {
    __typename: "ModelPollConnection",
    items:  Array< {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPollByPledgeEndPeriod2QueryVariables = {
  status?: PollStatus | null,
  pledgePeriod2EndTime?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPollFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPollByPledgeEndPeriod2Query = {
  listPollByPledgeEndPeriod2?:  {
    __typename: "ModelPollConnection",
    items:  Array< {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPollsByOwnerQueryVariables = {
  owner?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPollFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPollsByOwnerQuery = {
  listPollsByOwner?:  {
    __typename: "ModelPollConnection",
    items:  Array< {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPollsByRepresentativeIDQueryVariables = {
  representativeID?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPollFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPollsByRepresentativeIDQuery = {
  listPollsByRepresentativeID?:  {
    __typename: "ModelPollConnection",
    items:  Array< {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPollsByCompanyIDQueryVariables = {
  companyID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPollFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPollsByCompanyIDQuery = {
  listPollsByCompanyID?:  {
    __typename: "ModelPollConnection",
    items:  Array< {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSubPollQueryVariables = {
  id: string,
};

export type GetSubPollQuery = {
  getSubPoll?:  {
    __typename: "SubPoll",
    id: string,
    pollID?: string | null,
    title?: string | null,
    question: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    status?: PollStatus | null,
    options?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    winOption?:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } | null,
    owner?: string | null,
    createdAt: string,
    orderID: number,
    private: number,
    maxVote?: number | null,
    isNotExact?: boolean | null,
    updatedAt: string,
    votes?:  {
      __typename: "ModelVoteConnection",
      items:  Array< {
        __typename: "Vote",
        id: string,
        userID: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        type: VoteType,
        subPollID?: string | null,
        reason?: string | null,
        pollID: string,
        proxyUserID?: string | null,
        createdAt: string,
        updatedAt: string,
        poll?:  {
          __typename: "Poll",
          id: string,
          title: string,
          question: string,
          description?: string | null,
          video?: string | null,
          status?: PollStatus | null,
          hasPledge?: boolean | null,
          isGroup?: boolean | null,
          featured?: boolean | null,
          startTime: string,
          endTime: string,
          pledgePeriod1StartTime?: string | null,
          pledgePeriod1EndTime?: string | null,
          pledgePeriod2StartTime?: string | null,
          pledgePeriod2EndTime?: string | null,
          owner?: string | null,
          password?: string | null,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          private?: number | null,
          companyID?: string | null,
          themeID?: string | null,
          representativeID?: string | null,
          isPremium?: boolean | null,
          maxVote?: number | null,
          isNotExact?: boolean | null,
          category?: string | null,
          hashtag?: Array< string | null > | null,
          updatedAt: string,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          email?: string | null,
          username?: string | null,
          owner?: string | null,
          phone?: string | null,
          type?: UserType | null,
          disable?: boolean | null,
          firstName?: string | null,
          lastName?: string | null,
          yearOfBirth?: number | null,
          gender?: string | null,
          education?: string | null,
          postalCode?: string | null,
          salaryRange?: UserSalaryRange | null,
          company?: string | null,
          createdAt: string,
          isSetup?: boolean | null,
          tier?: Tier | null,
          proxyUserID?: string | null,
          premiumPolls?: number | null,
          usedPremiumPolls?: number | null,
          cryptowallet?: string | null,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    voteResults?:  {
      __typename: "ModelVoteResultConnection",
      items:  Array< {
        __typename: "VoteResult",
        id: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        count: number,
        subPollID?: string | null,
        pollID: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListSubPollsQueryVariables = {
  filter?: ModelSubPollFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSubPollsQuery = {
  listSubPolls?:  {
    __typename: "ModelSubPollConnection",
    items:  Array< {
      __typename: "SubPoll",
      id: string,
      pollID?: string | null,
      title?: string | null,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      owner?: string | null,
      createdAt: string,
      orderID: number,
      private: number,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      updatedAt: string,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListSubPollsByMainPollQueryVariables = {
  pollID?: string | null,
  orderID?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelSubPollFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSubPollsByMainPollQuery = {
  listSubPollsByMainPoll?:  {
    __typename: "ModelSubPollConnection",
    items:  Array< {
      __typename: "SubPoll",
      id: string,
      pollID?: string | null,
      title?: string | null,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      owner?: string | null,
      createdAt: string,
      orderID: number,
      private: number,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      updatedAt: string,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetVoteQueryVariables = {
  id: string,
};

export type GetVoteQuery = {
  getVote?:  {
    __typename: "Vote",
    id: string,
    userID: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    type: VoteType,
    subPollID?: string | null,
    reason?: string | null,
    pollID: string,
    proxyUserID?: string | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type ListVotesQueryVariables = {
  filter?: ModelVoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVotesQuery = {
  listVotes?:  {
    __typename: "ModelVoteConnection",
    items:  Array< {
      __typename: "Vote",
      id: string,
      userID: string,
      option:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      },
      type: VoteType,
      subPollID?: string | null,
      reason?: string | null,
      pollID: string,
      proxyUserID?: string | null,
      createdAt: string,
      updatedAt: string,
      poll?:  {
        __typename: "Poll",
        id: string,
        title: string,
        question: string,
        description?: string | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        theme?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        background?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        logo?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        status?: PollStatus | null,
        options?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        drawOptions?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        hasPledge?: boolean | null,
        isGroup?: boolean | null,
        featured?: boolean | null,
        winOption?:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } | null,
        startTime: string,
        endTime: string,
        pledgePeriod1StartTime?: string | null,
        pledgePeriod1EndTime?: string | null,
        pledgePeriod2StartTime?: string | null,
        pledgePeriod2EndTime?: string | null,
        owner?: string | null,
        password?: string | null,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        private?: number | null,
        companyID?: string | null,
        themeID?: string | null,
        representativeID?: string | null,
        isPremium?: boolean | null,
        maxVote?: number | null,
        isNotExact?: boolean | null,
        category?: string | null,
        hashtag?: Array< string | null > | null,
        updatedAt: string,
        comments?:  {
          __typename: "ModelPollCommentConnection",
          nextToken?: string | null,
        } | null,
        votes?:  {
          __typename: "ModelVoteConnection",
          nextToken?: string | null,
        } | null,
        voteResults?:  {
          __typename: "ModelVoteResultConnection",
          nextToken?: string | null,
        } | null,
        companyTheme?:  {
          __typename: "CompanyTheme",
          id: string,
          companyID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          domain: string,
          owner?: string | null,
          status?: CompanyStatus | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        postalsGRC?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
        postalsDivision?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListVotesByPollQueryVariables = {
  pollID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVotesByPollQuery = {
  listVotesByPoll?:  {
    __typename: "ModelVoteConnection",
    items:  Array< {
      __typename: "Vote",
      id: string,
      userID: string,
      option:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      },
      type: VoteType,
      subPollID?: string | null,
      reason?: string | null,
      pollID: string,
      proxyUserID?: string | null,
      createdAt: string,
      updatedAt: string,
      poll?:  {
        __typename: "Poll",
        id: string,
        title: string,
        question: string,
        description?: string | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        theme?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        background?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        logo?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        status?: PollStatus | null,
        options?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        drawOptions?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        hasPledge?: boolean | null,
        isGroup?: boolean | null,
        featured?: boolean | null,
        winOption?:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } | null,
        startTime: string,
        endTime: string,
        pledgePeriod1StartTime?: string | null,
        pledgePeriod1EndTime?: string | null,
        pledgePeriod2StartTime?: string | null,
        pledgePeriod2EndTime?: string | null,
        owner?: string | null,
        password?: string | null,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        private?: number | null,
        companyID?: string | null,
        themeID?: string | null,
        representativeID?: string | null,
        isPremium?: boolean | null,
        maxVote?: number | null,
        isNotExact?: boolean | null,
        category?: string | null,
        hashtag?: Array< string | null > | null,
        updatedAt: string,
        comments?:  {
          __typename: "ModelPollCommentConnection",
          nextToken?: string | null,
        } | null,
        votes?:  {
          __typename: "ModelVoteConnection",
          nextToken?: string | null,
        } | null,
        voteResults?:  {
          __typename: "ModelVoteResultConnection",
          nextToken?: string | null,
        } | null,
        companyTheme?:  {
          __typename: "CompanyTheme",
          id: string,
          companyID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          domain: string,
          owner?: string | null,
          status?: CompanyStatus | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        postalsGRC?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
        postalsDivision?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetVoteByUserIDQueryVariables = {
  userID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetVoteByUserIDQuery = {
  getVoteByUserID?:  {
    __typename: "ModelVoteConnection",
    items:  Array< {
      __typename: "Vote",
      id: string,
      userID: string,
      option:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      },
      type: VoteType,
      subPollID?: string | null,
      reason?: string | null,
      pollID: string,
      proxyUserID?: string | null,
      createdAt: string,
      updatedAt: string,
      poll?:  {
        __typename: "Poll",
        id: string,
        title: string,
        question: string,
        description?: string | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        theme?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        background?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        logo?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        status?: PollStatus | null,
        options?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        drawOptions?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        hasPledge?: boolean | null,
        isGroup?: boolean | null,
        featured?: boolean | null,
        winOption?:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } | null,
        startTime: string,
        endTime: string,
        pledgePeriod1StartTime?: string | null,
        pledgePeriod1EndTime?: string | null,
        pledgePeriod2StartTime?: string | null,
        pledgePeriod2EndTime?: string | null,
        owner?: string | null,
        password?: string | null,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        private?: number | null,
        companyID?: string | null,
        themeID?: string | null,
        representativeID?: string | null,
        isPremium?: boolean | null,
        maxVote?: number | null,
        isNotExact?: boolean | null,
        category?: string | null,
        hashtag?: Array< string | null > | null,
        updatedAt: string,
        comments?:  {
          __typename: "ModelPollCommentConnection",
          nextToken?: string | null,
        } | null,
        votes?:  {
          __typename: "ModelVoteConnection",
          nextToken?: string | null,
        } | null,
        voteResults?:  {
          __typename: "ModelVoteResultConnection",
          nextToken?: string | null,
        } | null,
        companyTheme?:  {
          __typename: "CompanyTheme",
          id: string,
          companyID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          domain: string,
          owner?: string | null,
          status?: CompanyStatus | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        postalsGRC?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
        postalsDivision?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListVotesByProxyQueryVariables = {
  proxyUserID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVotesByProxyQuery = {
  listVotesByProxy?:  {
    __typename: "ModelVoteConnection",
    items:  Array< {
      __typename: "Vote",
      id: string,
      userID: string,
      option:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      },
      type: VoteType,
      subPollID?: string | null,
      reason?: string | null,
      pollID: string,
      proxyUserID?: string | null,
      createdAt: string,
      updatedAt: string,
      poll?:  {
        __typename: "Poll",
        id: string,
        title: string,
        question: string,
        description?: string | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        theme?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        background?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        logo?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        status?: PollStatus | null,
        options?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        drawOptions?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        hasPledge?: boolean | null,
        isGroup?: boolean | null,
        featured?: boolean | null,
        winOption?:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } | null,
        startTime: string,
        endTime: string,
        pledgePeriod1StartTime?: string | null,
        pledgePeriod1EndTime?: string | null,
        pledgePeriod2StartTime?: string | null,
        pledgePeriod2EndTime?: string | null,
        owner?: string | null,
        password?: string | null,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        private?: number | null,
        companyID?: string | null,
        themeID?: string | null,
        representativeID?: string | null,
        isPremium?: boolean | null,
        maxVote?: number | null,
        isNotExact?: boolean | null,
        category?: string | null,
        hashtag?: Array< string | null > | null,
        updatedAt: string,
        comments?:  {
          __typename: "ModelPollCommentConnection",
          nextToken?: string | null,
        } | null,
        votes?:  {
          __typename: "ModelVoteConnection",
          nextToken?: string | null,
        } | null,
        voteResults?:  {
          __typename: "ModelVoteResultConnection",
          nextToken?: string | null,
        } | null,
        companyTheme?:  {
          __typename: "CompanyTheme",
          id: string,
          companyID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          domain: string,
          owner?: string | null,
          status?: CompanyStatus | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        postalsGRC?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
        postalsDivision?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListVotesByPollByProxyQueryVariables = {
  pollID?: string | null,
  proxyUserID?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVoteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVotesByPollByProxyQuery = {
  listVotesByPollByProxy?:  {
    __typename: "ModelVoteConnection",
    items:  Array< {
      __typename: "Vote",
      id: string,
      userID: string,
      option:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      },
      type: VoteType,
      subPollID?: string | null,
      reason?: string | null,
      pollID: string,
      proxyUserID?: string | null,
      createdAt: string,
      updatedAt: string,
      poll?:  {
        __typename: "Poll",
        id: string,
        title: string,
        question: string,
        description?: string | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        theme?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        background?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        logo?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        status?: PollStatus | null,
        options?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        drawOptions?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        hasPledge?: boolean | null,
        isGroup?: boolean | null,
        featured?: boolean | null,
        winOption?:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } | null,
        startTime: string,
        endTime: string,
        pledgePeriod1StartTime?: string | null,
        pledgePeriod1EndTime?: string | null,
        pledgePeriod2StartTime?: string | null,
        pledgePeriod2EndTime?: string | null,
        owner?: string | null,
        password?: string | null,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        private?: number | null,
        companyID?: string | null,
        themeID?: string | null,
        representativeID?: string | null,
        isPremium?: boolean | null,
        maxVote?: number | null,
        isNotExact?: boolean | null,
        category?: string | null,
        hashtag?: Array< string | null > | null,
        updatedAt: string,
        comments?:  {
          __typename: "ModelPollCommentConnection",
          nextToken?: string | null,
        } | null,
        votes?:  {
          __typename: "ModelVoteConnection",
          nextToken?: string | null,
        } | null,
        voteResults?:  {
          __typename: "ModelVoteResultConnection",
          nextToken?: string | null,
        } | null,
        companyTheme?:  {
          __typename: "CompanyTheme",
          id: string,
          companyID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          domain: string,
          owner?: string | null,
          status?: CompanyStatus | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        postalsGRC?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
        postalsDivision?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetHotPollQueryVariables = {
  id: string,
};

export type GetHotPollQuery = {
  getHotPoll?:  {
    __typename: "HotPoll",
    id: string,
    pollID: string,
    count: number,
    status: HotPollStatus,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListHotPollsQueryVariables = {
  filter?: ModelHotPollFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHotPollsQuery = {
  listHotPolls?:  {
    __typename: "ModelHotPollConnection",
    items:  Array< {
      __typename: "HotPoll",
      id: string,
      pollID: string,
      count: number,
      status: HotPollStatus,
      createdAt: string,
      updatedAt: string,
      poll?:  {
        __typename: "Poll",
        id: string,
        title: string,
        question: string,
        description?: string | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        theme?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        background?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        logo?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        status?: PollStatus | null,
        options?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        drawOptions?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        hasPledge?: boolean | null,
        isGroup?: boolean | null,
        featured?: boolean | null,
        winOption?:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } | null,
        startTime: string,
        endTime: string,
        pledgePeriod1StartTime?: string | null,
        pledgePeriod1EndTime?: string | null,
        pledgePeriod2StartTime?: string | null,
        pledgePeriod2EndTime?: string | null,
        owner?: string | null,
        password?: string | null,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        private?: number | null,
        companyID?: string | null,
        themeID?: string | null,
        representativeID?: string | null,
        isPremium?: boolean | null,
        maxVote?: number | null,
        isNotExact?: boolean | null,
        category?: string | null,
        hashtag?: Array< string | null > | null,
        updatedAt: string,
        comments?:  {
          __typename: "ModelPollCommentConnection",
          nextToken?: string | null,
        } | null,
        votes?:  {
          __typename: "ModelVoteConnection",
          nextToken?: string | null,
        } | null,
        voteResults?:  {
          __typename: "ModelVoteResultConnection",
          nextToken?: string | null,
        } | null,
        companyTheme?:  {
          __typename: "CompanyTheme",
          id: string,
          companyID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          domain: string,
          owner?: string | null,
          status?: CompanyStatus | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        postalsGRC?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
        postalsDivision?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListHotPollsByStatusQueryVariables = {
  status?: HotPollStatus | null,
  count?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelHotPollFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHotPollsByStatusQuery = {
  listHotPollsByStatus?:  {
    __typename: "ModelHotPollConnection",
    items:  Array< {
      __typename: "HotPoll",
      id: string,
      pollID: string,
      count: number,
      status: HotPollStatus,
      createdAt: string,
      updatedAt: string,
      poll?:  {
        __typename: "Poll",
        id: string,
        title: string,
        question: string,
        description?: string | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        theme?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        background?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        logo?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        status?: PollStatus | null,
        options?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        drawOptions?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        hasPledge?: boolean | null,
        isGroup?: boolean | null,
        featured?: boolean | null,
        winOption?:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } | null,
        startTime: string,
        endTime: string,
        pledgePeriod1StartTime?: string | null,
        pledgePeriod1EndTime?: string | null,
        pledgePeriod2StartTime?: string | null,
        pledgePeriod2EndTime?: string | null,
        owner?: string | null,
        password?: string | null,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        private?: number | null,
        companyID?: string | null,
        themeID?: string | null,
        representativeID?: string | null,
        isPremium?: boolean | null,
        maxVote?: number | null,
        isNotExact?: boolean | null,
        category?: string | null,
        hashtag?: Array< string | null > | null,
        updatedAt: string,
        comments?:  {
          __typename: "ModelPollCommentConnection",
          nextToken?: string | null,
        } | null,
        votes?:  {
          __typename: "ModelVoteConnection",
          nextToken?: string | null,
        } | null,
        voteResults?:  {
          __typename: "ModelVoteResultConnection",
          nextToken?: string | null,
        } | null,
        companyTheme?:  {
          __typename: "CompanyTheme",
          id: string,
          companyID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          domain: string,
          owner?: string | null,
          status?: CompanyStatus | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        postalsGRC?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
        postalsDivision?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetHotPledgeQueryVariables = {
  id: string,
};

export type GetHotPledgeQuery = {
  getHotPledge?:  {
    __typename: "HotPledge",
    id: string,
    pollID: string,
    count: number,
    status: HotPollStatus,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListHotPledgesQueryVariables = {
  filter?: ModelHotPledgeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHotPledgesQuery = {
  listHotPledges?:  {
    __typename: "ModelHotPledgeConnection",
    items:  Array< {
      __typename: "HotPledge",
      id: string,
      pollID: string,
      count: number,
      status: HotPollStatus,
      createdAt: string,
      updatedAt: string,
      poll?:  {
        __typename: "Poll",
        id: string,
        title: string,
        question: string,
        description?: string | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        theme?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        background?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        logo?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        status?: PollStatus | null,
        options?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        drawOptions?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        hasPledge?: boolean | null,
        isGroup?: boolean | null,
        featured?: boolean | null,
        winOption?:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } | null,
        startTime: string,
        endTime: string,
        pledgePeriod1StartTime?: string | null,
        pledgePeriod1EndTime?: string | null,
        pledgePeriod2StartTime?: string | null,
        pledgePeriod2EndTime?: string | null,
        owner?: string | null,
        password?: string | null,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        private?: number | null,
        companyID?: string | null,
        themeID?: string | null,
        representativeID?: string | null,
        isPremium?: boolean | null,
        maxVote?: number | null,
        isNotExact?: boolean | null,
        category?: string | null,
        hashtag?: Array< string | null > | null,
        updatedAt: string,
        comments?:  {
          __typename: "ModelPollCommentConnection",
          nextToken?: string | null,
        } | null,
        votes?:  {
          __typename: "ModelVoteConnection",
          nextToken?: string | null,
        } | null,
        voteResults?:  {
          __typename: "ModelVoteResultConnection",
          nextToken?: string | null,
        } | null,
        companyTheme?:  {
          __typename: "CompanyTheme",
          id: string,
          companyID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          domain: string,
          owner?: string | null,
          status?: CompanyStatus | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        postalsGRC?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
        postalsDivision?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListHotPledgesByStatusQueryVariables = {
  status?: HotPollStatus | null,
  count?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelHotPledgeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListHotPledgesByStatusQuery = {
  listHotPledgesByStatus?:  {
    __typename: "ModelHotPledgeConnection",
    items:  Array< {
      __typename: "HotPledge",
      id: string,
      pollID: string,
      count: number,
      status: HotPollStatus,
      createdAt: string,
      updatedAt: string,
      poll?:  {
        __typename: "Poll",
        id: string,
        title: string,
        question: string,
        description?: string | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        theme?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        background?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        logo?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        status?: PollStatus | null,
        options?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        drawOptions?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        hasPledge?: boolean | null,
        isGroup?: boolean | null,
        featured?: boolean | null,
        winOption?:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } | null,
        startTime: string,
        endTime: string,
        pledgePeriod1StartTime?: string | null,
        pledgePeriod1EndTime?: string | null,
        pledgePeriod2StartTime?: string | null,
        pledgePeriod2EndTime?: string | null,
        owner?: string | null,
        password?: string | null,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        private?: number | null,
        companyID?: string | null,
        themeID?: string | null,
        representativeID?: string | null,
        isPremium?: boolean | null,
        maxVote?: number | null,
        isNotExact?: boolean | null,
        category?: string | null,
        hashtag?: Array< string | null > | null,
        updatedAt: string,
        comments?:  {
          __typename: "ModelPollCommentConnection",
          nextToken?: string | null,
        } | null,
        votes?:  {
          __typename: "ModelVoteConnection",
          nextToken?: string | null,
        } | null,
        voteResults?:  {
          __typename: "ModelVoteResultConnection",
          nextToken?: string | null,
        } | null,
        companyTheme?:  {
          __typename: "CompanyTheme",
          id: string,
          companyID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          domain: string,
          owner?: string | null,
          status?: CompanyStatus | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        postalsGRC?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
        postalsDivision?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetVoteResultQueryVariables = {
  id: string,
};

export type GetVoteResultQuery = {
  getVoteResult?:  {
    __typename: "VoteResult",
    id: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    count: number,
    subPollID?: string | null,
    pollID: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListVoteResultsQueryVariables = {
  filter?: ModelVoteResultFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListVoteResultsQuery = {
  listVoteResults?:  {
    __typename: "ModelVoteResultConnection",
    items:  Array< {
      __typename: "VoteResult",
      id: string,
      option:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      },
      count: number,
      subPollID?: string | null,
      pollID: string,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetVoteResultByPollIDQueryVariables = {
  pollID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelVoteResultFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetVoteResultByPollIDQuery = {
  getVoteResultByPollID?:  {
    __typename: "ModelVoteResultConnection",
    items:  Array< {
      __typename: "VoteResult",
      id: string,
      option:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      },
      count: number,
      subPollID?: string | null,
      pollID: string,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPledgeQueryVariables = {
  id: string,
};

export type GetPledgeQuery = {
  getPledge?:  {
    __typename: "Pledge",
    id: string,
    userID: string,
    type: PledgeType,
    pollID: string,
    reason?: string | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type ListPledgesQueryVariables = {
  filter?: ModelPledgeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPledgesQuery = {
  listPledges?:  {
    __typename: "ModelPledgeConnection",
    items:  Array< {
      __typename: "Pledge",
      id: string,
      userID: string,
      type: PledgeType,
      pollID: string,
      reason?: string | null,
      createdAt: string,
      updatedAt: string,
      poll?:  {
        __typename: "Poll",
        id: string,
        title: string,
        question: string,
        description?: string | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        theme?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        background?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        logo?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        status?: PollStatus | null,
        options?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        drawOptions?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        hasPledge?: boolean | null,
        isGroup?: boolean | null,
        featured?: boolean | null,
        winOption?:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } | null,
        startTime: string,
        endTime: string,
        pledgePeriod1StartTime?: string | null,
        pledgePeriod1EndTime?: string | null,
        pledgePeriod2StartTime?: string | null,
        pledgePeriod2EndTime?: string | null,
        owner?: string | null,
        password?: string | null,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        private?: number | null,
        companyID?: string | null,
        themeID?: string | null,
        representativeID?: string | null,
        isPremium?: boolean | null,
        maxVote?: number | null,
        isNotExact?: boolean | null,
        category?: string | null,
        hashtag?: Array< string | null > | null,
        updatedAt: string,
        comments?:  {
          __typename: "ModelPollCommentConnection",
          nextToken?: string | null,
        } | null,
        votes?:  {
          __typename: "ModelVoteConnection",
          nextToken?: string | null,
        } | null,
        voteResults?:  {
          __typename: "ModelVoteResultConnection",
          nextToken?: string | null,
        } | null,
        companyTheme?:  {
          __typename: "CompanyTheme",
          id: string,
          companyID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          domain: string,
          owner?: string | null,
          status?: CompanyStatus | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        postalsGRC?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
        postalsDivision?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPledgesByUserIDQueryVariables = {
  userID?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPledgeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPledgesByUserIDQuery = {
  listPledgesByUserID?:  {
    __typename: "ModelPledgeConnection",
    items:  Array< {
      __typename: "Pledge",
      id: string,
      userID: string,
      type: PledgeType,
      pollID: string,
      reason?: string | null,
      createdAt: string,
      updatedAt: string,
      poll?:  {
        __typename: "Poll",
        id: string,
        title: string,
        question: string,
        description?: string | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        theme?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        background?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        logo?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        status?: PollStatus | null,
        options?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        drawOptions?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        hasPledge?: boolean | null,
        isGroup?: boolean | null,
        featured?: boolean | null,
        winOption?:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } | null,
        startTime: string,
        endTime: string,
        pledgePeriod1StartTime?: string | null,
        pledgePeriod1EndTime?: string | null,
        pledgePeriod2StartTime?: string | null,
        pledgePeriod2EndTime?: string | null,
        owner?: string | null,
        password?: string | null,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        private?: number | null,
        companyID?: string | null,
        themeID?: string | null,
        representativeID?: string | null,
        isPremium?: boolean | null,
        maxVote?: number | null,
        isNotExact?: boolean | null,
        category?: string | null,
        hashtag?: Array< string | null > | null,
        updatedAt: string,
        comments?:  {
          __typename: "ModelPollCommentConnection",
          nextToken?: string | null,
        } | null,
        votes?:  {
          __typename: "ModelVoteConnection",
          nextToken?: string | null,
        } | null,
        voteResults?:  {
          __typename: "ModelVoteResultConnection",
          nextToken?: string | null,
        } | null,
        companyTheme?:  {
          __typename: "CompanyTheme",
          id: string,
          companyID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          domain: string,
          owner?: string | null,
          status?: CompanyStatus | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        postalsGRC?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
        postalsDivision?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPledgesByPollIDQueryVariables = {
  pollID?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPledgeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPledgesByPollIDQuery = {
  listPledgesByPollID?:  {
    __typename: "ModelPledgeConnection",
    items:  Array< {
      __typename: "Pledge",
      id: string,
      userID: string,
      type: PledgeType,
      pollID: string,
      reason?: string | null,
      createdAt: string,
      updatedAt: string,
      poll?:  {
        __typename: "Poll",
        id: string,
        title: string,
        question: string,
        description?: string | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        theme?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        background?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        logo?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        status?: PollStatus | null,
        options?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        drawOptions?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        hasPledge?: boolean | null,
        isGroup?: boolean | null,
        featured?: boolean | null,
        winOption?:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } | null,
        startTime: string,
        endTime: string,
        pledgePeriod1StartTime?: string | null,
        pledgePeriod1EndTime?: string | null,
        pledgePeriod2StartTime?: string | null,
        pledgePeriod2EndTime?: string | null,
        owner?: string | null,
        password?: string | null,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        private?: number | null,
        companyID?: string | null,
        themeID?: string | null,
        representativeID?: string | null,
        isPremium?: boolean | null,
        maxVote?: number | null,
        isNotExact?: boolean | null,
        category?: string | null,
        hashtag?: Array< string | null > | null,
        updatedAt: string,
        comments?:  {
          __typename: "ModelPollCommentConnection",
          nextToken?: string | null,
        } | null,
        votes?:  {
          __typename: "ModelVoteConnection",
          nextToken?: string | null,
        } | null,
        voteResults?:  {
          __typename: "ModelVoteResultConnection",
          nextToken?: string | null,
        } | null,
        companyTheme?:  {
          __typename: "CompanyTheme",
          id: string,
          companyID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          domain: string,
          owner?: string | null,
          status?: CompanyStatus | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        postalsGRC?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
        postalsDivision?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPledgeResultQueryVariables = {
  id: string,
};

export type GetPledgeResultQuery = {
  getPledgeResult?:  {
    __typename: "PledgeResult",
    id: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    count: number,
    pollID: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListPledgeResultsQueryVariables = {
  filter?: ModelPledgeResultFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPledgeResultsQuery = {
  listPledgeResults?:  {
    __typename: "ModelPledgeResultConnection",
    items:  Array< {
      __typename: "PledgeResult",
      id: string,
      option:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      },
      count: number,
      pollID: string,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPledgeResultByPollIDQueryVariables = {
  pollID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPledgeResultFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetPledgeResultByPollIDQuery = {
  getPledgeResultByPollID?:  {
    __typename: "ModelPledgeResultConnection",
    items:  Array< {
      __typename: "PledgeResult",
      id: string,
      option:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      },
      count: number,
      pollID: string,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPollReportQueryVariables = {
  id: string,
};

export type GetPollReportQuery = {
  getPollReport?:  {
    __typename: "PollReport",
    id: string,
    title: string,
    description: string,
    pollID: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPollReportsQueryVariables = {
  filter?: ModelPollReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPollReportsQuery = {
  listPollReports?:  {
    __typename: "ModelPollReportConnection",
    items:  Array< {
      __typename: "PollReport",
      id: string,
      title: string,
      description: string,
      pollID: string,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListReportsByPollQueryVariables = {
  pollID?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPollReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReportsByPollQuery = {
  listReportsByPoll?:  {
    __typename: "ModelPollReportConnection",
    items:  Array< {
      __typename: "PollReport",
      id: string,
      title: string,
      description: string,
      pollID: string,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListReportsByOwnerQueryVariables = {
  owner?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPollReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListReportsByOwnerQuery = {
  listReportsByOwner?:  {
    __typename: "ModelPollReportConnection",
    items:  Array< {
      __typename: "PollReport",
      id: string,
      title: string,
      description: string,
      pollID: string,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPackageSubscriptionQueryVariables = {
  id: string,
};

export type GetPackageSubscriptionQuery = {
  getPackageSubscription?:  {
    __typename: "PackageSubscription",
    id: string,
    tier: Tier,
    price?: string | null,
    stripePriceID?: string | null,
    pollOptionLimit?: number | null,
    groupPollAllowed?: boolean | null,
    groupPollLimit?: number | null,
    pledgeAllowed?: boolean | null,
    pledgeChargePercentage?: string | null,
    pollDurationLimit?: string | null,
    pollResultLiveAllowed?: boolean | null,
    statisticReportAllowed?: boolean | null,
    withdrawalAllowed?: boolean | null,
    extensionPledgeAllowed?: boolean | null,
    noOfPolls?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPackageSubscriptionsQueryVariables = {
  filter?: ModelPackageSubscriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPackageSubscriptionsQuery = {
  listPackageSubscriptions?:  {
    __typename: "ModelPackageSubscriptionConnection",
    items:  Array< {
      __typename: "PackageSubscription",
      id: string,
      tier: Tier,
      price?: string | null,
      stripePriceID?: string | null,
      pollOptionLimit?: number | null,
      groupPollAllowed?: boolean | null,
      groupPollLimit?: number | null,
      pledgeAllowed?: boolean | null,
      pledgeChargePercentage?: string | null,
      pollDurationLimit?: string | null,
      pollResultLiveAllowed?: boolean | null,
      statisticReportAllowed?: boolean | null,
      withdrawalAllowed?: boolean | null,
      extensionPledgeAllowed?: boolean | null,
      noOfPolls?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPackageByTierQueryVariables = {
  tier?: Tier | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPackageSubscriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPackageByTierQuery = {
  listPackageByTier?:  {
    __typename: "ModelPackageSubscriptionConnection",
    items:  Array< {
      __typename: "PackageSubscription",
      id: string,
      tier: Tier,
      price?: string | null,
      stripePriceID?: string | null,
      pollOptionLimit?: number | null,
      groupPollAllowed?: boolean | null,
      groupPollLimit?: number | null,
      pledgeAllowed?: boolean | null,
      pledgeChargePercentage?: string | null,
      pollDurationLimit?: string | null,
      pollResultLiveAllowed?: boolean | null,
      statisticReportAllowed?: boolean | null,
      withdrawalAllowed?: boolean | null,
      extensionPledgeAllowed?: boolean | null,
      noOfPolls?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    email?: string | null,
    username?: string | null,
    owner?: string | null,
    phone?: string | null,
    type?: UserType | null,
    disable?: boolean | null,
    firstName?: string | null,
    lastName?: string | null,
    yearOfBirth?: number | null,
    gender?: string | null,
    education?: string | null,
    postalCode?: string | null,
    salaryRange?: UserSalaryRange | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    company?: string | null,
    createdAt: string,
    organisation?:  {
      __typename: "OrganisationInfo",
      name?: string | null,
      department?: string | null,
      jobTitle?: string | null,
    } | null,
    isSetup?: boolean | null,
    tier?: Tier | null,
    proxyUserID?: string | null,
    premiumPolls?: number | null,
    usedPremiumPolls?: number | null,
    cryptowallet?: string | null,
    updatedAt: string,
    postalInfo?:  {
      __typename: "PostalInfo",
      postal: string,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ByEmailQueryVariables = {
  email?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ByEmailQuery = {
  byEmail?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserByUsernameQueryVariables = {
  username?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GetUserByUsernameQuery = {
  getUserByUsername?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserByCompanyQueryVariables = {
  username?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserByCompanyQuery = {
  listUserByCompany?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUserByTierQueryVariables = {
  tier?: Tier | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserByTierQuery = {
  listUserByTier?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListUsersByProxyUserIDQueryVariables = {
  proxyUserID?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersByProxyUserIDQuery = {
  listUsersByProxyUserID?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCompanyUserQueryVariables = {
  id: string,
};

export type GetCompanyUserQuery = {
  getCompanyUser?:  {
    __typename: "CompanyUser",
    id: string,
    userID: string,
    username: string,
    companyID: string,
    adminID: string,
    role: CompanyRole,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type ListCompanyUsersQueryVariables = {
  filter?: ModelCompanyUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompanyUsersQuery = {
  listCompanyUsers?:  {
    __typename: "ModelCompanyUserConnection",
    items:  Array< {
      __typename: "CompanyUser",
      id: string,
      userID: string,
      username: string,
      companyID: string,
      adminID: string,
      role: CompanyRole,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCompanyRolesByAdminQueryVariables = {
  adminID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCompanyUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompanyRolesByAdminQuery = {
  listCompanyRolesByAdmin?:  {
    __typename: "ModelCompanyUserConnection",
    items:  Array< {
      __typename: "CompanyUser",
      id: string,
      userID: string,
      username: string,
      companyID: string,
      adminID: string,
      role: CompanyRole,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCompanyRolesByUserQueryVariables = {
  userID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCompanyUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompanyRolesByUserQuery = {
  listCompanyRolesByUser?:  {
    __typename: "ModelCompanyUserConnection",
    items:  Array< {
      __typename: "CompanyUser",
      id: string,
      userID: string,
      username: string,
      companyID: string,
      adminID: string,
      role: CompanyRole,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCompanyRolesByCompanyQueryVariables = {
  companyID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCompanyUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompanyRolesByCompanyQuery = {
  listCompanyRolesByCompany?:  {
    __typename: "ModelCompanyUserConnection",
    items:  Array< {
      __typename: "CompanyUser",
      id: string,
      userID: string,
      username: string,
      companyID: string,
      adminID: string,
      role: CompanyRole,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCompanyThemeQueryVariables = {
  id: string,
};

export type GetCompanyThemeQuery = {
  getCompanyTheme?:  {
    __typename: "CompanyTheme",
    id: string,
    companyID: string,
    attributes?:  {
      __typename: "CustomThemeAttribute",
      pollActivePeriodBgColor?: string | null,
      pollActivePeriodShadowColor?: string | null,
      pollQuestionCardBgColor?: string | null,
      pollQuestionCardQuestionColor?: string | null,
      pollQuestionCardAnswerColor?: string | null,
      pollPledgeCastBtnBgColor?: string | null,
      pollPledgeCastBtnBracketColor?: string | null,
      pollPledgeCastBtnTextColor?: string | null,
      pollPageBgColor?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListCompanyThemesQueryVariables = {
  filter?: ModelCompanyThemeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompanyThemesQuery = {
  listCompanyThemes?:  {
    __typename: "ModelCompanyThemeConnection",
    items:  Array< {
      __typename: "CompanyTheme",
      id: string,
      companyID: string,
      attributes?:  {
        __typename: "CustomThemeAttribute",
        pollActivePeriodBgColor?: string | null,
        pollActivePeriodShadowColor?: string | null,
        pollQuestionCardBgColor?: string | null,
        pollQuestionCardQuestionColor?: string | null,
        pollQuestionCardAnswerColor?: string | null,
        pollPledgeCastBtnBgColor?: string | null,
        pollPledgeCastBtnBracketColor?: string | null,
        pollPledgeCastBtnTextColor?: string | null,
        pollPageBgColor?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCompanyThemesByCompanyIDQueryVariables = {
  companyID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCompanyThemeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompanyThemesByCompanyIDQuery = {
  listCompanyThemesByCompanyID?:  {
    __typename: "ModelCompanyThemeConnection",
    items:  Array< {
      __typename: "CompanyTheme",
      id: string,
      companyID: string,
      attributes?:  {
        __typename: "CustomThemeAttribute",
        pollActivePeriodBgColor?: string | null,
        pollActivePeriodShadowColor?: string | null,
        pollQuestionCardBgColor?: string | null,
        pollQuestionCardQuestionColor?: string | null,
        pollQuestionCardAnswerColor?: string | null,
        pollPledgeCastBtnBgColor?: string | null,
        pollPledgeCastBtnBracketColor?: string | null,
        pollPledgeCastBtnTextColor?: string | null,
        pollPageBgColor?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCompanyQueryVariables = {
  id: string,
};

export type GetCompanyQuery = {
  getCompany?:  {
    __typename: "Company",
    id: string,
    name: string,
    domain: string,
    owner?: string | null,
    status?: CompanyStatus | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCompanysQueryVariables = {
  filter?: ModelCompanyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompanysQuery = {
  listCompanys?:  {
    __typename: "ModelCompanyConnection",
    items:  Array< {
      __typename: "Company",
      id: string,
      name: string,
      domain: string,
      owner?: string | null,
      status?: CompanyStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCompaniesByOwnerQueryVariables = {
  owner?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCompanyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompaniesByOwnerQuery = {
  listCompaniesByOwner?:  {
    __typename: "ModelCompanyConnection",
    items:  Array< {
      __typename: "Company",
      id: string,
      name: string,
      domain: string,
      owner?: string | null,
      status?: CompanyStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCompanyDomainQueryVariables = {
  id: string,
};

export type GetCompanyDomainQuery = {
  getCompanyDomain?:  {
    __typename: "CompanyDomain",
    id: string,
    companyID: string,
    domain: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListCompanyDomainsQueryVariables = {
  filter?: ModelCompanyDomainFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompanyDomainsQuery = {
  listCompanyDomains?:  {
    __typename: "ModelCompanyDomainConnection",
    items:  Array< {
      __typename: "CompanyDomain",
      id: string,
      companyID: string,
      domain: string,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCompanyDomainByCompanyIDQueryVariables = {
  companyID?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCompanyDomainFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCompanyDomainByCompanyIDQuery = {
  listCompanyDomainByCompanyID?:  {
    __typename: "ModelCompanyDomainConnection",
    items:  Array< {
      __typename: "CompanyDomain",
      id: string,
      companyID: string,
      domain: string,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetRequestJoinCompanyQueryVariables = {
  id: string,
};

export type GetRequestJoinCompanyQuery = {
  getRequestJoinCompany?:  {
    __typename: "RequestJoinCompany",
    id: string,
    userID: string,
    companyID: string,
    status: RequestJoinCompanyStatus,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type ListRequestJoinCompanysQueryVariables = {
  filter?: ModelRequestJoinCompanyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRequestJoinCompanysQuery = {
  listRequestJoinCompanys?:  {
    __typename: "ModelRequestJoinCompanyConnection",
    items:  Array< {
      __typename: "RequestJoinCompany",
      id: string,
      userID: string,
      companyID: string,
      status: RequestJoinCompanyStatus,
      createdAt: string,
      updatedAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRequestJoinCompanyByUserQueryVariables = {
  userID?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRequestJoinCompanyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRequestJoinCompanyByUserQuery = {
  listRequestJoinCompanyByUser?:  {
    __typename: "ModelRequestJoinCompanyConnection",
    items:  Array< {
      __typename: "RequestJoinCompany",
      id: string,
      userID: string,
      companyID: string,
      status: RequestJoinCompanyStatus,
      createdAt: string,
      updatedAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListRequestJoinCompanyByCompanyIDQueryVariables = {
  companyID?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelRequestJoinCompanyFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListRequestJoinCompanyByCompanyIDQuery = {
  listRequestJoinCompanyByCompanyID?:  {
    __typename: "ModelRequestJoinCompanyConnection",
    items:  Array< {
      __typename: "RequestJoinCompany",
      id: string,
      userID: string,
      companyID: string,
      status: RequestJoinCompanyStatus,
      createdAt: string,
      updatedAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAlertQueryVariables = {
  id: string,
};

export type GetAlertQuery = {
  getAlert?:  {
    __typename: "Alert",
    id: string,
    title?: string | null,
    detail?: string | null,
    pollID?: string | null,
    message?: string | null,
    type: AlertType,
    createdAt: string,
    userID: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type ListAlertsQueryVariables = {
  filter?: ModelAlertFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAlertsQuery = {
  listAlerts?:  {
    __typename: "ModelAlertConnection",
    items:  Array< {
      __typename: "Alert",
      id: string,
      title?: string | null,
      detail?: string | null,
      pollID?: string | null,
      message?: string | null,
      type: AlertType,
      createdAt: string,
      userID: string,
      updatedAt: string,
      poll?:  {
        __typename: "Poll",
        id: string,
        title: string,
        question: string,
        description?: string | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        theme?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        background?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        logo?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        status?: PollStatus | null,
        options?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        drawOptions?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        hasPledge?: boolean | null,
        isGroup?: boolean | null,
        featured?: boolean | null,
        winOption?:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } | null,
        startTime: string,
        endTime: string,
        pledgePeriod1StartTime?: string | null,
        pledgePeriod1EndTime?: string | null,
        pledgePeriod2StartTime?: string | null,
        pledgePeriod2EndTime?: string | null,
        owner?: string | null,
        password?: string | null,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        private?: number | null,
        companyID?: string | null,
        themeID?: string | null,
        representativeID?: string | null,
        isPremium?: boolean | null,
        maxVote?: number | null,
        isNotExact?: boolean | null,
        category?: string | null,
        hashtag?: Array< string | null > | null,
        updatedAt: string,
        comments?:  {
          __typename: "ModelPollCommentConnection",
          nextToken?: string | null,
        } | null,
        votes?:  {
          __typename: "ModelVoteConnection",
          nextToken?: string | null,
        } | null,
        voteResults?:  {
          __typename: "ModelVoteResultConnection",
          nextToken?: string | null,
        } | null,
        companyTheme?:  {
          __typename: "CompanyTheme",
          id: string,
          companyID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          domain: string,
          owner?: string | null,
          status?: CompanyStatus | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        postalsGRC?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
        postalsDivision?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListAlertsByUserQueryVariables = {
  userID?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAlertFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAlertsByUserQuery = {
  listAlertsByUser?:  {
    __typename: "ModelAlertConnection",
    items:  Array< {
      __typename: "Alert",
      id: string,
      title?: string | null,
      detail?: string | null,
      pollID?: string | null,
      message?: string | null,
      type: AlertType,
      createdAt: string,
      userID: string,
      updatedAt: string,
      poll?:  {
        __typename: "Poll",
        id: string,
        title: string,
        question: string,
        description?: string | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        theme?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        background?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        logo?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        status?: PollStatus | null,
        options?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        drawOptions?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        hasPledge?: boolean | null,
        isGroup?: boolean | null,
        featured?: boolean | null,
        winOption?:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } | null,
        startTime: string,
        endTime: string,
        pledgePeriod1StartTime?: string | null,
        pledgePeriod1EndTime?: string | null,
        pledgePeriod2StartTime?: string | null,
        pledgePeriod2EndTime?: string | null,
        owner?: string | null,
        password?: string | null,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        private?: number | null,
        companyID?: string | null,
        themeID?: string | null,
        representativeID?: string | null,
        isPremium?: boolean | null,
        maxVote?: number | null,
        isNotExact?: boolean | null,
        category?: string | null,
        hashtag?: Array< string | null > | null,
        updatedAt: string,
        comments?:  {
          __typename: "ModelPollCommentConnection",
          nextToken?: string | null,
        } | null,
        votes?:  {
          __typename: "ModelVoteConnection",
          nextToken?: string | null,
        } | null,
        voteResults?:  {
          __typename: "ModelVoteResultConnection",
          nextToken?: string | null,
        } | null,
        companyTheme?:  {
          __typename: "CompanyTheme",
          id: string,
          companyID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          domain: string,
          owner?: string | null,
          status?: CompanyStatus | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        postalsGRC?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
        postalsDivision?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetStripeAccountQueryVariables = {
  id: string,
};

export type GetStripeAccountQuery = {
  getStripeAccount?:  {
    __typename: "StripeAccount",
    id: string,
    userID: string,
    isOnboard: boolean,
    createdAt: string,
    amount?: string | null,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type ListStripeAccountsQueryVariables = {
  filter?: ModelStripeAccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStripeAccountsQuery = {
  listStripeAccounts?:  {
    __typename: "ModelStripeAccountConnection",
    items:  Array< {
      __typename: "StripeAccount",
      id: string,
      userID: string,
      isOnboard: boolean,
      createdAt: string,
      amount?: string | null,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListStripeAccountsByUserQueryVariables = {
  userID?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStripeAccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStripeAccountsByUserQuery = {
  listStripeAccountsByUser?:  {
    __typename: "ModelStripeAccountConnection",
    items:  Array< {
      __typename: "StripeAccount",
      id: string,
      userID: string,
      isOnboard: boolean,
      createdAt: string,
      amount?: string | null,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListStripeAccountsByOwnerQueryVariables = {
  owner?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStripeAccountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStripeAccountsByOwnerQuery = {
  listStripeAccountsByOwner?:  {
    __typename: "ModelStripeAccountConnection",
    items:  Array< {
      __typename: "StripeAccount",
      id: string,
      userID: string,
      isOnboard: boolean,
      createdAt: string,
      amount?: string | null,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetStripeCustomerQueryVariables = {
  id: string,
};

export type GetStripeCustomerQuery = {
  getStripeCustomer?:  {
    __typename: "StripeCustomer",
    id: string,
    userID: string,
    createdAt: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type ListStripeCustomersQueryVariables = {
  filter?: ModelStripeCustomerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStripeCustomersQuery = {
  listStripeCustomers?:  {
    __typename: "ModelStripeCustomerConnection",
    items:  Array< {
      __typename: "StripeCustomer",
      id: string,
      userID: string,
      createdAt: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListStripeCustomersByUserQueryVariables = {
  userID?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStripeCustomerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStripeCustomersByUserQuery = {
  listStripeCustomersByUser?:  {
    __typename: "ModelStripeCustomerConnection",
    items:  Array< {
      __typename: "StripeCustomer",
      id: string,
      userID: string,
      createdAt: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListStripeCustomersByOwnerQueryVariables = {
  owner?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStripeCustomerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStripeCustomersByOwnerQuery = {
  listStripeCustomersByOwner?:  {
    __typename: "ModelStripeCustomerConnection",
    items:  Array< {
      __typename: "StripeCustomer",
      id: string,
      userID: string,
      createdAt: string,
      owner?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetStripeChargeQueryVariables = {
  id: string,
};

export type GetStripeChargeQuery = {
  getStripeCharge?:  {
    __typename: "StripeCharge",
    id: string,
    userID: string,
    pollID: string,
    chargeID: string,
    status: StripeChargeStatus,
    amount: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListStripeChargesQueryVariables = {
  filter?: ModelStripeChargeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStripeChargesQuery = {
  listStripeCharges?:  {
    __typename: "ModelStripeChargeConnection",
    items:  Array< {
      __typename: "StripeCharge",
      id: string,
      userID: string,
      pollID: string,
      chargeID: string,
      status: StripeChargeStatus,
      amount: string,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListStripeChargesByPollQueryVariables = {
  pollID?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStripeChargeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStripeChargesByPollQuery = {
  listStripeChargesByPoll?:  {
    __typename: "ModelStripeChargeConnection",
    items:  Array< {
      __typename: "StripeCharge",
      id: string,
      userID: string,
      pollID: string,
      chargeID: string,
      status: StripeChargeStatus,
      amount: string,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListStripeChargesByChargeQueryVariables = {
  chargeID?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStripeChargeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStripeChargesByChargeQuery = {
  listStripeChargesByCharge?:  {
    __typename: "ModelStripeChargeConnection",
    items:  Array< {
      __typename: "StripeCharge",
      id: string,
      userID: string,
      pollID: string,
      chargeID: string,
      status: StripeChargeStatus,
      amount: string,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetStripeSubscriptionQueryVariables = {
  id: string,
};

export type GetStripeSubscriptionQuery = {
  getStripeSubscription?:  {
    __typename: "StripeSubscription",
    id: string,
    subscriptionID: string,
    customerID: string,
    userID: string,
    tier: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListStripeSubscriptionsQueryVariables = {
  filter?: ModelStripeSubscriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStripeSubscriptionsQuery = {
  listStripeSubscriptions?:  {
    __typename: "ModelStripeSubscriptionConnection",
    items:  Array< {
      __typename: "StripeSubscription",
      id: string,
      subscriptionID: string,
      customerID: string,
      userID: string,
      tier: string,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListStripeSubscriptionByUserQueryVariables = {
  userID?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStripeSubscriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStripeSubscriptionByUserQuery = {
  listStripeSubscriptionByUser?:  {
    __typename: "ModelStripeSubscriptionConnection",
    items:  Array< {
      __typename: "StripeSubscription",
      id: string,
      subscriptionID: string,
      customerID: string,
      userID: string,
      tier: string,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListStripeSubscriptionsBySubscriptionQueryVariables = {
  subscriptionID?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelStripeSubscriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListStripeSubscriptionsBySubscriptionQuery = {
  listStripeSubscriptionsBySubscription?:  {
    __typename: "ModelStripeSubscriptionConnection",
    items:  Array< {
      __typename: "StripeSubscription",
      id: string,
      subscriptionID: string,
      customerID: string,
      userID: string,
      tier: string,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProxyPollQueryVariables = {
  id: string,
};

export type GetProxyPollQuery = {
  getProxyPoll?:  {
    __typename: "ProxyPoll",
    id: string,
    proxyUserID: string,
    pollID: string,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type ListProxyPollsQueryVariables = {
  filter?: ModelProxyPollFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProxyPollsQuery = {
  listProxyPolls?:  {
    __typename: "ModelProxyPollConnection",
    items:  Array< {
      __typename: "ProxyPoll",
      id: string,
      proxyUserID: string,
      pollID: string,
      enabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      poll?:  {
        __typename: "Poll",
        id: string,
        title: string,
        question: string,
        description?: string | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        theme?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        background?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        logo?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        status?: PollStatus | null,
        options?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        drawOptions?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        hasPledge?: boolean | null,
        isGroup?: boolean | null,
        featured?: boolean | null,
        winOption?:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } | null,
        startTime: string,
        endTime: string,
        pledgePeriod1StartTime?: string | null,
        pledgePeriod1EndTime?: string | null,
        pledgePeriod2StartTime?: string | null,
        pledgePeriod2EndTime?: string | null,
        owner?: string | null,
        password?: string | null,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        private?: number | null,
        companyID?: string | null,
        themeID?: string | null,
        representativeID?: string | null,
        isPremium?: boolean | null,
        maxVote?: number | null,
        isNotExact?: boolean | null,
        category?: string | null,
        hashtag?: Array< string | null > | null,
        updatedAt: string,
        comments?:  {
          __typename: "ModelPollCommentConnection",
          nextToken?: string | null,
        } | null,
        votes?:  {
          __typename: "ModelVoteConnection",
          nextToken?: string | null,
        } | null,
        voteResults?:  {
          __typename: "ModelVoteResultConnection",
          nextToken?: string | null,
        } | null,
        companyTheme?:  {
          __typename: "CompanyTheme",
          id: string,
          companyID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          domain: string,
          owner?: string | null,
          status?: CompanyStatus | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        postalsGRC?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
        postalsDivision?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListProxyPollsByProxyUserIDQueryVariables = {
  proxyUserID?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProxyPollFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProxyPollsByProxyUserIDQuery = {
  listProxyPollsByProxyUserID?:  {
    __typename: "ModelProxyPollConnection",
    items:  Array< {
      __typename: "ProxyPoll",
      id: string,
      proxyUserID: string,
      pollID: string,
      enabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      poll?:  {
        __typename: "Poll",
        id: string,
        title: string,
        question: string,
        description?: string | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        theme?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        background?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        logo?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        status?: PollStatus | null,
        options?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        drawOptions?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        hasPledge?: boolean | null,
        isGroup?: boolean | null,
        featured?: boolean | null,
        winOption?:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } | null,
        startTime: string,
        endTime: string,
        pledgePeriod1StartTime?: string | null,
        pledgePeriod1EndTime?: string | null,
        pledgePeriod2StartTime?: string | null,
        pledgePeriod2EndTime?: string | null,
        owner?: string | null,
        password?: string | null,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        private?: number | null,
        companyID?: string | null,
        themeID?: string | null,
        representativeID?: string | null,
        isPremium?: boolean | null,
        maxVote?: number | null,
        isNotExact?: boolean | null,
        category?: string | null,
        hashtag?: Array< string | null > | null,
        updatedAt: string,
        comments?:  {
          __typename: "ModelPollCommentConnection",
          nextToken?: string | null,
        } | null,
        votes?:  {
          __typename: "ModelVoteConnection",
          nextToken?: string | null,
        } | null,
        voteResults?:  {
          __typename: "ModelVoteResultConnection",
          nextToken?: string | null,
        } | null,
        companyTheme?:  {
          __typename: "CompanyTheme",
          id: string,
          companyID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          domain: string,
          owner?: string | null,
          status?: CompanyStatus | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        postalsGRC?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
        postalsDivision?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListProxyPollsByPollIDQueryVariables = {
  pollID?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProxyPollFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProxyPollsByPollIDQuery = {
  listProxyPollsByPollID?:  {
    __typename: "ModelProxyPollConnection",
    items:  Array< {
      __typename: "ProxyPoll",
      id: string,
      proxyUserID: string,
      pollID: string,
      enabled?: boolean | null,
      createdAt: string,
      updatedAt: string,
      poll?:  {
        __typename: "Poll",
        id: string,
        title: string,
        question: string,
        description?: string | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        theme?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        background?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        logo?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        status?: PollStatus | null,
        options?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        drawOptions?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        hasPledge?: boolean | null,
        isGroup?: boolean | null,
        featured?: boolean | null,
        winOption?:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } | null,
        startTime: string,
        endTime: string,
        pledgePeriod1StartTime?: string | null,
        pledgePeriod1EndTime?: string | null,
        pledgePeriod2StartTime?: string | null,
        pledgePeriod2EndTime?: string | null,
        owner?: string | null,
        password?: string | null,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        private?: number | null,
        companyID?: string | null,
        themeID?: string | null,
        representativeID?: string | null,
        isPremium?: boolean | null,
        maxVote?: number | null,
        isNotExact?: boolean | null,
        category?: string | null,
        hashtag?: Array< string | null > | null,
        updatedAt: string,
        comments?:  {
          __typename: "ModelPollCommentConnection",
          nextToken?: string | null,
        } | null,
        votes?:  {
          __typename: "ModelVoteConnection",
          nextToken?: string | null,
        } | null,
        voteResults?:  {
          __typename: "ModelVoteResultConnection",
          nextToken?: string | null,
        } | null,
        companyTheme?:  {
          __typename: "CompanyTheme",
          id: string,
          companyID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          domain: string,
          owner?: string | null,
          status?: CompanyStatus | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        postalsGRC?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
        postalsDivision?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
      } | null,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetDefaultConfigurationQueryVariables = {
  id: string,
};

export type GetDefaultConfigurationQuery = {
  getDefaultConfiguration?:  {
    __typename: "DefaultConfiguration",
    id: string,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    pollImage?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListDefaultConfigurationsQueryVariables = {
  filter?: ModelDefaultConfigurationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListDefaultConfigurationsQuery = {
  listDefaultConfigurations?:  {
    __typename: "ModelDefaultConfigurationConnection",
    items:  Array< {
      __typename: "DefaultConfiguration",
      id: string,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      pollImage?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetCustomConfigurationQueryVariables = {
  id: string,
};

export type GetCustomConfigurationQuery = {
  getCustomConfiguration?:  {
    __typename: "CustomConfiguration",
    id: string,
    companyID: string,
    field?: string | null,
    value?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListCustomConfigurationsQueryVariables = {
  filter?: ModelCustomConfigurationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCustomConfigurationsQuery = {
  listCustomConfigurations?:  {
    __typename: "ModelCustomConfigurationConnection",
    items:  Array< {
      __typename: "CustomConfiguration",
      id: string,
      companyID: string,
      field?: string | null,
      value?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListCustomConfigurationByCompanyQueryVariables = {
  companyID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelCustomConfigurationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListCustomConfigurationByCompanyQuery = {
  listCustomConfigurationByCompany?:  {
    __typename: "ModelCustomConfigurationConnection",
    items:  Array< {
      __typename: "CustomConfiguration",
      id: string,
      companyID: string,
      field?: string | null,
      value?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPollCountQueryVariables = {
  id: string,
};

export type GetPollCountQuery = {
  getPollCount?:  {
    __typename: "PollCount",
    id: string,
    count?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPollCountsQueryVariables = {
  filter?: ModelPollCountFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPollCountsQuery = {
  listPollCounts?:  {
    __typename: "ModelPollCountConnection",
    items:  Array< {
      __typename: "PollCount",
      id: string,
      count?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPopUpQueryVariables = {
  id: string,
};

export type GetPopUpQuery = {
  getPopUp?:  {
    __typename: "PopUp",
    id: string,
    status: PopUpStatus,
    type: PopUpType,
    pollID: string,
    updatedAt: string,
    createdAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type ListPopUpsQueryVariables = {
  filter?: ModelPopUpFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPopUpsQuery = {
  listPopUps?:  {
    __typename: "ModelPopUpConnection",
    items:  Array< {
      __typename: "PopUp",
      id: string,
      status: PopUpStatus,
      type: PopUpType,
      pollID: string,
      updatedAt: string,
      createdAt: string,
      poll?:  {
        __typename: "Poll",
        id: string,
        title: string,
        question: string,
        description?: string | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        theme?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        background?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        logo?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        status?: PollStatus | null,
        options?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        drawOptions?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        hasPledge?: boolean | null,
        isGroup?: boolean | null,
        featured?: boolean | null,
        winOption?:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } | null,
        startTime: string,
        endTime: string,
        pledgePeriod1StartTime?: string | null,
        pledgePeriod1EndTime?: string | null,
        pledgePeriod2StartTime?: string | null,
        pledgePeriod2EndTime?: string | null,
        owner?: string | null,
        password?: string | null,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        private?: number | null,
        companyID?: string | null,
        themeID?: string | null,
        representativeID?: string | null,
        isPremium?: boolean | null,
        maxVote?: number | null,
        isNotExact?: boolean | null,
        category?: string | null,
        hashtag?: Array< string | null > | null,
        updatedAt: string,
        comments?:  {
          __typename: "ModelPollCommentConnection",
          nextToken?: string | null,
        } | null,
        votes?:  {
          __typename: "ModelVoteConnection",
          nextToken?: string | null,
        } | null,
        voteResults?:  {
          __typename: "ModelVoteResultConnection",
          nextToken?: string | null,
        } | null,
        companyTheme?:  {
          __typename: "CompanyTheme",
          id: string,
          companyID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          domain: string,
          owner?: string | null,
          status?: CompanyStatus | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        postalsGRC?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
        postalsDivision?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPopUpsByTypeQueryVariables = {
  type?: PopUpType | null,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPopUpFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPopUpsByTypeQuery = {
  listPopUpsByType?:  {
    __typename: "ModelPopUpConnection",
    items:  Array< {
      __typename: "PopUp",
      id: string,
      status: PopUpStatus,
      type: PopUpType,
      pollID: string,
      updatedAt: string,
      createdAt: string,
      poll?:  {
        __typename: "Poll",
        id: string,
        title: string,
        question: string,
        description?: string | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        theme?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        background?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        logo?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        status?: PollStatus | null,
        options?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        drawOptions?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        hasPledge?: boolean | null,
        isGroup?: boolean | null,
        featured?: boolean | null,
        winOption?:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } | null,
        startTime: string,
        endTime: string,
        pledgePeriod1StartTime?: string | null,
        pledgePeriod1EndTime?: string | null,
        pledgePeriod2StartTime?: string | null,
        pledgePeriod2EndTime?: string | null,
        owner?: string | null,
        password?: string | null,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        private?: number | null,
        companyID?: string | null,
        themeID?: string | null,
        representativeID?: string | null,
        isPremium?: boolean | null,
        maxVote?: number | null,
        isNotExact?: boolean | null,
        category?: string | null,
        hashtag?: Array< string | null > | null,
        updatedAt: string,
        comments?:  {
          __typename: "ModelPollCommentConnection",
          nextToken?: string | null,
        } | null,
        votes?:  {
          __typename: "ModelVoteConnection",
          nextToken?: string | null,
        } | null,
        voteResults?:  {
          __typename: "ModelVoteResultConnection",
          nextToken?: string | null,
        } | null,
        companyTheme?:  {
          __typename: "CompanyTheme",
          id: string,
          companyID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          domain: string,
          owner?: string | null,
          status?: CompanyStatus | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        postalsGRC?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
        postalsDivision?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPopUpsByStatusQueryVariables = {
  status?: PopUpStatus | null,
  updatedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPopUpFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPopUpsByStatusQuery = {
  listPopUpsByStatus?:  {
    __typename: "ModelPopUpConnection",
    items:  Array< {
      __typename: "PopUp",
      id: string,
      status: PopUpStatus,
      type: PopUpType,
      pollID: string,
      updatedAt: string,
      createdAt: string,
      poll?:  {
        __typename: "Poll",
        id: string,
        title: string,
        question: string,
        description?: string | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        theme?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        background?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        logo?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        status?: PollStatus | null,
        options?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        drawOptions?:  Array< {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } > | null,
        hasPledge?: boolean | null,
        isGroup?: boolean | null,
        featured?: boolean | null,
        winOption?:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        } | null,
        startTime: string,
        endTime: string,
        pledgePeriod1StartTime?: string | null,
        pledgePeriod1EndTime?: string | null,
        pledgePeriod2StartTime?: string | null,
        pledgePeriod2EndTime?: string | null,
        owner?: string | null,
        password?: string | null,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        private?: number | null,
        companyID?: string | null,
        themeID?: string | null,
        representativeID?: string | null,
        isPremium?: boolean | null,
        maxVote?: number | null,
        isNotExact?: boolean | null,
        category?: string | null,
        hashtag?: Array< string | null > | null,
        updatedAt: string,
        comments?:  {
          __typename: "ModelPollCommentConnection",
          nextToken?: string | null,
        } | null,
        votes?:  {
          __typename: "ModelVoteConnection",
          nextToken?: string | null,
        } | null,
        voteResults?:  {
          __typename: "ModelVoteResultConnection",
          nextToken?: string | null,
        } | null,
        companyTheme?:  {
          __typename: "CompanyTheme",
          id: string,
          companyID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null,
        company?:  {
          __typename: "Company",
          id: string,
          name: string,
          domain: string,
          owner?: string | null,
          status?: CompanyStatus | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        postalsGRC?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
        postalsDivision?:  {
          __typename: "ModelPostalInfoConnection",
          nextToken?: string | null,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPostalInfoQueryVariables = {
  postal: string,
};

export type GetPostalInfoQuery = {
  getPostalInfo?:  {
    __typename: "PostalInfo",
    postal: string,
    grc?: string | null,
    division?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListPostalInfosQueryVariables = {
  postal?: string | null,
  filter?: ModelPostalInfoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListPostalInfosQuery = {
  listPostalInfos?:  {
    __typename: "ModelPostalInfoConnection",
    items:  Array< {
      __typename: "PostalInfo",
      postal: string,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPostalInfoByGRCQueryVariables = {
  grc?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPostalInfoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPostalInfoByGRCQuery = {
  listPostalInfoByGRC?:  {
    __typename: "ModelPostalInfoConnection",
    items:  Array< {
      __typename: "PostalInfo",
      postal: string,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPostalInfoByDivisionQueryVariables = {
  division?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPostalInfoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPostalInfoByDivisionQuery = {
  listPostalInfoByDivision?:  {
    __typename: "ModelPostalInfoConnection",
    items:  Array< {
      __typename: "PostalInfo",
      postal: string,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetPremiumPollPurchaseQueryVariables = {
  id: string,
};

export type GetPremiumPollPurchaseQuery = {
  getPremiumPollPurchase?:  {
    __typename: "PremiumPollPurchase",
    id: string,
    userID: string,
    createdAt: string,
    amount?: string | null,
    chargeID?: string | null,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type ListPremiumPollPurchasesQueryVariables = {
  filter?: ModelPremiumPollPurchaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPremiumPollPurchasesQuery = {
  listPremiumPollPurchases?:  {
    __typename: "ModelPremiumPollPurchaseConnection",
    items:  Array< {
      __typename: "PremiumPollPurchase",
      id: string,
      userID: string,
      createdAt: string,
      amount?: string | null,
      chargeID?: string | null,
      updatedAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListPremiumPollPurchaseByUserQueryVariables = {
  userID?: string | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPremiumPollPurchaseFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPremiumPollPurchaseByUserQuery = {
  listPremiumPollPurchaseByUser?:  {
    __typename: "ModelPremiumPollPurchaseConnection",
    items:  Array< {
      __typename: "PremiumPollPurchase",
      id: string,
      userID: string,
      createdAt: string,
      amount?: string | null,
      chargeID?: string | null,
      updatedAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetIdeaCategoryQueryVariables = {
  id: string,
};

export type GetIdeaCategoryQuery = {
  getIdeaCategory?:  {
    __typename: "IdeaCategory",
    id: string,
    title?: string | null,
    edu?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListIdeaCategorysQueryVariables = {
  filter?: ModelIdeaCategoryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListIdeaCategorysQuery = {
  listIdeaCategorys?:  {
    __typename: "ModelIdeaCategoryConnection",
    items:  Array< {
      __typename: "IdeaCategory",
      id: string,
      title?: string | null,
      edu?: boolean | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetIdeaHashtagQueryVariables = {
  id: string,
};

export type GetIdeaHashtagQuery = {
  getIdeaHashtag?:  {
    __typename: "IdeaHashtag",
    id: string,
    title?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListIdeaHashtagsQueryVariables = {
  filter?: ModelIdeaHashtagFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListIdeaHashtagsQuery = {
  listIdeaHashtags?:  {
    __typename: "ModelIdeaHashtagConnection",
    items:  Array< {
      __typename: "IdeaHashtag",
      id: string,
      title?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetIdeaQueryVariables = {
  id: string,
};

export type GetIdeaQuery = {
  getIdea?:  {
    __typename: "Idea",
    id: string,
    title: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    featured?: boolean | null,
    startTime: string,
    endTime: string,
    owner?: string | null,
    createdAt: string,
    companyID?: string | null,
    themeID?: string | null,
    category?: string | null,
    hashtag?: Array< string | null > | null,
    updatedAt: string,
    companyTheme?:  {
      __typename: "CompanyTheme",
      id: string,
      companyID: string,
      attributes?:  {
        __typename: "CustomThemeAttribute",
        pollActivePeriodBgColor?: string | null,
        pollActivePeriodShadowColor?: string | null,
        pollQuestionCardBgColor?: string | null,
        pollQuestionCardQuestionColor?: string | null,
        pollQuestionCardAnswerColor?: string | null,
        pollPledgeCastBtnBgColor?: string | null,
        pollPledgeCastBtnBracketColor?: string | null,
        pollPledgeCastBtnTextColor?: string | null,
        pollPageBgColor?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      domain: string,
      owner?: string | null,
      status?: CompanyStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    pledges?:  {
      __typename: "ModelIdeaPledgeConnection",
      items:  Array< {
        __typename: "IdeaPledge",
        id: string,
        ideaID: string,
        title?: string | null,
        description?: string | null,
        video?: string | null,
        price: string,
        currency: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelIdeaCommentConnection",
      items:  Array< {
        __typename: "IdeaComment",
        id: string,
        ideaID: string,
        userID: string,
        content: string,
        avatar?: string | null,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    scores?:  {
      __typename: "ModelIdeaScoreConnection",
      items:  Array< {
        __typename: "IdeaScore",
        id: string,
        ideaID: string,
        userID: string,
        level_of_success: number,
        investment_required: number,
        talent_required: number,
        consultation_required: number,
        connection_required: number,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type ListIdeasQueryVariables = {
  filter?: ModelIdeaFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListIdeasQuery = {
  listIdeas?:  {
    __typename: "ModelIdeaConnection",
    items:  Array< {
      __typename: "Idea",
      id: string,
      title: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      featured?: boolean | null,
      startTime: string,
      endTime: string,
      owner?: string | null,
      createdAt: string,
      companyID?: string | null,
      themeID?: string | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      pledges?:  {
        __typename: "ModelIdeaPledgeConnection",
        items:  Array< {
          __typename: "IdeaPledge",
          id: string,
          ideaID: string,
          title?: string | null,
          description?: string | null,
          video?: string | null,
          price: string,
          currency: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelIdeaCommentConnection",
        items:  Array< {
          __typename: "IdeaComment",
          id: string,
          ideaID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      scores?:  {
        __typename: "ModelIdeaScoreConnection",
        items:  Array< {
          __typename: "IdeaScore",
          id: string,
          ideaID: string,
          userID: string,
          level_of_success: number,
          investment_required: number,
          talent_required: number,
          consultation_required: number,
          connection_required: number,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListIdeasByOwnerQueryVariables = {
  owner?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelIdeaFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListIdeasByOwnerQuery = {
  listIdeasByOwner?:  {
    __typename: "ModelIdeaConnection",
    items:  Array< {
      __typename: "Idea",
      id: string,
      title: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      featured?: boolean | null,
      startTime: string,
      endTime: string,
      owner?: string | null,
      createdAt: string,
      companyID?: string | null,
      themeID?: string | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      pledges?:  {
        __typename: "ModelIdeaPledgeConnection",
        items:  Array< {
          __typename: "IdeaPledge",
          id: string,
          ideaID: string,
          title?: string | null,
          description?: string | null,
          video?: string | null,
          price: string,
          currency: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      comments?:  {
        __typename: "ModelIdeaCommentConnection",
        items:  Array< {
          __typename: "IdeaComment",
          id: string,
          ideaID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      scores?:  {
        __typename: "ModelIdeaScoreConnection",
        items:  Array< {
          __typename: "IdeaScore",
          id: string,
          ideaID: string,
          userID: string,
          level_of_success: number,
          investment_required: number,
          talent_required: number,
          consultation_required: number,
          connection_required: number,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetIdeaPledgeQueryVariables = {
  id: string,
};

export type GetIdeaPledgeQuery = {
  getIdeaPledge?:  {
    __typename: "IdeaPledge",
    id: string,
    ideaID: string,
    title?: string | null,
    description?: string | null,
    video?: string | null,
    price: string,
    currency: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListIdeaPledgesQueryVariables = {
  filter?: ModelIdeaPledgeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListIdeaPledgesQuery = {
  listIdeaPledges?:  {
    __typename: "ModelIdeaPledgeConnection",
    items:  Array< {
      __typename: "IdeaPledge",
      id: string,
      ideaID: string,
      title?: string | null,
      description?: string | null,
      video?: string | null,
      price: string,
      currency: string,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetIdeaCommentQueryVariables = {
  id: string,
};

export type GetIdeaCommentQuery = {
  getIdeaComment?:  {
    __typename: "IdeaComment",
    id: string,
    ideaID: string,
    userID: string,
    content: string,
    avatar?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListIdeaCommentsQueryVariables = {
  filter?: ModelIdeaCommentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListIdeaCommentsQuery = {
  listIdeaComments?:  {
    __typename: "ModelIdeaCommentConnection",
    items:  Array< {
      __typename: "IdeaComment",
      id: string,
      ideaID: string,
      userID: string,
      content: string,
      avatar?: string | null,
      name?: string | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetIdeaPledgeStripeChargeQueryVariables = {
  id: string,
};

export type GetIdeaPledgeStripeChargeQuery = {
  getIdeaPledgeStripeCharge?:  {
    __typename: "IdeaPledgeStripeCharge",
    id: string,
    userID: string,
    ideaID: string,
    ideaPledgeID: string,
    chargeID: string,
    status: StripeChargeStatus,
    amount: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type ListIdeaPledgeStripeChargesQueryVariables = {
  filter?: ModelIdeaPledgeStripeChargeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListIdeaPledgeStripeChargesQuery = {
  listIdeaPledgeStripeCharges?:  {
    __typename: "ModelIdeaPledgeStripeChargeConnection",
    items:  Array< {
      __typename: "IdeaPledgeStripeCharge",
      id: string,
      userID: string,
      ideaID: string,
      ideaPledgeID: string,
      chargeID: string,
      status: StripeChargeStatus,
      amount: string,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListIdeaPledgeStripeChargesByIdeaQueryVariables = {
  ideaID?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelIdeaPledgeStripeChargeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListIdeaPledgeStripeChargesByIdeaQuery = {
  listIdeaPledgeStripeChargesByIdea?:  {
    __typename: "ModelIdeaPledgeStripeChargeConnection",
    items:  Array< {
      __typename: "IdeaPledgeStripeCharge",
      id: string,
      userID: string,
      ideaID: string,
      ideaPledgeID: string,
      chargeID: string,
      status: StripeChargeStatus,
      amount: string,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListIdeaPledgeStripeChargesByIdeaPledgeQueryVariables = {
  ideaPledgeID?: string | null,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelIdeaPledgeStripeChargeFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListIdeaPledgeStripeChargesByIdeaPledgeQuery = {
  listIdeaPledgeStripeChargesByIdeaPledge?:  {
    __typename: "ModelIdeaPledgeStripeChargeConnection",
    items:  Array< {
      __typename: "IdeaPledgeStripeCharge",
      id: string,
      userID: string,
      ideaID: string,
      ideaPledgeID: string,
      chargeID: string,
      status: StripeChargeStatus,
      amount: string,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
      user?:  {
        __typename: "User",
        id: string,
        email?: string | null,
        username?: string | null,
        owner?: string | null,
        phone?: string | null,
        type?: UserType | null,
        disable?: boolean | null,
        firstName?: string | null,
        lastName?: string | null,
        yearOfBirth?: number | null,
        gender?: string | null,
        education?: string | null,
        postalCode?: string | null,
        salaryRange?: UserSalaryRange | null,
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        company?: string | null,
        createdAt: string,
        organisation?:  {
          __typename: "OrganisationInfo",
          name?: string | null,
          department?: string | null,
          jobTitle?: string | null,
        } | null,
        isSetup?: boolean | null,
        tier?: Tier | null,
        proxyUserID?: string | null,
        premiumPolls?: number | null,
        usedPremiumPolls?: number | null,
        cryptowallet?: string | null,
        updatedAt: string,
        postalInfo?:  {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
      } | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetIdeaScoreQueryVariables = {
  id: string,
};

export type GetIdeaScoreQuery = {
  getIdeaScore?:  {
    __typename: "IdeaScore",
    id: string,
    ideaID: string,
    userID: string,
    level_of_success: number,
    investment_required: number,
    talent_required: number,
    consultation_required: number,
    connection_required: number,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListIdeaScoresQueryVariables = {
  filter?: ModelIdeaScoreFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListIdeaScoresQuery = {
  listIdeaScores?:  {
    __typename: "ModelIdeaScoreConnection",
    items:  Array< {
      __typename: "IdeaScore",
      id: string,
      ideaID: string,
      userID: string,
      level_of_success: number,
      investment_required: number,
      talent_required: number,
      consultation_required: number,
      connection_required: number,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetIdeaSupporterQueryVariables = {
  id: string,
};

export type GetIdeaSupporterQuery = {
  getIdeaSupporter?:  {
    __typename: "IdeaSupporter",
    id: string,
    url?: string | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type ListIdeaSupportersQueryVariables = {
  filter?: ModelIdeaSupporterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListIdeaSupportersQuery = {
  listIdeaSupporters?:  {
    __typename: "ModelIdeaSupporterConnection",
    items:  Array< {
      __typename: "IdeaSupporter",
      id: string,
      url?: string | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type OnCreatePollCommentSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreatePollCommentSubscription = {
  onCreatePollComment?:  {
    __typename: "PollComment",
    id: string,
    pollID: string,
    userID: string,
    content: string,
    avatar?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdatePollCommentSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdatePollCommentSubscription = {
  onUpdatePollComment?:  {
    __typename: "PollComment",
    id: string,
    pollID: string,
    userID: string,
    content: string,
    avatar?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeletePollCommentSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeletePollCommentSubscription = {
  onDeletePollComment?:  {
    __typename: "PollComment",
    id: string,
    pollID: string,
    userID: string,
    content: string,
    avatar?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreatePollSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreatePollSubscription = {
  onCreatePoll?:  {
    __typename: "Poll",
    id: string,
    title: string,
    question: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    status?: PollStatus | null,
    options?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    drawOptions?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    hasPledge?: boolean | null,
    isGroup?: boolean | null,
    featured?: boolean | null,
    winOption?:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } | null,
    startTime: string,
    endTime: string,
    pledgePeriod1StartTime?: string | null,
    pledgePeriod1EndTime?: string | null,
    pledgePeriod2StartTime?: string | null,
    pledgePeriod2EndTime?: string | null,
    owner?: string | null,
    password?: string | null,
    grc?: string | null,
    division?: string | null,
    createdAt: string,
    private?: number | null,
    companyID?: string | null,
    themeID?: string | null,
    representativeID?: string | null,
    isPremium?: boolean | null,
    maxVote?: number | null,
    isNotExact?: boolean | null,
    category?: string | null,
    hashtag?: Array< string | null > | null,
    updatedAt: string,
    comments?:  {
      __typename: "ModelPollCommentConnection",
      items:  Array< {
        __typename: "PollComment",
        id: string,
        pollID: string,
        userID: string,
        content: string,
        avatar?: string | null,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    votes?:  {
      __typename: "ModelVoteConnection",
      items:  Array< {
        __typename: "Vote",
        id: string,
        userID: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        type: VoteType,
        subPollID?: string | null,
        reason?: string | null,
        pollID: string,
        proxyUserID?: string | null,
        createdAt: string,
        updatedAt: string,
        poll?:  {
          __typename: "Poll",
          id: string,
          title: string,
          question: string,
          description?: string | null,
          video?: string | null,
          status?: PollStatus | null,
          hasPledge?: boolean | null,
          isGroup?: boolean | null,
          featured?: boolean | null,
          startTime: string,
          endTime: string,
          pledgePeriod1StartTime?: string | null,
          pledgePeriod1EndTime?: string | null,
          pledgePeriod2StartTime?: string | null,
          pledgePeriod2EndTime?: string | null,
          owner?: string | null,
          password?: string | null,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          private?: number | null,
          companyID?: string | null,
          themeID?: string | null,
          representativeID?: string | null,
          isPremium?: boolean | null,
          maxVote?: number | null,
          isNotExact?: boolean | null,
          category?: string | null,
          hashtag?: Array< string | null > | null,
          updatedAt: string,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          email?: string | null,
          username?: string | null,
          owner?: string | null,
          phone?: string | null,
          type?: UserType | null,
          disable?: boolean | null,
          firstName?: string | null,
          lastName?: string | null,
          yearOfBirth?: number | null,
          gender?: string | null,
          education?: string | null,
          postalCode?: string | null,
          salaryRange?: UserSalaryRange | null,
          company?: string | null,
          createdAt: string,
          isSetup?: boolean | null,
          tier?: Tier | null,
          proxyUserID?: string | null,
          premiumPolls?: number | null,
          usedPremiumPolls?: number | null,
          cryptowallet?: string | null,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    voteResults?:  {
      __typename: "ModelVoteResultConnection",
      items:  Array< {
        __typename: "VoteResult",
        id: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        count: number,
        subPollID?: string | null,
        pollID: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    companyTheme?:  {
      __typename: "CompanyTheme",
      id: string,
      companyID: string,
      attributes?:  {
        __typename: "CustomThemeAttribute",
        pollActivePeriodBgColor?: string | null,
        pollActivePeriodShadowColor?: string | null,
        pollQuestionCardBgColor?: string | null,
        pollQuestionCardQuestionColor?: string | null,
        pollQuestionCardAnswerColor?: string | null,
        pollPledgeCastBtnBgColor?: string | null,
        pollPledgeCastBtnBracketColor?: string | null,
        pollPledgeCastBtnTextColor?: string | null,
        pollPageBgColor?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      domain: string,
      owner?: string | null,
      status?: CompanyStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    postalsGRC?:  {
      __typename: "ModelPostalInfoConnection",
      items:  Array< {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    postalsDivision?:  {
      __typename: "ModelPostalInfoConnection",
      items:  Array< {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnUpdatePollSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdatePollSubscription = {
  onUpdatePoll?:  {
    __typename: "Poll",
    id: string,
    title: string,
    question: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    status?: PollStatus | null,
    options?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    drawOptions?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    hasPledge?: boolean | null,
    isGroup?: boolean | null,
    featured?: boolean | null,
    winOption?:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } | null,
    startTime: string,
    endTime: string,
    pledgePeriod1StartTime?: string | null,
    pledgePeriod1EndTime?: string | null,
    pledgePeriod2StartTime?: string | null,
    pledgePeriod2EndTime?: string | null,
    owner?: string | null,
    password?: string | null,
    grc?: string | null,
    division?: string | null,
    createdAt: string,
    private?: number | null,
    companyID?: string | null,
    themeID?: string | null,
    representativeID?: string | null,
    isPremium?: boolean | null,
    maxVote?: number | null,
    isNotExact?: boolean | null,
    category?: string | null,
    hashtag?: Array< string | null > | null,
    updatedAt: string,
    comments?:  {
      __typename: "ModelPollCommentConnection",
      items:  Array< {
        __typename: "PollComment",
        id: string,
        pollID: string,
        userID: string,
        content: string,
        avatar?: string | null,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    votes?:  {
      __typename: "ModelVoteConnection",
      items:  Array< {
        __typename: "Vote",
        id: string,
        userID: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        type: VoteType,
        subPollID?: string | null,
        reason?: string | null,
        pollID: string,
        proxyUserID?: string | null,
        createdAt: string,
        updatedAt: string,
        poll?:  {
          __typename: "Poll",
          id: string,
          title: string,
          question: string,
          description?: string | null,
          video?: string | null,
          status?: PollStatus | null,
          hasPledge?: boolean | null,
          isGroup?: boolean | null,
          featured?: boolean | null,
          startTime: string,
          endTime: string,
          pledgePeriod1StartTime?: string | null,
          pledgePeriod1EndTime?: string | null,
          pledgePeriod2StartTime?: string | null,
          pledgePeriod2EndTime?: string | null,
          owner?: string | null,
          password?: string | null,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          private?: number | null,
          companyID?: string | null,
          themeID?: string | null,
          representativeID?: string | null,
          isPremium?: boolean | null,
          maxVote?: number | null,
          isNotExact?: boolean | null,
          category?: string | null,
          hashtag?: Array< string | null > | null,
          updatedAt: string,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          email?: string | null,
          username?: string | null,
          owner?: string | null,
          phone?: string | null,
          type?: UserType | null,
          disable?: boolean | null,
          firstName?: string | null,
          lastName?: string | null,
          yearOfBirth?: number | null,
          gender?: string | null,
          education?: string | null,
          postalCode?: string | null,
          salaryRange?: UserSalaryRange | null,
          company?: string | null,
          createdAt: string,
          isSetup?: boolean | null,
          tier?: Tier | null,
          proxyUserID?: string | null,
          premiumPolls?: number | null,
          usedPremiumPolls?: number | null,
          cryptowallet?: string | null,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    voteResults?:  {
      __typename: "ModelVoteResultConnection",
      items:  Array< {
        __typename: "VoteResult",
        id: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        count: number,
        subPollID?: string | null,
        pollID: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    companyTheme?:  {
      __typename: "CompanyTheme",
      id: string,
      companyID: string,
      attributes?:  {
        __typename: "CustomThemeAttribute",
        pollActivePeriodBgColor?: string | null,
        pollActivePeriodShadowColor?: string | null,
        pollQuestionCardBgColor?: string | null,
        pollQuestionCardQuestionColor?: string | null,
        pollQuestionCardAnswerColor?: string | null,
        pollPledgeCastBtnBgColor?: string | null,
        pollPledgeCastBtnBracketColor?: string | null,
        pollPledgeCastBtnTextColor?: string | null,
        pollPageBgColor?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      domain: string,
      owner?: string | null,
      status?: CompanyStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    postalsGRC?:  {
      __typename: "ModelPostalInfoConnection",
      items:  Array< {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    postalsDivision?:  {
      __typename: "ModelPostalInfoConnection",
      items:  Array< {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnDeletePollSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeletePollSubscription = {
  onDeletePoll?:  {
    __typename: "Poll",
    id: string,
    title: string,
    question: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    status?: PollStatus | null,
    options?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    drawOptions?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    hasPledge?: boolean | null,
    isGroup?: boolean | null,
    featured?: boolean | null,
    winOption?:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } | null,
    startTime: string,
    endTime: string,
    pledgePeriod1StartTime?: string | null,
    pledgePeriod1EndTime?: string | null,
    pledgePeriod2StartTime?: string | null,
    pledgePeriod2EndTime?: string | null,
    owner?: string | null,
    password?: string | null,
    grc?: string | null,
    division?: string | null,
    createdAt: string,
    private?: number | null,
    companyID?: string | null,
    themeID?: string | null,
    representativeID?: string | null,
    isPremium?: boolean | null,
    maxVote?: number | null,
    isNotExact?: boolean | null,
    category?: string | null,
    hashtag?: Array< string | null > | null,
    updatedAt: string,
    comments?:  {
      __typename: "ModelPollCommentConnection",
      items:  Array< {
        __typename: "PollComment",
        id: string,
        pollID: string,
        userID: string,
        content: string,
        avatar?: string | null,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    votes?:  {
      __typename: "ModelVoteConnection",
      items:  Array< {
        __typename: "Vote",
        id: string,
        userID: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        type: VoteType,
        subPollID?: string | null,
        reason?: string | null,
        pollID: string,
        proxyUserID?: string | null,
        createdAt: string,
        updatedAt: string,
        poll?:  {
          __typename: "Poll",
          id: string,
          title: string,
          question: string,
          description?: string | null,
          video?: string | null,
          status?: PollStatus | null,
          hasPledge?: boolean | null,
          isGroup?: boolean | null,
          featured?: boolean | null,
          startTime: string,
          endTime: string,
          pledgePeriod1StartTime?: string | null,
          pledgePeriod1EndTime?: string | null,
          pledgePeriod2StartTime?: string | null,
          pledgePeriod2EndTime?: string | null,
          owner?: string | null,
          password?: string | null,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          private?: number | null,
          companyID?: string | null,
          themeID?: string | null,
          representativeID?: string | null,
          isPremium?: boolean | null,
          maxVote?: number | null,
          isNotExact?: boolean | null,
          category?: string | null,
          hashtag?: Array< string | null > | null,
          updatedAt: string,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          email?: string | null,
          username?: string | null,
          owner?: string | null,
          phone?: string | null,
          type?: UserType | null,
          disable?: boolean | null,
          firstName?: string | null,
          lastName?: string | null,
          yearOfBirth?: number | null,
          gender?: string | null,
          education?: string | null,
          postalCode?: string | null,
          salaryRange?: UserSalaryRange | null,
          company?: string | null,
          createdAt: string,
          isSetup?: boolean | null,
          tier?: Tier | null,
          proxyUserID?: string | null,
          premiumPolls?: number | null,
          usedPremiumPolls?: number | null,
          cryptowallet?: string | null,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    voteResults?:  {
      __typename: "ModelVoteResultConnection",
      items:  Array< {
        __typename: "VoteResult",
        id: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        count: number,
        subPollID?: string | null,
        pollID: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    companyTheme?:  {
      __typename: "CompanyTheme",
      id: string,
      companyID: string,
      attributes?:  {
        __typename: "CustomThemeAttribute",
        pollActivePeriodBgColor?: string | null,
        pollActivePeriodShadowColor?: string | null,
        pollQuestionCardBgColor?: string | null,
        pollQuestionCardQuestionColor?: string | null,
        pollQuestionCardAnswerColor?: string | null,
        pollPledgeCastBtnBgColor?: string | null,
        pollPledgeCastBtnBracketColor?: string | null,
        pollPledgeCastBtnTextColor?: string | null,
        pollPageBgColor?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      domain: string,
      owner?: string | null,
      status?: CompanyStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    postalsGRC?:  {
      __typename: "ModelPostalInfoConnection",
      items:  Array< {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    postalsDivision?:  {
      __typename: "ModelPostalInfoConnection",
      items:  Array< {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateSubPollSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateSubPollSubscription = {
  onCreateSubPoll?:  {
    __typename: "SubPoll",
    id: string,
    pollID?: string | null,
    title?: string | null,
    question: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    status?: PollStatus | null,
    options?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    winOption?:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } | null,
    owner?: string | null,
    createdAt: string,
    orderID: number,
    private: number,
    maxVote?: number | null,
    isNotExact?: boolean | null,
    updatedAt: string,
    votes?:  {
      __typename: "ModelVoteConnection",
      items:  Array< {
        __typename: "Vote",
        id: string,
        userID: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        type: VoteType,
        subPollID?: string | null,
        reason?: string | null,
        pollID: string,
        proxyUserID?: string | null,
        createdAt: string,
        updatedAt: string,
        poll?:  {
          __typename: "Poll",
          id: string,
          title: string,
          question: string,
          description?: string | null,
          video?: string | null,
          status?: PollStatus | null,
          hasPledge?: boolean | null,
          isGroup?: boolean | null,
          featured?: boolean | null,
          startTime: string,
          endTime: string,
          pledgePeriod1StartTime?: string | null,
          pledgePeriod1EndTime?: string | null,
          pledgePeriod2StartTime?: string | null,
          pledgePeriod2EndTime?: string | null,
          owner?: string | null,
          password?: string | null,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          private?: number | null,
          companyID?: string | null,
          themeID?: string | null,
          representativeID?: string | null,
          isPremium?: boolean | null,
          maxVote?: number | null,
          isNotExact?: boolean | null,
          category?: string | null,
          hashtag?: Array< string | null > | null,
          updatedAt: string,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          email?: string | null,
          username?: string | null,
          owner?: string | null,
          phone?: string | null,
          type?: UserType | null,
          disable?: boolean | null,
          firstName?: string | null,
          lastName?: string | null,
          yearOfBirth?: number | null,
          gender?: string | null,
          education?: string | null,
          postalCode?: string | null,
          salaryRange?: UserSalaryRange | null,
          company?: string | null,
          createdAt: string,
          isSetup?: boolean | null,
          tier?: Tier | null,
          proxyUserID?: string | null,
          premiumPolls?: number | null,
          usedPremiumPolls?: number | null,
          cryptowallet?: string | null,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    voteResults?:  {
      __typename: "ModelVoteResultConnection",
      items:  Array< {
        __typename: "VoteResult",
        id: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        count: number,
        subPollID?: string | null,
        pollID: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnUpdateSubPollSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateSubPollSubscription = {
  onUpdateSubPoll?:  {
    __typename: "SubPoll",
    id: string,
    pollID?: string | null,
    title?: string | null,
    question: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    status?: PollStatus | null,
    options?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    winOption?:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } | null,
    owner?: string | null,
    createdAt: string,
    orderID: number,
    private: number,
    maxVote?: number | null,
    isNotExact?: boolean | null,
    updatedAt: string,
    votes?:  {
      __typename: "ModelVoteConnection",
      items:  Array< {
        __typename: "Vote",
        id: string,
        userID: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        type: VoteType,
        subPollID?: string | null,
        reason?: string | null,
        pollID: string,
        proxyUserID?: string | null,
        createdAt: string,
        updatedAt: string,
        poll?:  {
          __typename: "Poll",
          id: string,
          title: string,
          question: string,
          description?: string | null,
          video?: string | null,
          status?: PollStatus | null,
          hasPledge?: boolean | null,
          isGroup?: boolean | null,
          featured?: boolean | null,
          startTime: string,
          endTime: string,
          pledgePeriod1StartTime?: string | null,
          pledgePeriod1EndTime?: string | null,
          pledgePeriod2StartTime?: string | null,
          pledgePeriod2EndTime?: string | null,
          owner?: string | null,
          password?: string | null,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          private?: number | null,
          companyID?: string | null,
          themeID?: string | null,
          representativeID?: string | null,
          isPremium?: boolean | null,
          maxVote?: number | null,
          isNotExact?: boolean | null,
          category?: string | null,
          hashtag?: Array< string | null > | null,
          updatedAt: string,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          email?: string | null,
          username?: string | null,
          owner?: string | null,
          phone?: string | null,
          type?: UserType | null,
          disable?: boolean | null,
          firstName?: string | null,
          lastName?: string | null,
          yearOfBirth?: number | null,
          gender?: string | null,
          education?: string | null,
          postalCode?: string | null,
          salaryRange?: UserSalaryRange | null,
          company?: string | null,
          createdAt: string,
          isSetup?: boolean | null,
          tier?: Tier | null,
          proxyUserID?: string | null,
          premiumPolls?: number | null,
          usedPremiumPolls?: number | null,
          cryptowallet?: string | null,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    voteResults?:  {
      __typename: "ModelVoteResultConnection",
      items:  Array< {
        __typename: "VoteResult",
        id: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        count: number,
        subPollID?: string | null,
        pollID: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnDeleteSubPollSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteSubPollSubscription = {
  onDeleteSubPoll?:  {
    __typename: "SubPoll",
    id: string,
    pollID?: string | null,
    title?: string | null,
    question: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    status?: PollStatus | null,
    options?:  Array< {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } > | null,
    winOption?:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    } | null,
    owner?: string | null,
    createdAt: string,
    orderID: number,
    private: number,
    maxVote?: number | null,
    isNotExact?: boolean | null,
    updatedAt: string,
    votes?:  {
      __typename: "ModelVoteConnection",
      items:  Array< {
        __typename: "Vote",
        id: string,
        userID: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        type: VoteType,
        subPollID?: string | null,
        reason?: string | null,
        pollID: string,
        proxyUserID?: string | null,
        createdAt: string,
        updatedAt: string,
        poll?:  {
          __typename: "Poll",
          id: string,
          title: string,
          question: string,
          description?: string | null,
          video?: string | null,
          status?: PollStatus | null,
          hasPledge?: boolean | null,
          isGroup?: boolean | null,
          featured?: boolean | null,
          startTime: string,
          endTime: string,
          pledgePeriod1StartTime?: string | null,
          pledgePeriod1EndTime?: string | null,
          pledgePeriod2StartTime?: string | null,
          pledgePeriod2EndTime?: string | null,
          owner?: string | null,
          password?: string | null,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          private?: number | null,
          companyID?: string | null,
          themeID?: string | null,
          representativeID?: string | null,
          isPremium?: boolean | null,
          maxVote?: number | null,
          isNotExact?: boolean | null,
          category?: string | null,
          hashtag?: Array< string | null > | null,
          updatedAt: string,
        } | null,
        user?:  {
          __typename: "User",
          id: string,
          email?: string | null,
          username?: string | null,
          owner?: string | null,
          phone?: string | null,
          type?: UserType | null,
          disable?: boolean | null,
          firstName?: string | null,
          lastName?: string | null,
          yearOfBirth?: number | null,
          gender?: string | null,
          education?: string | null,
          postalCode?: string | null,
          salaryRange?: UserSalaryRange | null,
          company?: string | null,
          createdAt: string,
          isSetup?: boolean | null,
          tier?: Tier | null,
          proxyUserID?: string | null,
          premiumPolls?: number | null,
          usedPremiumPolls?: number | null,
          cryptowallet?: string | null,
          updatedAt: string,
        } | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    voteResults?:  {
      __typename: "ModelVoteResultConnection",
      items:  Array< {
        __typename: "VoteResult",
        id: string,
        option:  {
          __typename: "PollOption",
          id: string,
          title?: string | null,
          description?: string | null,
        },
        count: number,
        subPollID?: string | null,
        pollID: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateVoteSubscription = {
  onCreateVote?:  {
    __typename: "Vote",
    id: string,
    userID: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    type: VoteType,
    subPollID?: string | null,
    reason?: string | null,
    pollID: string,
    proxyUserID?: string | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateVoteSubscription = {
  onUpdateVote?:  {
    __typename: "Vote",
    id: string,
    userID: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    type: VoteType,
    subPollID?: string | null,
    reason?: string | null,
    pollID: string,
    proxyUserID?: string | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteVoteSubscription = {
  onDeleteVote?:  {
    __typename: "Vote",
    id: string,
    userID: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    type: VoteType,
    subPollID?: string | null,
    reason?: string | null,
    pollID: string,
    proxyUserID?: string | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnCreateHotPollSubscription = {
  onCreateHotPoll?:  {
    __typename: "HotPoll",
    id: string,
    pollID: string,
    count: number,
    status: HotPollStatus,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateHotPollSubscription = {
  onUpdateHotPoll?:  {
    __typename: "HotPoll",
    id: string,
    pollID: string,
    count: number,
    status: HotPollStatus,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteHotPollSubscription = {
  onDeleteHotPoll?:  {
    __typename: "HotPoll",
    id: string,
    pollID: string,
    count: number,
    status: HotPollStatus,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateHotPledgeSubscription = {
  onCreateHotPledge?:  {
    __typename: "HotPledge",
    id: string,
    pollID: string,
    count: number,
    status: HotPollStatus,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateHotPledgeSubscription = {
  onUpdateHotPledge?:  {
    __typename: "HotPledge",
    id: string,
    pollID: string,
    count: number,
    status: HotPollStatus,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteHotPledgeSubscription = {
  onDeleteHotPledge?:  {
    __typename: "HotPledge",
    id: string,
    pollID: string,
    count: number,
    status: HotPollStatus,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreateVoteResultSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateVoteResultSubscription = {
  onCreateVoteResult?:  {
    __typename: "VoteResult",
    id: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    count: number,
    subPollID?: string | null,
    pollID: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateVoteResultSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateVoteResultSubscription = {
  onUpdateVoteResult?:  {
    __typename: "VoteResult",
    id: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    count: number,
    subPollID?: string | null,
    pollID: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteVoteResultSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteVoteResultSubscription = {
  onDeleteVoteResult?:  {
    __typename: "VoteResult",
    id: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    count: number,
    subPollID?: string | null,
    pollID: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreatePledgeSubscription = {
  onCreatePledge?:  {
    __typename: "Pledge",
    id: string,
    userID: string,
    type: PledgeType,
    pollID: string,
    reason?: string | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnUpdatePledgeSubscription = {
  onUpdatePledge?:  {
    __typename: "Pledge",
    id: string,
    userID: string,
    type: PledgeType,
    pollID: string,
    reason?: string | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnDeletePledgeSubscription = {
  onDeletePledge?:  {
    __typename: "Pledge",
    id: string,
    userID: string,
    type: PledgeType,
    pollID: string,
    reason?: string | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnCreatePledgeResultSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreatePledgeResultSubscription = {
  onCreatePledgeResult?:  {
    __typename: "PledgeResult",
    id: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    count: number,
    pollID: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdatePledgeResultSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdatePledgeResultSubscription = {
  onUpdatePledgeResult?:  {
    __typename: "PledgeResult",
    id: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    count: number,
    pollID: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeletePledgeResultSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeletePledgeResultSubscription = {
  onDeletePledgeResult?:  {
    __typename: "PledgeResult",
    id: string,
    option:  {
      __typename: "PollOption",
      id: string,
      title?: string | null,
      description?: string | null,
      detail?:  {
        __typename: "Detail",
        image?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        video?: string | null,
        price?: string | null,
        currency?: Currency | null,
      } | null,
    },
    count: number,
    pollID: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreatePollReportSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreatePollReportSubscription = {
  onCreatePollReport?:  {
    __typename: "PollReport",
    id: string,
    title: string,
    description: string,
    pollID: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePollReportSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdatePollReportSubscription = {
  onUpdatePollReport?:  {
    __typename: "PollReport",
    id: string,
    title: string,
    description: string,
    pollID: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePollReportSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeletePollReportSubscription = {
  onDeletePollReport?:  {
    __typename: "PollReport",
    id: string,
    title: string,
    description: string,
    pollID: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePackageSubscriptionSubscription = {
  onCreatePackageSubscription?:  {
    __typename: "PackageSubscription",
    id: string,
    tier: Tier,
    price?: string | null,
    stripePriceID?: string | null,
    pollOptionLimit?: number | null,
    groupPollAllowed?: boolean | null,
    groupPollLimit?: number | null,
    pledgeAllowed?: boolean | null,
    pledgeChargePercentage?: string | null,
    pollDurationLimit?: string | null,
    pollResultLiveAllowed?: boolean | null,
    statisticReportAllowed?: boolean | null,
    withdrawalAllowed?: boolean | null,
    extensionPledgeAllowed?: boolean | null,
    noOfPolls?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePackageSubscriptionSubscription = {
  onUpdatePackageSubscription?:  {
    __typename: "PackageSubscription",
    id: string,
    tier: Tier,
    price?: string | null,
    stripePriceID?: string | null,
    pollOptionLimit?: number | null,
    groupPollAllowed?: boolean | null,
    groupPollLimit?: number | null,
    pledgeAllowed?: boolean | null,
    pledgeChargePercentage?: string | null,
    pollDurationLimit?: string | null,
    pollResultLiveAllowed?: boolean | null,
    statisticReportAllowed?: boolean | null,
    withdrawalAllowed?: boolean | null,
    extensionPledgeAllowed?: boolean | null,
    noOfPolls?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePackageSubscriptionSubscription = {
  onDeletePackageSubscription?:  {
    __typename: "PackageSubscription",
    id: string,
    tier: Tier,
    price?: string | null,
    stripePriceID?: string | null,
    pollOptionLimit?: number | null,
    groupPollAllowed?: boolean | null,
    groupPollLimit?: number | null,
    pledgeAllowed?: boolean | null,
    pledgeChargePercentage?: string | null,
    pollDurationLimit?: string | null,
    pollResultLiveAllowed?: boolean | null,
    statisticReportAllowed?: boolean | null,
    withdrawalAllowed?: boolean | null,
    extensionPledgeAllowed?: boolean | null,
    noOfPolls?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateUserSubscription = {
  onCreateUser?:  {
    __typename: "User",
    id: string,
    email?: string | null,
    username?: string | null,
    owner?: string | null,
    phone?: string | null,
    type?: UserType | null,
    disable?: boolean | null,
    firstName?: string | null,
    lastName?: string | null,
    yearOfBirth?: number | null,
    gender?: string | null,
    education?: string | null,
    postalCode?: string | null,
    salaryRange?: UserSalaryRange | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    company?: string | null,
    createdAt: string,
    organisation?:  {
      __typename: "OrganisationInfo",
      name?: string | null,
      department?: string | null,
      jobTitle?: string | null,
    } | null,
    isSetup?: boolean | null,
    tier?: Tier | null,
    proxyUserID?: string | null,
    premiumPolls?: number | null,
    usedPremiumPolls?: number | null,
    cryptowallet?: string | null,
    updatedAt: string,
    postalInfo?:  {
      __typename: "PostalInfo",
      postal: string,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnUpdateUserSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateUserSubscription = {
  onUpdateUser?:  {
    __typename: "User",
    id: string,
    email?: string | null,
    username?: string | null,
    owner?: string | null,
    phone?: string | null,
    type?: UserType | null,
    disable?: boolean | null,
    firstName?: string | null,
    lastName?: string | null,
    yearOfBirth?: number | null,
    gender?: string | null,
    education?: string | null,
    postalCode?: string | null,
    salaryRange?: UserSalaryRange | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    company?: string | null,
    createdAt: string,
    organisation?:  {
      __typename: "OrganisationInfo",
      name?: string | null,
      department?: string | null,
      jobTitle?: string | null,
    } | null,
    isSetup?: boolean | null,
    tier?: Tier | null,
    proxyUserID?: string | null,
    premiumPolls?: number | null,
    usedPremiumPolls?: number | null,
    cryptowallet?: string | null,
    updatedAt: string,
    postalInfo?:  {
      __typename: "PostalInfo",
      postal: string,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnDeleteUserSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteUserSubscription = {
  onDeleteUser?:  {
    __typename: "User",
    id: string,
    email?: string | null,
    username?: string | null,
    owner?: string | null,
    phone?: string | null,
    type?: UserType | null,
    disable?: boolean | null,
    firstName?: string | null,
    lastName?: string | null,
    yearOfBirth?: number | null,
    gender?: string | null,
    education?: string | null,
    postalCode?: string | null,
    salaryRange?: UserSalaryRange | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    company?: string | null,
    createdAt: string,
    organisation?:  {
      __typename: "OrganisationInfo",
      name?: string | null,
      department?: string | null,
      jobTitle?: string | null,
    } | null,
    isSetup?: boolean | null,
    tier?: Tier | null,
    proxyUserID?: string | null,
    premiumPolls?: number | null,
    usedPremiumPolls?: number | null,
    cryptowallet?: string | null,
    updatedAt: string,
    postalInfo?:  {
      __typename: "PostalInfo",
      postal: string,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null,
};

export type OnCreateCompanyUserSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateCompanyUserSubscription = {
  onCreateCompanyUser?:  {
    __typename: "CompanyUser",
    id: string,
    userID: string,
    username: string,
    companyID: string,
    adminID: string,
    role: CompanyRole,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateCompanyUserSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateCompanyUserSubscription = {
  onUpdateCompanyUser?:  {
    __typename: "CompanyUser",
    id: string,
    userID: string,
    username: string,
    companyID: string,
    adminID: string,
    role: CompanyRole,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteCompanyUserSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteCompanyUserSubscription = {
  onDeleteCompanyUser?:  {
    __typename: "CompanyUser",
    id: string,
    userID: string,
    username: string,
    companyID: string,
    adminID: string,
    role: CompanyRole,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnCreateCompanyThemeSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateCompanyThemeSubscription = {
  onCreateCompanyTheme?:  {
    __typename: "CompanyTheme",
    id: string,
    companyID: string,
    attributes?:  {
      __typename: "CustomThemeAttribute",
      pollActivePeriodBgColor?: string | null,
      pollActivePeriodShadowColor?: string | null,
      pollQuestionCardBgColor?: string | null,
      pollQuestionCardQuestionColor?: string | null,
      pollQuestionCardAnswerColor?: string | null,
      pollPledgeCastBtnBgColor?: string | null,
      pollPledgeCastBtnBracketColor?: string | null,
      pollPledgeCastBtnTextColor?: string | null,
      pollPageBgColor?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateCompanyThemeSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateCompanyThemeSubscription = {
  onUpdateCompanyTheme?:  {
    __typename: "CompanyTheme",
    id: string,
    companyID: string,
    attributes?:  {
      __typename: "CustomThemeAttribute",
      pollActivePeriodBgColor?: string | null,
      pollActivePeriodShadowColor?: string | null,
      pollQuestionCardBgColor?: string | null,
      pollQuestionCardQuestionColor?: string | null,
      pollQuestionCardAnswerColor?: string | null,
      pollPledgeCastBtnBgColor?: string | null,
      pollPledgeCastBtnBracketColor?: string | null,
      pollPledgeCastBtnTextColor?: string | null,
      pollPageBgColor?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteCompanyThemeSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteCompanyThemeSubscription = {
  onDeleteCompanyTheme?:  {
    __typename: "CompanyTheme",
    id: string,
    companyID: string,
    attributes?:  {
      __typename: "CustomThemeAttribute",
      pollActivePeriodBgColor?: string | null,
      pollActivePeriodShadowColor?: string | null,
      pollQuestionCardBgColor?: string | null,
      pollQuestionCardQuestionColor?: string | null,
      pollQuestionCardAnswerColor?: string | null,
      pollPledgeCastBtnBgColor?: string | null,
      pollPledgeCastBtnBracketColor?: string | null,
      pollPledgeCastBtnTextColor?: string | null,
      pollPageBgColor?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateCompanySubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateCompanySubscription = {
  onCreateCompany?:  {
    __typename: "Company",
    id: string,
    name: string,
    domain: string,
    owner?: string | null,
    status?: CompanyStatus | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCompanySubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateCompanySubscription = {
  onUpdateCompany?:  {
    __typename: "Company",
    id: string,
    name: string,
    domain: string,
    owner?: string | null,
    status?: CompanyStatus | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCompanySubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteCompanySubscription = {
  onDeleteCompany?:  {
    __typename: "Company",
    id: string,
    name: string,
    domain: string,
    owner?: string | null,
    status?: CompanyStatus | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCompanyDomainSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateCompanyDomainSubscription = {
  onCreateCompanyDomain?:  {
    __typename: "CompanyDomain",
    id: string,
    companyID: string,
    domain: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateCompanyDomainSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateCompanyDomainSubscription = {
  onUpdateCompanyDomain?:  {
    __typename: "CompanyDomain",
    id: string,
    companyID: string,
    domain: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteCompanyDomainSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteCompanyDomainSubscription = {
  onDeleteCompanyDomain?:  {
    __typename: "CompanyDomain",
    id: string,
    companyID: string,
    domain: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateRequestJoinCompanySubscription = {
  onCreateRequestJoinCompany?:  {
    __typename: "RequestJoinCompany",
    id: string,
    userID: string,
    companyID: string,
    status: RequestJoinCompanyStatus,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateRequestJoinCompanySubscription = {
  onUpdateRequestJoinCompany?:  {
    __typename: "RequestJoinCompany",
    id: string,
    userID: string,
    companyID: string,
    status: RequestJoinCompanyStatus,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteRequestJoinCompanySubscription = {
  onDeleteRequestJoinCompany?:  {
    __typename: "RequestJoinCompany",
    id: string,
    userID: string,
    companyID: string,
    status: RequestJoinCompanyStatus,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnCreateAlertSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateAlertSubscription = {
  onCreateAlert?:  {
    __typename: "Alert",
    id: string,
    title?: string | null,
    detail?: string | null,
    pollID?: string | null,
    message?: string | null,
    type: AlertType,
    createdAt: string,
    userID: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type OnUpdateAlertSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateAlertSubscription = {
  onUpdateAlert?:  {
    __typename: "Alert",
    id: string,
    title?: string | null,
    detail?: string | null,
    pollID?: string | null,
    message?: string | null,
    type: AlertType,
    createdAt: string,
    userID: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type OnDeleteAlertSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteAlertSubscription = {
  onDeleteAlert?:  {
    __typename: "Alert",
    id: string,
    title?: string | null,
    detail?: string | null,
    pollID?: string | null,
    message?: string | null,
    type: AlertType,
    createdAt: string,
    userID: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type OnCreateStripeAccountSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateStripeAccountSubscription = {
  onCreateStripeAccount?:  {
    __typename: "StripeAccount",
    id: string,
    userID: string,
    isOnboard: boolean,
    createdAt: string,
    amount?: string | null,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateStripeAccountSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateStripeAccountSubscription = {
  onUpdateStripeAccount?:  {
    __typename: "StripeAccount",
    id: string,
    userID: string,
    isOnboard: boolean,
    createdAt: string,
    amount?: string | null,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteStripeAccountSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteStripeAccountSubscription = {
  onDeleteStripeAccount?:  {
    __typename: "StripeAccount",
    id: string,
    userID: string,
    isOnboard: boolean,
    createdAt: string,
    amount?: string | null,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateStripeCustomerSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateStripeCustomerSubscription = {
  onCreateStripeCustomer?:  {
    __typename: "StripeCustomer",
    id: string,
    userID: string,
    createdAt: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnUpdateStripeCustomerSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateStripeCustomerSubscription = {
  onUpdateStripeCustomer?:  {
    __typename: "StripeCustomer",
    id: string,
    userID: string,
    createdAt: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnDeleteStripeCustomerSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteStripeCustomerSubscription = {
  onDeleteStripeCustomer?:  {
    __typename: "StripeCustomer",
    id: string,
    userID: string,
    createdAt: string,
    owner?: string | null,
    updatedAt: string,
  } | null,
};

export type OnCreateStripeChargeSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateStripeChargeSubscription = {
  onCreateStripeCharge?:  {
    __typename: "StripeCharge",
    id: string,
    userID: string,
    pollID: string,
    chargeID: string,
    status: StripeChargeStatus,
    amount: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateStripeChargeSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateStripeChargeSubscription = {
  onUpdateStripeCharge?:  {
    __typename: "StripeCharge",
    id: string,
    userID: string,
    pollID: string,
    chargeID: string,
    status: StripeChargeStatus,
    amount: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteStripeChargeSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteStripeChargeSubscription = {
  onDeleteStripeCharge?:  {
    __typename: "StripeCharge",
    id: string,
    userID: string,
    pollID: string,
    chargeID: string,
    status: StripeChargeStatus,
    amount: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateStripeSubscriptionSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateStripeSubscriptionSubscription = {
  onCreateStripeSubscription?:  {
    __typename: "StripeSubscription",
    id: string,
    subscriptionID: string,
    customerID: string,
    userID: string,
    tier: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateStripeSubscriptionSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateStripeSubscriptionSubscription = {
  onUpdateStripeSubscription?:  {
    __typename: "StripeSubscription",
    id: string,
    subscriptionID: string,
    customerID: string,
    userID: string,
    tier: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteStripeSubscriptionSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteStripeSubscriptionSubscription = {
  onDeleteStripeSubscription?:  {
    __typename: "StripeSubscription",
    id: string,
    subscriptionID: string,
    customerID: string,
    userID: string,
    tier: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateProxyPollSubscription = {
  onCreateProxyPoll?:  {
    __typename: "ProxyPoll",
    id: string,
    proxyUserID: string,
    pollID: string,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateProxyPollSubscription = {
  onUpdateProxyPoll?:  {
    __typename: "ProxyPoll",
    id: string,
    proxyUserID: string,
    pollID: string,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteProxyPollSubscription = {
  onDeleteProxyPoll?:  {
    __typename: "ProxyPoll",
    id: string,
    proxyUserID: string,
    pollID: string,
    enabled?: boolean | null,
    createdAt: string,
    updatedAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnCreateDefaultConfigurationSubscription = {
  onCreateDefaultConfiguration?:  {
    __typename: "DefaultConfiguration",
    id: string,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    pollImage?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateDefaultConfigurationSubscription = {
  onUpdateDefaultConfiguration?:  {
    __typename: "DefaultConfiguration",
    id: string,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    pollImage?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteDefaultConfigurationSubscription = {
  onDeleteDefaultConfiguration?:  {
    __typename: "DefaultConfiguration",
    id: string,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    pollImage?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateCustomConfigurationSubscription = {
  onCreateCustomConfiguration?:  {
    __typename: "CustomConfiguration",
    id: string,
    companyID: string,
    field?: string | null,
    value?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateCustomConfigurationSubscription = {
  onUpdateCustomConfiguration?:  {
    __typename: "CustomConfiguration",
    id: string,
    companyID: string,
    field?: string | null,
    value?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteCustomConfigurationSubscription = {
  onDeleteCustomConfiguration?:  {
    __typename: "CustomConfiguration",
    id: string,
    companyID: string,
    field?: string | null,
    value?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePollCountSubscription = {
  onCreatePollCount?:  {
    __typename: "PollCount",
    id: string,
    count?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePollCountSubscription = {
  onUpdatePollCount?:  {
    __typename: "PollCount",
    id: string,
    count?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePollCountSubscription = {
  onDeletePollCount?:  {
    __typename: "PollCount",
    id: string,
    count?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePopUpSubscription = {
  onCreatePopUp?:  {
    __typename: "PopUp",
    id: string,
    status: PopUpStatus,
    type: PopUpType,
    pollID: string,
    updatedAt: string,
    createdAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnUpdatePopUpSubscription = {
  onUpdatePopUp?:  {
    __typename: "PopUp",
    id: string,
    status: PopUpStatus,
    type: PopUpType,
    pollID: string,
    updatedAt: string,
    createdAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnDeletePopUpSubscription = {
  onDeletePopUp?:  {
    __typename: "PopUp",
    id: string,
    status: PopUpStatus,
    type: PopUpType,
    pollID: string,
    updatedAt: string,
    createdAt: string,
    poll?:  {
      __typename: "Poll",
      id: string,
      title: string,
      question: string,
      description?: string | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      theme?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      background?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      logo?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      video?: string | null,
      status?: PollStatus | null,
      options?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      drawOptions?:  Array< {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } > | null,
      hasPledge?: boolean | null,
      isGroup?: boolean | null,
      featured?: boolean | null,
      winOption?:  {
        __typename: "PollOption",
        id: string,
        title?: string | null,
        description?: string | null,
        detail?:  {
          __typename: "Detail",
          video?: string | null,
          price?: string | null,
          currency?: Currency | null,
        } | null,
      } | null,
      startTime: string,
      endTime: string,
      pledgePeriod1StartTime?: string | null,
      pledgePeriod1EndTime?: string | null,
      pledgePeriod2StartTime?: string | null,
      pledgePeriod2EndTime?: string | null,
      owner?: string | null,
      password?: string | null,
      grc?: string | null,
      division?: string | null,
      createdAt: string,
      private?: number | null,
      companyID?: string | null,
      themeID?: string | null,
      representativeID?: string | null,
      isPremium?: boolean | null,
      maxVote?: number | null,
      isNotExact?: boolean | null,
      category?: string | null,
      hashtag?: Array< string | null > | null,
      updatedAt: string,
      comments?:  {
        __typename: "ModelPollCommentConnection",
        items:  Array< {
          __typename: "PollComment",
          id: string,
          pollID: string,
          userID: string,
          content: string,
          avatar?: string | null,
          name?: string | null,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      votes?:  {
        __typename: "ModelVoteConnection",
        items:  Array< {
          __typename: "Vote",
          id: string,
          userID: string,
          type: VoteType,
          subPollID?: string | null,
          reason?: string | null,
          pollID: string,
          proxyUserID?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      voteResults?:  {
        __typename: "ModelVoteResultConnection",
        items:  Array< {
          __typename: "VoteResult",
          id: string,
          count: number,
          subPollID?: string | null,
          pollID: string,
          createdAt: string,
          updatedAt: string,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      companyTheme?:  {
        __typename: "CompanyTheme",
        id: string,
        companyID: string,
        attributes?:  {
          __typename: "CustomThemeAttribute",
          pollActivePeriodBgColor?: string | null,
          pollActivePeriodShadowColor?: string | null,
          pollQuestionCardBgColor?: string | null,
          pollQuestionCardQuestionColor?: string | null,
          pollQuestionCardAnswerColor?: string | null,
          pollPledgeCastBtnBgColor?: string | null,
          pollPledgeCastBtnBracketColor?: string | null,
          pollPledgeCastBtnTextColor?: string | null,
          pollPageBgColor?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null,
      company?:  {
        __typename: "Company",
        id: string,
        name: string,
        domain: string,
        owner?: string | null,
        status?: CompanyStatus | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      postalsGRC?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      postalsDivision?:  {
        __typename: "ModelPostalInfoConnection",
        items:  Array< {
          __typename: "PostalInfo",
          postal: string,
          grc?: string | null,
          division?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
    } | null,
  } | null,
};

export type OnCreatePostalInfoSubscription = {
  onCreatePostalInfo?:  {
    __typename: "PostalInfo",
    postal: string,
    grc?: string | null,
    division?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdatePostalInfoSubscription = {
  onUpdatePostalInfo?:  {
    __typename: "PostalInfo",
    postal: string,
    grc?: string | null,
    division?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeletePostalInfoSubscription = {
  onDeletePostalInfo?:  {
    __typename: "PostalInfo",
    postal: string,
    grc?: string | null,
    division?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreatePremiumPollPurchaseSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreatePremiumPollPurchaseSubscription = {
  onCreatePremiumPollPurchase?:  {
    __typename: "PremiumPollPurchase",
    id: string,
    userID: string,
    createdAt: string,
    amount?: string | null,
    chargeID?: string | null,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type OnUpdatePremiumPollPurchaseSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdatePremiumPollPurchaseSubscription = {
  onUpdatePremiumPollPurchase?:  {
    __typename: "PremiumPollPurchase",
    id: string,
    userID: string,
    createdAt: string,
    amount?: string | null,
    chargeID?: string | null,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type OnDeletePremiumPollPurchaseSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeletePremiumPollPurchaseSubscription = {
  onDeletePremiumPollPurchase?:  {
    __typename: "PremiumPollPurchase",
    id: string,
    userID: string,
    createdAt: string,
    amount?: string | null,
    chargeID?: string | null,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
    owner?: string | null,
  } | null,
};

export type OnCreateIdeaCategorySubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateIdeaCategorySubscription = {
  onCreateIdeaCategory?:  {
    __typename: "IdeaCategory",
    id: string,
    title?: string | null,
    edu?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateIdeaCategorySubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateIdeaCategorySubscription = {
  onUpdateIdeaCategory?:  {
    __typename: "IdeaCategory",
    id: string,
    title?: string | null,
    edu?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteIdeaCategorySubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteIdeaCategorySubscription = {
  onDeleteIdeaCategory?:  {
    __typename: "IdeaCategory",
    id: string,
    title?: string | null,
    edu?: boolean | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateIdeaHashtagSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateIdeaHashtagSubscription = {
  onCreateIdeaHashtag?:  {
    __typename: "IdeaHashtag",
    id: string,
    title?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateIdeaHashtagSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateIdeaHashtagSubscription = {
  onUpdateIdeaHashtag?:  {
    __typename: "IdeaHashtag",
    id: string,
    title?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteIdeaHashtagSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteIdeaHashtagSubscription = {
  onDeleteIdeaHashtag?:  {
    __typename: "IdeaHashtag",
    id: string,
    title?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateIdeaSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateIdeaSubscription = {
  onCreateIdea?:  {
    __typename: "Idea",
    id: string,
    title: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    featured?: boolean | null,
    startTime: string,
    endTime: string,
    owner?: string | null,
    createdAt: string,
    companyID?: string | null,
    themeID?: string | null,
    category?: string | null,
    hashtag?: Array< string | null > | null,
    updatedAt: string,
    companyTheme?:  {
      __typename: "CompanyTheme",
      id: string,
      companyID: string,
      attributes?:  {
        __typename: "CustomThemeAttribute",
        pollActivePeriodBgColor?: string | null,
        pollActivePeriodShadowColor?: string | null,
        pollQuestionCardBgColor?: string | null,
        pollQuestionCardQuestionColor?: string | null,
        pollQuestionCardAnswerColor?: string | null,
        pollPledgeCastBtnBgColor?: string | null,
        pollPledgeCastBtnBracketColor?: string | null,
        pollPledgeCastBtnTextColor?: string | null,
        pollPageBgColor?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      domain: string,
      owner?: string | null,
      status?: CompanyStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    pledges?:  {
      __typename: "ModelIdeaPledgeConnection",
      items:  Array< {
        __typename: "IdeaPledge",
        id: string,
        ideaID: string,
        title?: string | null,
        description?: string | null,
        video?: string | null,
        price: string,
        currency: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelIdeaCommentConnection",
      items:  Array< {
        __typename: "IdeaComment",
        id: string,
        ideaID: string,
        userID: string,
        content: string,
        avatar?: string | null,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    scores?:  {
      __typename: "ModelIdeaScoreConnection",
      items:  Array< {
        __typename: "IdeaScore",
        id: string,
        ideaID: string,
        userID: string,
        level_of_success: number,
        investment_required: number,
        talent_required: number,
        consultation_required: number,
        connection_required: number,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnUpdateIdeaSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateIdeaSubscription = {
  onUpdateIdea?:  {
    __typename: "Idea",
    id: string,
    title: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    featured?: boolean | null,
    startTime: string,
    endTime: string,
    owner?: string | null,
    createdAt: string,
    companyID?: string | null,
    themeID?: string | null,
    category?: string | null,
    hashtag?: Array< string | null > | null,
    updatedAt: string,
    companyTheme?:  {
      __typename: "CompanyTheme",
      id: string,
      companyID: string,
      attributes?:  {
        __typename: "CustomThemeAttribute",
        pollActivePeriodBgColor?: string | null,
        pollActivePeriodShadowColor?: string | null,
        pollQuestionCardBgColor?: string | null,
        pollQuestionCardQuestionColor?: string | null,
        pollQuestionCardAnswerColor?: string | null,
        pollPledgeCastBtnBgColor?: string | null,
        pollPledgeCastBtnBracketColor?: string | null,
        pollPledgeCastBtnTextColor?: string | null,
        pollPageBgColor?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      domain: string,
      owner?: string | null,
      status?: CompanyStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    pledges?:  {
      __typename: "ModelIdeaPledgeConnection",
      items:  Array< {
        __typename: "IdeaPledge",
        id: string,
        ideaID: string,
        title?: string | null,
        description?: string | null,
        video?: string | null,
        price: string,
        currency: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelIdeaCommentConnection",
      items:  Array< {
        __typename: "IdeaComment",
        id: string,
        ideaID: string,
        userID: string,
        content: string,
        avatar?: string | null,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    scores?:  {
      __typename: "ModelIdeaScoreConnection",
      items:  Array< {
        __typename: "IdeaScore",
        id: string,
        ideaID: string,
        userID: string,
        level_of_success: number,
        investment_required: number,
        talent_required: number,
        consultation_required: number,
        connection_required: number,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnDeleteIdeaSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteIdeaSubscription = {
  onDeleteIdea?:  {
    __typename: "Idea",
    id: string,
    title: string,
    description?: string | null,
    image?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    theme?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    background?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    video?: string | null,
    featured?: boolean | null,
    startTime: string,
    endTime: string,
    owner?: string | null,
    createdAt: string,
    companyID?: string | null,
    themeID?: string | null,
    category?: string | null,
    hashtag?: Array< string | null > | null,
    updatedAt: string,
    companyTheme?:  {
      __typename: "CompanyTheme",
      id: string,
      companyID: string,
      attributes?:  {
        __typename: "CustomThemeAttribute",
        pollActivePeriodBgColor?: string | null,
        pollActivePeriodShadowColor?: string | null,
        pollQuestionCardBgColor?: string | null,
        pollQuestionCardQuestionColor?: string | null,
        pollQuestionCardAnswerColor?: string | null,
        pollPledgeCastBtnBgColor?: string | null,
        pollPledgeCastBtnBracketColor?: string | null,
        pollPledgeCastBtnTextColor?: string | null,
        pollPageBgColor?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      owner?: string | null,
    } | null,
    company?:  {
      __typename: "Company",
      id: string,
      name: string,
      domain: string,
      owner?: string | null,
      status?: CompanyStatus | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    pledges?:  {
      __typename: "ModelIdeaPledgeConnection",
      items:  Array< {
        __typename: "IdeaPledge",
        id: string,
        ideaID: string,
        title?: string | null,
        description?: string | null,
        video?: string | null,
        price: string,
        currency: string,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    comments?:  {
      __typename: "ModelIdeaCommentConnection",
      items:  Array< {
        __typename: "IdeaComment",
        id: string,
        ideaID: string,
        userID: string,
        content: string,
        avatar?: string | null,
        name?: string | null,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    scores?:  {
      __typename: "ModelIdeaScoreConnection",
      items:  Array< {
        __typename: "IdeaScore",
        id: string,
        ideaID: string,
        userID: string,
        level_of_success: number,
        investment_required: number,
        talent_required: number,
        consultation_required: number,
        connection_required: number,
        createdAt: string,
        updatedAt: string,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
  } | null,
};

export type OnCreateIdeaPledgeSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateIdeaPledgeSubscription = {
  onCreateIdeaPledge?:  {
    __typename: "IdeaPledge",
    id: string,
    ideaID: string,
    title?: string | null,
    description?: string | null,
    video?: string | null,
    price: string,
    currency: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateIdeaPledgeSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateIdeaPledgeSubscription = {
  onUpdateIdeaPledge?:  {
    __typename: "IdeaPledge",
    id: string,
    ideaID: string,
    title?: string | null,
    description?: string | null,
    video?: string | null,
    price: string,
    currency: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteIdeaPledgeSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteIdeaPledgeSubscription = {
  onDeleteIdeaPledge?:  {
    __typename: "IdeaPledge",
    id: string,
    ideaID: string,
    title?: string | null,
    description?: string | null,
    video?: string | null,
    price: string,
    currency: string,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateIdeaCommentSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateIdeaCommentSubscription = {
  onCreateIdeaComment?:  {
    __typename: "IdeaComment",
    id: string,
    ideaID: string,
    userID: string,
    content: string,
    avatar?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateIdeaCommentSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateIdeaCommentSubscription = {
  onUpdateIdeaComment?:  {
    __typename: "IdeaComment",
    id: string,
    ideaID: string,
    userID: string,
    content: string,
    avatar?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteIdeaCommentSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteIdeaCommentSubscription = {
  onDeleteIdeaComment?:  {
    __typename: "IdeaComment",
    id: string,
    ideaID: string,
    userID: string,
    content: string,
    avatar?: string | null,
    name?: string | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateIdeaPledgeStripeChargeSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateIdeaPledgeStripeChargeSubscription = {
  onCreateIdeaPledgeStripeCharge?:  {
    __typename: "IdeaPledgeStripeCharge",
    id: string,
    userID: string,
    ideaID: string,
    ideaPledgeID: string,
    chargeID: string,
    status: StripeChargeStatus,
    amount: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateIdeaPledgeStripeChargeSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateIdeaPledgeStripeChargeSubscription = {
  onUpdateIdeaPledgeStripeCharge?:  {
    __typename: "IdeaPledgeStripeCharge",
    id: string,
    userID: string,
    ideaID: string,
    ideaPledgeID: string,
    chargeID: string,
    status: StripeChargeStatus,
    amount: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnDeleteIdeaPledgeStripeChargeSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteIdeaPledgeStripeChargeSubscription = {
  onDeleteIdeaPledgeStripeCharge?:  {
    __typename: "IdeaPledgeStripeCharge",
    id: string,
    userID: string,
    ideaID: string,
    ideaPledgeID: string,
    chargeID: string,
    status: StripeChargeStatus,
    amount: string,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    user?:  {
      __typename: "User",
      id: string,
      email?: string | null,
      username?: string | null,
      owner?: string | null,
      phone?: string | null,
      type?: UserType | null,
      disable?: boolean | null,
      firstName?: string | null,
      lastName?: string | null,
      yearOfBirth?: number | null,
      gender?: string | null,
      education?: string | null,
      postalCode?: string | null,
      salaryRange?: UserSalaryRange | null,
      image?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      company?: string | null,
      createdAt: string,
      organisation?:  {
        __typename: "OrganisationInfo",
        name?: string | null,
        department?: string | null,
        jobTitle?: string | null,
      } | null,
      isSetup?: boolean | null,
      tier?: Tier | null,
      proxyUserID?: string | null,
      premiumPolls?: number | null,
      usedPremiumPolls?: number | null,
      cryptowallet?: string | null,
      updatedAt: string,
      postalInfo?:  {
        __typename: "PostalInfo",
        postal: string,
        grc?: string | null,
        division?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnCreateIdeaScoreSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateIdeaScoreSubscription = {
  onCreateIdeaScore?:  {
    __typename: "IdeaScore",
    id: string,
    ideaID: string,
    userID: string,
    level_of_success: number,
    investment_required: number,
    talent_required: number,
    consultation_required: number,
    connection_required: number,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateIdeaScoreSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateIdeaScoreSubscription = {
  onUpdateIdeaScore?:  {
    __typename: "IdeaScore",
    id: string,
    ideaID: string,
    userID: string,
    level_of_success: number,
    investment_required: number,
    talent_required: number,
    consultation_required: number,
    connection_required: number,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteIdeaScoreSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteIdeaScoreSubscription = {
  onDeleteIdeaScore?:  {
    __typename: "IdeaScore",
    id: string,
    ideaID: string,
    userID: string,
    level_of_success: number,
    investment_required: number,
    talent_required: number,
    consultation_required: number,
    connection_required: number,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnCreateIdeaSupporterSubscriptionVariables = {
  owner?: string | null,
};

export type OnCreateIdeaSupporterSubscription = {
  onCreateIdeaSupporter?:  {
    __typename: "IdeaSupporter",
    id: string,
    url?: string | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnUpdateIdeaSupporterSubscriptionVariables = {
  owner?: string | null,
};

export type OnUpdateIdeaSupporterSubscription = {
  onUpdateIdeaSupporter?:  {
    __typename: "IdeaSupporter",
    id: string,
    url?: string | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};

export type OnDeleteIdeaSupporterSubscriptionVariables = {
  owner?: string | null,
};

export type OnDeleteIdeaSupporterSubscription = {
  onDeleteIdeaSupporter?:  {
    __typename: "IdeaSupporter",
    id: string,
    url?: string | null,
    logo?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
    } | null,
    createdAt: string,
    updatedAt: string,
    owner?: string | null,
  } | null,
};
